/* ===== sbdc-gate-js ===== */

/* =====================================================================
   빗장의 곁들이 — 보이고 안 보이고는 위의 미디어쿼리가 이미 정했다.
   여기서는 세 가지만 한다.

     1. 좁아지면 편집기에 inert · aria-hidden 을 건다
        (display:none 만으로도 막히지만, 뜻을 코드에 남겨 둔다)
     2. 좁아지는 순간 편집기 안에 있던 커서를 빼내 안내 제목으로 옮긴다
     3. 바뀐 상태를 스크린리더에 한 줄로 알린다

   리스너는 파일이 읽힐 때 딱 두 개만 단다. 창을 몇 번을 줄였다 늘려도
   더 늘지 않는다. 디자인은 손대지 않는다 — 편집기는 살아 있고 숨겨질 뿐이다.
   ===================================================================== */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 1024px)');
  var desktop = null;            // null = 아직 한 번도 정하지 않음
  var changes = 0;

  var $ = function (id) { return document.getElementById(id); };

  function showWidth() {
    var w = $('sbdc-gate-w');
    if (w) w.textContent = Math.round(window.innerWidth) + 'px';
  }

  function apply() {
    var root = $('root'), gate = $('sbdc-gate'), say = $('sbdc-gate-status');
    if (!root || !gate) return;
    showWidth();

    var now = mq.matches;
    if (now === desktop) return;      // 같은 상태면 아무것도 다시 하지 않는다
    var first = desktop === null;
    desktop = now;
    gate.setAttribute('data-dc-changes', String(++changes));

    if (now) {
      root.removeAttribute('inert');
      root.removeAttribute('aria-hidden');
      gate.setAttribute('aria-hidden', 'true');
      if (say && !first) say.textContent = 'The window is wide enough again to use the editor.';
    } else {
      var on = document.activeElement;
      if (on && on !== document.body && root.contains(on) && on.blur) on.blur();
      root.setAttribute('inert', '');
      root.setAttribute('aria-hidden', 'true');
      gate.removeAttribute('aria-hidden');
      if (say) say.textContent = 'The window is too narrow for the design editor. Please open it on a computer at least 1024px wide.';
      if (!first) {
        var h = $('sbdc-gate-title');
        if (h && h.focus) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      }
    }
  }

  // 1024px 경계를 넘을 때만 부른다 (창 크기 조절 · 화면 회전 둘 다 여기로 온다)
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
  // 경계를 안 넘는 잔잔한 크기 변화는 «지금 폭» 숫자만 고친다
  window.addEventListener('resize', showWidth);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
})();
    

/* ===== sbdc-textinput ===== */

/* =====================================================================
   글자를 치는 자리 — 누르면 바로, 줄은 Shift+Enter

   두 가지가 불편했다.

   1) 왼쪽 패널의 문구 칸에는 «문구를 입력하세요» 가 **글자로 들어 있다**
      (흐린 안내문이 아니라 진짜 값이다). 그래서 고객이 칠 때마다 먼저 그것을
      지워야 했다.
   2) 문구 칸이 한 줄짜리 `input` 이라 줄을 바꿀 수 없었다. `input` 은 값에서
      줄바꿈 문자를 아예 걷어낸다 — Enter 를 아무리 눌러도 두 줄이 되지 않는다.

   여기서 하는 일:
     __dcPickAll   칸에 커서가 들어올 때, 아직 «문구를 입력하세요» 그대로면 통째로 고른다
                   → 그냥 치면 덮어써진다. 손댄 문구는 건드리지 않는다.
     __dcRows      여러 줄 칸의 높이 — 줄 수에 맞춰 늘어난다 (최대 여섯 줄)

   번들에서는 문구 칸을 `input` → `textarea` 로 바꾸고, 두 곳(패널 칸 · 캔버스
   편집칸)에서 **Enter 는 마침, Shift+Enter 는 줄바꿈**으로 통일했다.
   ===================================================================== */
(function () {
  'use strict';

  /** 새 텍스트가 들고 나오는 기본 문구 — 이것만 «아직 안 쓴 것» 으로 본다 */
  var PLACEHOLDER = 'Enter your text';
  var MAX_ROWS = 6;

  /**
   * 칸에 커서가 들어올 때 글자를 통째로 고른다.
   *
   * 고르기만 하고 지우지는 않는다 — 눌렀다가 그냥 나가도 문구가 남아 있어야
   * 빈 글자 상자가 생기지 않는다. 치는 순간 사라지는 것은 마찬가지다.
   */
  window.__dcPickAll = function (el) {
    if (!el) return;
    var untouched = String(el.value).trim() === PLACEHOLDER;
    // 2026-09-08 V0.0.5: 캔버스 편집칸은 열릴 때(autoFocus) 커서가 맨 앞에 남는다 → 맨 뒤로.
    // 패널 문구 칸은 손님이 누른 자리를 지켜야 하므로 건드리지 않는다.
    if (!untouched && !el.classList.contains('inline-edit')) return;
    // React 가 값을 다시 그린 뒤에 골라야 선택이 풀리지 않는다
    setTimeout(function () {
      try { if (untouched) el.select(); else { var n = el.value.length; el.setSelectionRange(n, n); } }
      catch (e) { /* 이미 사라진 칸 */ }
    }, 0);
  };

  /**
   * 다른 데를 누르면 편집을 마친다.
   *
   * 편집칸은 커서가 빠질 때(blur) 확정된다. 그런데 브라우저에 따라 단추를 눌러도
   * 커서가 옮겨 가지 않는다(사파리의 button 이 그렇다). 그러면 편집칸이 열린 채로
   * 남는다. 눌린 자리가 편집칸 바깥이면 여기서 손수 커서를 빼 준다.
   *
   * 누르는 시점(pointerdown)에 처리해야 그 클릭이 목적지에 닿기 전에 확정된다.
   */
  document.addEventListener('pointerdown', function (e) {
    var el = document.querySelector('textarea.inline-edit');
    if (!el || el === e.target || el.contains(e.target)) return;
    el.blur();
  }, true);

  /** 문구 칸의 줄 수 */
  window.__dcRows = function (text) {
    var n = String(text == null ? '' : text).split('\n').length;
    return Math.max(1, Math.min(MAX_ROWS, n));
  };
})();
    

/* ===== sbdc-textfit ===== */

/* =====================================================================
   글자를 상자 안에 앉힌다 — 잘려 나가지 않게

   Konva 텍스트는 상자보다 넘치는 글줄을 **말없이 버린다.** 폭이 모자라면 줄을
   나누고, 나눈 줄이 상자 높이를 넘으면 그 줄부터는 아예 그리지 않는다
   (konva/lib/shapes/Text.js `_setTextData`). 경고도, 표시도 없다.

   그래서 세로 배너(24″×48″)에서 이런 일이 벌어졌다.

     상자 19.2″ × 14.4″ · 글자 10.08″ · 문구 «GRAND OPPENING»
     → 한 줄이 상자보다 넓다 → 줄을 나눈다 → 둘째 줄은 높이를 넘는다
     → 화면에 남는 것은 «GR»

   화면만의 문제가 아니다. 납품 PNG 는 이 캔버스를 그대로 뽑으므로
   («stage.toDataURL») 잘린 채로 인쇄소에 간다. 프리플라이트도 «통과» 라고
   말한다 — 글자가 몇 자 사라졌는지는 아무도 재지 않았기 때문이다.

   ---------------------------------------------------------------------
   여기서 하는 일은 하나다: **글자 크기를 상자에 맞게 줄인다.**

     fitMaxIn   고객이 원한 크기. 글자를 줄여도 이 값은 기억한다.
     fontSizeIn 실제로 그리는 크기 = min(fitMaxIn, 상자에 들어가는 최대치)

   문구를 지워 짧아지면 fitMaxIn 까지 도로 커진다. 그 위로는 절대 커지지 않는다
   — 고객이 정한 크기를 앱이 마음대로 키우면 그것도 놀라운 일이다.

   재는 일은 **Konva 에게 직접 시킨다.** 화면 밖 Konva.Text 하나를 두고 크기를
   바꿔 가며 «몇 글자가 살아남았나» 를 묻는다. 조판 규칙을 베껴 쓰면 언젠가
   본체와 어긋나지만, 본체에게 물으면 어긋날 수가 없다.

   상자를 넘는지 판정하는 두 가지:
     1. 살아남은 글자 = 원래 글자   (높이에 밀려 사라진 줄이 없다)
     2. 라틴 낱말이 중간에서 끊기지 않는다
        Konva 는 자리가 없으면 «GRAN / D OPP» 처럼 낱말 한가운데를 끊는다.
        한글·한자는 어디서 끊어도 되지만 라틴 낱말은 아니다.

   ---------------------------------------------------------------------
   번들에 심은 자리 (앱.html 안, 손으로 고친 곳)

     addLayer     새 텍스트가 들어올 때        → __dcFitNew
     loadTemplate 템플릿을 얹을 때             → __dcFitAll
     updateLayer  문구·상자·글자 크기가 바뀔 때 → __dcFitUpd
     인라인 편집   캔버스에서 두 번 눌러 칠 때   → __dcFitEditPx
     면 썸네일     오른쪽 미리보기 SVG          → __dcWrapLines
   ===================================================================== */
(function () {
  'use strict';

  /** 1인치를 100px 로 놓고 잰다 — 화면 배율(줌)과 무관하게 같은 답이 나온다 */
  var SC = 100;
  /** 이보다 작게는 줄이지 않는다. 더 줄여야 들어간다면 그건 글자가 아니라 상자 문제다 */
  var MIN_IN = 0.12;
  /** 화면 배율에 따라 폭 반올림이 1px 쯤 달라진다 — 그만큼 여유를 두고 맞춘다 */
  var W_SLACK = 0.985;
  var H_SLACK = 0.99;
  /** 이분법 횟수 — 20인치 상자에서 0.0001″ 까지 좁힌다 */
  var STEPS = 18;
  /** 이 각도 이상 휘면 곡선 글줄 — 상자가 자르지 않으므로 손대지 않는다 */
  var CURVE_EPSILON = 0.5;

  /** 한글·한자·가나 — 낱말 가운데서 끊어도 되는 글자들 */
  var BREAKABLE = /[\u1100-\u11FF\u2E80-\u9FFF\uAC00-\uD7AF\uF900-\uFAFF\uFF00-\uFFEF]/;

  /** 상자 조판에 영향을 주는 값들 — 이 중 하나라도 바뀌면 다시 맞춘다 */
  var LAYOUT_KEYS = ['text', 'listStyle', 'fontFamily', 'bold', 'italic', 'lineHeight',
                     'widthIn', 'heightIn', 'stretchX', 'stretchY', 'fontSizeIn', 'curveDeg', 'curveRatio'];

  var has = function (o, k) { return Object.prototype.hasOwnProperty.call(o, k); };
  var strip = function (s) { return s.replace(/\s+/g, ''); };
  var isCurved = function (l) { return Math.abs(l.curveDeg || 0) >= CURVE_EPSILON; };

  /* ---------------------------------------------------------------- */
  /* 앱과 같은 글줄 만들기                                              */
  /* ---------------------------------------------------------------- */

  /** 목록 접두사는 그릴 때만 붙는다 — 재는 쪽도 붙여야 폭이 맞다 (domain/text.ts) */
  function displayText(layer) {
    var raw = String(layer.text == null ? '' : layer.text).split('\n');
    if (layer.listStyle !== 'bullet' && layer.listStyle !== 'number') return raw.join('\n');
    var n = 0;
    return raw.map(function (line) {
      if (!line.trim()) return line;
      n += 1;
      return layer.listStyle === 'bullet' ? '•  ' + line : n + '.  ' + line;
    }).join('\n');
  }

  /** Konva `_getContextFont()` 과 같은 순서로 만든다 — 안 그러면 다른 폭이 나온다 */
  function fontString(layer, px) {
    var style = (layer.italic ? 'italic ' : '') + (layer.bold ? 'bold' : 'normal');
    return style + ' normal ' + px + 'px ' + layer.fontFamily;
  }

  /* ---------------------------------------------------------------- */
  /* 재는 도구 — 앱이 쓰는 것과 같은 Konva                               */
  /* ---------------------------------------------------------------- */

  var probe = null;
  function getProbe() {
    if (probe) return probe;
    if (!window.Konva) return null;
    // 무대에 붙이지 않아도 Konva.Text 는 생성자에서 조판을 끝낸다
    probe = new window.Konva.Text({ text: '', wrap: 'word', ellipsis: false, padding: 0 });
    return probe;
  }

  var mctx = null;
  function textWidth(font, s) {
    if (!mctx) mctx = document.createElement('canvas').getContext('2d');
    mctx.font = font;
    return mctx.measureText(s).width;
  }

  /**
   * 끊어서는 안 되는 가장 긴 조각의 폭.
   *
   * Konva 는 공백과 하이픈 뒤에서 줄을 나누고, 그래도 안 들어가면 낱말 한가운데를
   * 끊는다. 그 «한가운데» 를 막으려면 조각 하나가 상자 폭 안에 들어가야 한다.
   */
  function widestUnbreakable(text, font) {
    var widest = 0;
    text.split(/\s+/).forEach(function (word) {
      if (!word || BREAKABLE.test(word)) return;
      var parts = word.split('-');
      parts.forEach(function (part, i) {
        var chunk = i < parts.length - 1 ? part + '-' : part;
        if (chunk) widest = Math.max(widest, textWidth(font, chunk));
      });
    });
    return widest;
  }

  /** 이 크기로 그리면 글자가 하나도 사라지지 않는가 */
  function fitsAt(layer, sizeIn, box, full) {
    var p = getProbe();
    if (!p) return true;                       // Konva 가 없으면 판정하지 않는다
    var px = sizeIn * SC;
    p.setAttrs({
      text: full,
      width: box.w,
      height: box.h,
      fontSize: px,
      fontFamily: layer.fontFamily,
      fontStyle: (layer.italic ? 'italic ' : '') + (layer.bold ? 'bold' : 'normal'),
      lineHeight: layer.lineHeight || 1.15,
    });
    var arr = p.textArr || [];
    var shown = '';
    for (var i = 0; i < arr.length; i++) shown += arr[i].text;
    if (strip(shown) !== strip(full)) return false;
    return widestUnbreakable(full, fontString(layer, px)) <= box.w;
  }

  /** 상자 안에 글자가 다 들어가는 가장 큰 크기 (인치) */
  function fitSize(layer, maxIn) {
    var sx = layer.stretchX || 1, sy = layer.stretchY || 1;
    // 장평·평체는 노드에 scale 로 걸린다 — 조판은 늘어나기 전 상자에서 이뤄진다
    var box = { w: (layer.widthIn / sx) * SC * W_SLACK, h: (layer.heightIn / sy) * SC * H_SLACK };
    var full = displayText(layer);
    if (!full.trim() || !(box.w > 0) || !(box.h > 0)) return maxIn;
    if (!(maxIn > MIN_IN)) return maxIn;
    if (fitsAt(layer, maxIn, box, full)) return maxIn;

    var lo = 0, hi = maxIn;
    for (var i = 0; i < STEPS; i++) {
      var mid = (lo + hi) / 2;
      if (fitsAt(layer, mid, box, full)) lo = mid; else hi = mid;
    }
    return Math.max(MIN_IN, Math.floor(lo * 1000) / 1000);
  }

  /* ---------------------------------------------------------------- */
  /* 레이어에 적용                                                      */
  /* ---------------------------------------------------------------- */

  function withFit(layer, requestedIn, announce) {
    var max = requestedIn > 0 ? requestedIn : layer.fontSizeIn;
    if (isCurved(layer)) {
      // 곡선 글줄은 상자 밖으로 그려진다 — 잘리지 않으니 크기를 건드릴 이유가 없다.
      // (상자를 넘어서는지는 프리플라이트의 «곡선» 규칙이 따로 본다)
      return layer.fitMaxIn === max ? layer : Object.assign({}, layer, { fitMaxIn: max });
    }
    var size = fitSize(layer, max);
    if (layer.fontSizeIn === size && layer.fitMaxIn === max) return layer;
    var next = Object.assign({}, layer, { fontSizeIn: size, fitMaxIn: max });
    if (announce && size < max * 0.98 && typeof window.__dcOnTextFit === 'function') {
      try { window.__dcOnTextFit(next, max, size); } catch (e) { /* 알림은 실패해도 그만 */ }
    }
    return next;
  }

  /** 새 텍스트가 문서에 들어올 때 — 처음부터 상자에 맞는 크기로 앉힌다 */
  window.__dcFitNew = function (layer) {
    if (layer && layer.s914SourceId) return layer; // 09/14 owns this prepared font size; legacy artwork still uses withFit.
    if (window.__dcFitFresh) { var fresh = window.__dcFitFresh(layer); if (fresh) return fresh; }   // V1.0.2 draft: one line per Enter

    if (!layer || layer.type !== 'text') return layer;
    try {
      return withFit(layer, layer.fitMaxIn > 0 ? layer.fitMaxIn : layer.fontSizeIn, false);
    } catch (e) { return layer; }
  };

  /** 템플릿을 통째로 얹을 때 — 문구마다 상자에 맞는지 본다 */
  window.__dcFitAll = function (layers) {
    if (!Array.isArray(layers)) return layers;
    try { return layers.map(function (l) { return window.__dcFitNew(l); }); }
    catch (e) { return layers; }
  };

  /**
   * 레이어가 바뀔 때.
   *
   * 글자 크기를 직접 준 변경(크기 입력칸·상자 끌기)은 그 값이 새 «원하는 크기» 가
   * 된다. 문구만 바뀐 변경은 원래 원하던 크기를 그대로 목표로 삼는다.
   */
  window.__dcFitBox = function (next, prev, patch) {
    // V1.0.2 draft: a text box is as big as its words. Lines break only where the customer pressed Enter,
    // and the box grows to the right (left-aligned), both ways (centre) or to the left (right-aligned).
    if (!next || next.type !== 'text' || !prev || !patch) return null;   // curved too: its arch is as long as the box is wide
    if (next.s914TextMeasure && next.s914TextMeasure.kind === 'svg') return null;   // flag/popup SVG text: the runtime measures it
    var keys = ['text', 'listStyle', 'fontFamily', 'bold', 'italic', 'lineHeight', 'letterSpacingIn', 'fontSizeIn', 'stretchX', 'stretchY', 'curveDeg'], hit = false;
    for (var i = 0; i < keys.length; i++) if (has(patch, keys[i])) { hit = true; break; }
    var fs = next.fontSizeIn;
    if (!hit || !(fs > 0)) return null;
    var font = fontString(next, fs * SC), ls = (next.letterSpacingIn || 0) * SC, lines = displayText(next).split('\n'), wide = 0;
    lines.forEach(function (s) { wide = Math.max(wide, textWidth(font, s) + ls * Array.from(s).length); });
    // Keep the box's own top/bottom room (the imported boxes carry some), scaled with the type.
    var was = displayText(prev).split('\n').length, pfs = prev.fontSizeIn > 0 ? prev.fontSizeIn : fs;
    var room = Math.max(0, prev.heightIn / (prev.stretchY || 1) - was * pfs * (prev.lineHeight || 1)) * fs / pfs;
    var w = (wide / SC + fs * 0.05) * (next.stretchX || 1), h = (lines.length * fs * (next.lineHeight || 1) + room) * (next.stretchY || 1);
    var out = Object.assign({}, next, { widthIn: w, heightIn: h });
    // A handle drag already placed the box; typing keeps the aligned edge and the top where they were.
    // The box turns about its centre, so a turned box keeps that edge's top point where it was on the page.
    if (!has(patch, 'xIn') && !has(patch, 'yIn')) {
      var e = next.align === 'center' ? 0.5 : next.align === 'right' ? 1 : 0, a = (next.rotation || 0) * Math.PI / 180, cos = Math.cos(a), sin = Math.sin(a);
      var ux = (e - 0.5) * (prev.widthIn - w), uy = (h - prev.heightIn) / 2;
      out.xIn = prev.xIn + (prev.widthIn - w) / 2 + ux * cos - uy * sin; out.yIn = prev.yIn + (prev.heightIn - h) / 2 + ux * sin + uy * cos;
    }
    return out;
  };

  /** New text (Add text, older templates): start at the size that fits its first box as before, keep the lines it
      showed as real line breaks, then let the box follow the words. */
  window.__dcFitFresh = function (layer) {
    if (!layer || layer.type !== 'text' || isCurved(layer)) return null;
    var start = withFit(layer, layer.fitMaxIn > 0 ? layer.fitMaxIn : layer.fontSizeIn, false), text = String(start.text == null ? '' : start.text);
    if (!start.listStyle || start.listStyle === 'none') {
      var shown = window.__dcWrapLines(start);
      if (shown && shown.length > text.split('\n').length && strip(shown.join('')) === strip(text)) text = shown.join('\n');
    }
    var frozen = Object.assign({}, start, { text: text });
    return window.__dcFitBox(frozen, frozen, { text: text }) || frozen;
  };

  window.__dcFitUpd = function (next, patch) {
    var boxed = window.__dcFitBox ? window.__dcFitBox(next, arguments[2], patch) : null;   // V1.0.2 draft: box follows the words, no shrinking
    if (boxed) return boxed;
    if (next && next.s914SourceId) return next; // Runtime remeasures the source without legacy auto-shrinking.

    if (!next || next.type !== 'text' || !patch) return next;
    var touched = false;
    for (var i = 0; i < LAYOUT_KEYS.length; i++) if (has(patch, LAYOUT_KEYS[i])) { touched = true; break; }
    if (!touched) return next;
    var requested = has(patch, 'fontSizeIn') ? patch.fontSizeIn
      : (next.fitMaxIn > 0 ? next.fitMaxIn : next.fontSizeIn);
    try { return withFit(next, requested, has(patch, 'text')); } catch (e) { return next; }
  };

  /**
   * 캔버스 위 인라인 편집칸 — 치는 동안에도 실제로 그려질 크기를 보여 준다.
   *
   * 편집칸은 textarea 라 테두리 2px 만큼 속이 좁다. 그만큼 빼고 재지 않으면
   * 캔버스는 «OPPENING» 을 한 줄로 두는데 편집칸만 «OPPENIN / G» 로 끊는다.
   */
  window.__dcFitEditPx = function (layer, value, scale) {
    if (layer && window.__dcFitBox) return layer.fontSizeIn * scale;   // V1.0.2 draft: typing never shrinks the text
    if (layer && layer.s914SourceId) return layer.fontSizeIn * scale;

    var base = layer.fontSizeIn * scale;
    try {
      if (!layer || layer.type !== 'text' || isCurved(layer)) return base;
      var max = layer.fitMaxIn > 0 ? layer.fitMaxIn : layer.fontSizeIn;
      var inset = 4 / (scale || 1);                     // .inline-edit 테두리 2px × 양쪽
      var probeLayer = Object.assign({}, layer, {
        text: value == null ? layer.text : value,
        widthIn: Math.max(0.1, layer.widthIn - inset),
        heightIn: Math.max(0.1, layer.heightIn - inset),
      });
      return fitSize(probeLayer, max) * scale;
    } catch (e) { return base; }
  };

  /**
   * 면 썸네일(SVG)이 그릴 줄들.
   *
   * 썸네일은 자동 줄바꿈을 하지 않아 캔버스가 두 줄로 나눈 문구를 한 줄로 그렸다.
   * 캔버스와 같은 Konva 에게 물어 같은 줄을 받는다.
   */
  window.__dcWrapLines = function (layer) {
    try {
      if (!layer || layer.type !== 'text' || isCurved(layer)) return null;
      var full = displayText(layer);
      if (!full) return null;
      var p = getProbe();
      if (!p) return null;
      var sx = layer.stretchX || 1, sy = layer.stretchY || 1;
      p.setAttrs({
        text: full,
        width: (layer.widthIn / sx) * SC,
        height: (layer.heightIn / sy) * SC,
        fontSize: layer.fontSizeIn * SC,
        fontFamily: layer.fontFamily,
        fontStyle: (layer.italic ? 'italic ' : '') + (layer.bold ? 'bold' : 'normal'),
        lineHeight: layer.lineHeight || 1.15,
      });
      var arr = p.textArr || [];
      if (!arr.length) return null;
      return arr.map(function (l) { return l.text; });
    } catch (e) { return null; }
  };

  /* ---------------------------------------------------------------- */
  /* 그래도 잘렸다면 — 프리플라이트가 막는다                              */
  /* ---------------------------------------------------------------- */

  /**
   * 인쇄 직전 검사에 «이 문구는 다 안 나옵니다» 항목을 더한다.
   *
   * 위의 맞춤이 있는 한 여기 걸릴 일은 거의 없다. 그물은 남는 구멍을 위한 것이다.
   *   · 글이 너무 길어 최소 크기(0.12″)까지 줄여도 안 들어가는 경우
   *   · 맞춤을 건너뛰는 글줄(곡선은 상자가 자르지 않으니 여기서도 뺀다)
   *   · 앞으로 누가 훅 부르는 자리를 지워 맞춤이 조용히 죽는 경우
   *
   * 판정은 그리는 쪽과 **같은 Konva** 에게 묻는다(__dcWrapLines) — 화면에 남은
   * 글자와 레이어의 글자를 견줘 한 자라도 사라졌으면 잘린 것이다.
   *
   * 등급은 «막음» 이다. 글자가 빠진 인쇄물은 다시 찍어야 하고, 그 값은
   * 경고를 한 번 더 보는 불편보다 훨씬 크다.
   */
  window.__dcClipIssues = function (layers, issues) {
    try {
      if (!Array.isArray(layers) || !Array.isArray(issues)) return;
      layers.forEach(function (l) {
        if (!l || l.type !== 'text' || isCurved(l)) return;
        var full = displayText(l);
        if (!full.trim()) return;
        var shown = window.__dcWrapLines(l);
        if (!shown) return;
        var drawn = strip(shown.join(''));
        var whole = strip(full);
        if (drawn === whole) return;
        issues.push({
          id: 'clipped-' + l.id,
          severity: 'block',
          title: '“' + (l.name || 'Text') + '” overflows its box and gets cut off',
          detail: '«' + cut(lost(full, drawn.length)) + '» onward will not print — '
            + whole.length + ' of ' + drawn.length + ' only.',
          fix: 'Make the text box bigger or shorten the text.',
          layerId: l.id,
        });
      });
    } catch (e) { /* 검사가 앱을 멈추게 하지는 않는다 */ }
  };

  /** 어디서부터 안 나오는지 — 살아남은 글자 수만큼 세고 남은 부분을 돌려준다 */
  function lost(full, drawnCount) {
    var seen = 0, i = 0;
    for (; i < full.length && seen < drawnCount; i++) if (!/\s/.test(full[i])) seen += 1;
    return full.slice(i);
  }

  /** 안내문에 넣을 만큼만 자른다 */
  function cut(text) {
    var one = String(text).replace(/\s+/g, ' ').trim();
    return one.length > 24 ? one.slice(0, 24) + '…' : one;
  }

  /* ---------------------------------------------------------------- */
  /* 줄어들었다고 한 번은 알려 준다                                      */
  /* ---------------------------------------------------------------- */

  var toldAt = 0;
  window.__dcOnTextFit = function (layer, requestedIn, appliedIn) {
    var now = Date.now();
    if (now - toldAt < 12000) return;          // 한 글자마다 떠들지 않는다
    toldAt = now;
    if (typeof window.__dcToast === 'function') {
      window.__dcToast('Text was fitted to the box ' + appliedIn.toFixed(1) + '″ — make the box bigger for larger text');
    }
  };
})();
    

/* ===== sbdc-aug ===== */

/* =====================================================================
   StickersBanners Design Center — augmentation layer
   1) 시작 팝업: 상품(카테고리별) + 크기 + 수량 + 마감 옵션
   2) 포토샵식 단축키 (Ctrl+C / V / X / D / Z / Y, 방향키 이동 등)
   3) 이미지 드래그 앤 드롭 업로드
   4) ft 상품 / inch 상품 각각의 사이즈 규칙
   5) 왼쪽 레일 "텍스트" 클릭 시 아트보드에 바로 텍스트 추가
   ===================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     [수정 지점] 상품 카탈로그 — 카테고리 / 상품 / 가격
     handle        : Shopify 상품 핸들
     unit          : 'ft'(피트 단위 인쇄물) | 'in'(인치 규격 상품)
     rate          : sq.ft 당 단가 (ft 상품)
     rateBySize    : 'WxH'(피트) → sq.ft 단가 (규격형 ft 상품)
     specials      : 'WxH'(피트) → 고정 특가
     ftSize        : 이 상품이 «실제로 파는» 피트 규격 { minSide, maxSide, maxShort }
                     — 2026-08-26 스토어 전 변형에서 뽑았고, 판매 목록을 오차 없이 재현함
     optNames      : 스토어 옵션 이름 { w, h } — 숫자를 긁지 않고 이 이름으로 정확히 집는다
     hidden        : «디자인센터에서만» 감춘다. 스토어에서는 그대로 팔린다.
                     지우지 않고 감추는 이유 — 되살릴 때 가격·프리셋·옵션 이름을 다시
                     만들지 않아도 되고, 「감춘 것이 목록에 없다」를 시험으로 지킬 수 있다.
     priceBySizeIn : 'WxH'(인치) → 개당 고정가 (inch 상품)
     piecePrice    : 장당 단가 (스티커류 — 사이즈 무관 정액)
     noFinishing   : 마감 옵션 없는 상품
     materials     : 재질 선택 (A19) — 같은 크기에 재질만 다른 변형이 둘 있는 상품
     viewFt        : 프리플라이트 기준 시청 거리(ft)
  ------------------------------------------------------------------ */

  /* ------------------------------------------------------------------ 재질 (A19)
     스토어에 «같은 크기 · 다른 재질» 변형이 둘씩 있는데 손님에게 묻는 칸이 없었다.
     앱이 PREFER 라는 내부 표로 늘 Regular 를 골라, 리무버블을 원한 손님도
     일반을 받았다. 2026-08-27 스토어 실측 — 두 재질의 가격이 419쌍 전부 같고,
     한쪽만 있는 규격도 품절도 없다. 그래서 가격 계산은 손대지 않는다.

       opt  : 스토어 옵션 이름. 뒤에 붙은 ':' 는 무시하고 맞춘다
              (키스컷만 'Material Type:' 로 콜론이 붙어 있다)
       val  : 스토어 옵션 값 — 이 값과 «정확히» 같은 변형을 담는다
       word : 스토어가 이름을 바꿨을 때 쓰는 예비 낱말 (val 로 못 찾을 때만)
     ------------------------------------------------------------------ */
  var MAT_ORACAL = { opt: 'Material Type', list: [
    { id: 'regular',   ko: 'Regular vinyl',    en: 'Oracal 4 mil Regular Vinyl',
      note: 'For long-term use · standard',      val: 'Oracal 4 mil Regular Vinyl',   word: 'regular' },
    { id: 'removable', ko: 'Removable vinyl', en: 'Oracal 4 mil Removable Vinyl',
      note: 'Peels off cleanly · temporary use', val: 'Oracal 4 mil Removable Vinyl', word: 'removable' }
  ] };
  var MAT_DECAL = { opt: 'Option', list: [
    { id: 'regular',   ko: 'Regular vinyl (matte)', en: 'Regular Vinyl (Matte)',
      note: 'For long-term use · standard',      val: 'Regular Vinyl (Matte)', word: 'regular' },
    { id: 'removable', ko: 'Removable vinyl',    en: 'Removable Vinyl',
      note: 'Peels off cleanly · temporary use', val: 'Removable Vinyl',      word: 'removable' }
  ] };

  var CATALOG = [
    {
      cat: 'Banners',
      items: [
        { handle: 'custom-vinyl-banners', name: 'Custom Vinyl Banners', nameKo: 'Custom Vinyl Banner',
          material: '14oz heavy-duty matte vinyl', materialEn: '14oz Heavy Duty Matte Vinyl',
          unit: 'ft', rate: 1.99, min: 2, w: 8, h: 4, presets: ['2x4', '3x6', '4x8', '8x4', '8x8'],
          specials: { '8x8': 98, '10x8': 128, '8x10': 128 },
          ftSize: { minSide: 2, maxSide: 50, maxShort: 8 },          // 실제 637규격
          optNames: { w: 'WIDTH', h: 'HEIGHT' } },
        { handle: 'mesh-banners', name: 'Mesh Banners', nameKo: 'Mesh Banner',
          material: 'Mesh vinyl — lets wind through', materialEn: 'Mesh Vinyl',
          unit: 'ft', rate: 2.75, min: 2, w: 8, h: 4, presets: ['2x4', '4x8', '8x4', '10x5'],
          ftSize: { minSide: 2, maxSide: 50, maxShort: 8 },          // 실제 637규격 · 특가 없음
          optNames: { w: 'Width (Feet)', h: 'Height (Feet)' } },
        { handle: 'fabric-banners', name: 'Fabric Banners', nameKo: 'Fabric Banner',
          material: '270gsm (8oz) wrinkle-resistant tension fabric', materialEn: '270gsm Tension Fabric',
          unit: 'ft', rate: 2.99, min: 4, w: 8, h: 4, presets: ['4x4', '4x8', '8x4', '8x8'],
          // 스토어 실측(2026-08-26): 445개 변형 중 이 3개만 요율식과 다르다 (DC-113)
          specials: { '8x8': 160, '10x8': 200, '8x10': 200 },
          ftSize: { minSide: 4, maxSide: 50, maxShort: 8 },          // 실제 445규격
          optNames: { w: 'Width (Feet)', h: 'Height (Feet)' } },
        { handle: 'window-decals', name: 'Adhesive Banners / Window Decals', nameKo: 'Adhesive Banner · Window Decal',
          material: 'Adhesive vinyl (matte / removable)', materialEn: 'Adhesive Vinyl',
          unit: 'ft', rate: 2.75, min: 2, w: 4, h: 4, presets: ['2x2', '2x4', '4x4', '4x8'],
          // 이 상품만 짧은 변이 «4ft» 까지다 (다른 배너는 8ft). 앱은 8ft 까지 열어 두고 있었다.
          ftSize: { minSide: 2, maxSide: 50, maxShort: 4 },          // 실제 285규격 · 특가 없음
          optNames: { w: 'Width (Feet)', h: 'Height (Feet)' }, materials: MAT_DECAL }
      ]
    },
    {
      cat: 'Step & Repeat · Backdrop',
      items: [
        { handle: 'custom-step-and-repeat-banner', name: 'Custom Step and Repeat Banner', nameKo: 'Vinyl Custom Step and Repeat',
          material: 'Vinyl · any size (min 4ft)', materialEn: 'Vinyl',
          unit: 'ft', rate: 1.99, min: 4, w: 8, h: 8, presets: ['4x8', '8x8', '10x8', '12x8'],
          specials: { '8x8': 98, '10x8': 128, '8x10': 128 },                   // 스토어 실측 (DC-113)
          ftSize: { minSide: 4, maxSide: 50, maxShort: 8 },          // 실제 445규격
          optNames: { w: 'WIDTH', h: 'HEIGHT' } },
        { handle: 'fabric-step-repeat-banners', name: 'Fabric Step & Repeat Banners', nameKo: 'Fabric Step and Repeat',
          material: '270gsm fabric · any size (min 4ft)', materialEn: '270gsm Tension Fabric',
          unit: 'ft', rate: 2.99, min: 4, w: 8, h: 8, presets: ['4x8', '8x8', '10x8', '12x8'],
          specials: { '8x8': 160, '10x8': 200, '8x10': 200 },                  // 스토어 실측 (DC-113)
          ftSize: { minSide: 4, maxSide: 50, maxShort: 8 },          // 실제 445규격
          optNames: { w: 'Width (Feet)', h: 'Height (Feet)' } },
        { handle: 'vinyl-step-and-repeat-banner', name: 'Vinyl Step and Repeat Banner', nameKo: 'Vinyl Custom Step and Repeat',
          material: 'Vinyl · fixed 8ft height', materialEn: 'Vinyl',
          unit: 'ft', rate: 2, min: 8, w: 8, h: 8, fixedOnly: true, presets: ['8x8', '10x8', '12x8', '16x8', '20x8', '30x8'],
          rateBySize: { '8x8': 1.53125, '10x8': 1.6, '12x8': 2, '16x8': 2, '20x8': 2, '30x8': 2 },
          optNames: { w: 'Width (Feet)', h: 'Height (Feet)' } },
        { handle: 'fabric-step-and-repeat-banner', name: 'Fabric Step and Repeat Banner', nameKo: 'Fabric Step and Repeat',
          material: '270gsm fabric · fixed 8ft height', materialEn: '270gsm Tension Fabric',
          unit: 'ft', rate: 3, min: 8, w: 8, h: 8, fixedOnly: true, presets: ['8x8', '10x8', '12x8', '16x8', '20x8', '30x8'],
          rateBySize: { '8x8': 2.5, '10x8': 2.5, '12x8': 3, '16x8': 3, '20x8': 3, '30x8': 2.99 },
          // 이 상품만 옵션 이름이 «Banner Size (WxH) Feet / (Height) Feet» 로 특이하다
          optNames: { w: 'Banner Size (WxH) Feet', h: '(Height) Feet' } },
        { handle: '10x8-fabric-pop-up-display-backdrop-banner-only', name: "10'x8' Fabric Pop Up Display Backdrop (Banner Only)",
          nameKo: "10'x8' Pop-Up Display Backdrop (Banner Only)", material: '270gsm fabric · prints at 145″ or 141″ x 91″ · frame sold separately', materialEn: '270gsm Tension Fabric',
          // 스토어 실측(2026-08-25): 변형이 피트 10x8 이 아니라 «인치» 145x91 / 141x91, 각 $320.
          // (145x88 / 141x88 도 있으나 품절 상태) 예전 ft 10x8 설정으로는 변형 매칭이 아예 안 됐다.
          // maxIn 이 없으면 clampSize 의 기본 상한 120″ 에 걸려 145→120 으로 잘린다.
          // 잘린 규격은 priceBySizeIn 에 없어 단가 0(=$0.00)이 되고 고정규격 검사에서도 막혔다 (DC-101).
          unit: 'in', w: 145, h: 91, fixedOnly: true, viewFt: 10, qty: 1, minIn: 91, maxIn: 150,
          presetsIn: ['145x91', '141x91'], priceBySizeIn: { '145x91': 320, '141x91': 320 },
          optNames: { w: '(Width) Inches', h: '(Height) Inches' } }
      ]
    },
    {
      cat: 'Retractable · X-Banner (inch)',
      items: [
        { handle: 'pop-up-retractable-banner', name: 'Pop up Retractable Banner (Banner Only)', nameKo: 'Pop-Up Retractable Banner (Banner Only)',
          material: '31.5" x 80" · stand sold separately', materialEn: 'Retractable banner graphic',
          unit: 'in', w: 31.5, h: 80, fixedOnly: true, noFinishing: true, viewFt: 6, qty: 1, pick: ['banner only'],
          presetsIn: ['31.5x80'], priceBySizeIn: { '31.5x80': 50 },
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' } },
        { handle: 'pop-up-retractable-banner', key: 'retract-stand', name: 'Pop up Retractable Banner (Banner + Stand)',
          nameKo: 'Pop-Up Retractable Banner + Stand', material: '31.5" x 80" · stand included', materialEn: 'Retractable banner + stand',
          unit: 'in', w: 31.5, h: 80, fixedOnly: true, noFinishing: true, viewFt: 6, qty: 1, pick: ['banner + stand'],
          presetsIn: ['31.5x80'], priceBySizeIn: { '31.5x80': 120 },
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' } },
        { handle: 'x-banner', name: 'X-Banner (Banner Only)', nameKo: 'X-Banner (Banner Only)',
          material: '30" x 69" · single sided · stand sold separately', materialEn: 'X-banner graphic',
          unit: 'in', w: 30, h: 69, fixedOnly: true, noFinishing: true, viewFt: 6, qty: 1,
          pick: ['banner only'], presetsIn: ['30x69'], priceBySizeIn: { '30x69': 35 },
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' } },
        { handle: 'x-banner', key: 'xb-stand', name: 'X-Banner (Banner + Stand)', nameKo: 'X-Banner + Stand',
          material: '30" x 69" · single sided · stand included', materialEn: 'X-banner + stand',
          unit: 'in', w: 30, h: 69, fixedOnly: true, noFinishing: true, viewFt: 6, qty: 1,
          pick: ['banner + stand'], presetsIn: ['30x69'], priceBySizeIn: { '30x69': 80 },
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' } },
        { handle: 'double-sided-x-banner', name: 'Double Sided X-Banner (Banner Only)', nameKo: 'Double-Sided X-Banner (Banner Only)',
          material: '30" x 69" · double sided · stand sold separately', materialEn: 'Double sided X-banner graphic',
          unit: 'in', w: 30, h: 69, fixedOnly: true, noFinishing: true, doubleSided: true, viewFt: 6, qty: 1,
          pick: ['banner only'], presetsIn: ['30x69'], priceBySizeIn: { '30x69': 70 },
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' },
          // 사장님 결정(2026-08-26): 양면 인쇄가 필요한 상품은 디자인센터에서 뺀다.
          // 스토어에서는 계속 팔린다 — 손님은 완성 파일을 올려 주문한다.
          hidden: true },
        { handle: 'double-sided-x-banner', key: 'dxb-stand', name: 'Double Sided X-Banner (Banner + Stand)',
          nameKo: 'Double-Sided X-Banner + Stand', material: '30" x 69" · double sided · stand included', materialEn: 'Double sided X-banner + stand',
          unit: 'in', w: 30, h: 69, fixedOnly: true, noFinishing: true, doubleSided: true, viewFt: 6, qty: 1,
          pick: ['banner + stand'], presetsIn: ['30x69'], priceBySizeIn: { '30x69': 120 },
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' },
          hidden: true }                                            // 위와 같은 이유
      ]
    },
    {
      cat: 'Stickers (inch)',
      items: [
        { handle: 'bumper-stickers', name: 'Bumper Stickers', nameKo: 'Bumper sticker',
          material: 'Oracal 4mil vinyl (regular/removable) · 2"–12"', materialEn: 'Oracal 4 mil Vinyl',
          unit: 'in', w: 11, h: 3, minIn: 2, maxIn: 12, stepIn: 1, noFinishing: true, viewFt: 1,
          qty: 25, minQty: 25, presetsIn: ['4x2', '8x2', '5x3', '8x3', '10x3', '11x3', '12x3', '4x4', '6x4', '8x4', '10x4', '12x4'],
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' }, materials: MAT_ORACAL },
        { handle: 'kiss-cut-stickers', name: 'Custom Shape Kiss-Cut Stickers', nameKo: 'Custom shape kiss-cut sticker',
          material: 'Oracal 4mil vinyl · shape cut · 2"–12"', materialEn: 'Oracal 4 mil Vinyl',
          unit: 'in', w: 5, h: 3, minIn: 2, maxIn: 12, stepIn: 1, noFinishing: true, viewFt: 1,
          qty: 25, minQty: 25, presetsIn: ['4x2', '5x3', '8x3', '10x3', '8x4'],
          optNames: { w: 'Width (Inches)', h: 'Height (Inches)' }, materials: MAT_ORACAL,
          // 사장님 결정(2026-08-26): 두 가지 이유로 디자인센터에서 뺀다.
          //  · 모양대로 자를 «재단 경로» 를 디자인센터가 만들어 줄 수 없다
          //    (화면의 둥근 사각형은 자리를 보여 주는 예시일 뿐이다)
          //  · 손님이 원하는 그림이 제각각이라 디자인센터의 편집 방식과 맞지 않는다
          // 되살리는 조건: 고객 재단 경로를 받는 방법이 생겼을 때.
          hidden: true },
        { handle: 'round-stickers', name: 'Round Stickers', nameKo: 'Round sticker',
          material: 'Oracal 4mil vinyl · 2"–5" diameter', materialEn: 'Oracal 4 mil Vinyl',
          unit: 'in', w: 3, h: 3, fixedOnly: true, noFinishing: true, viewFt: 1,
          qty: 25, minQty: 25, fixedOnly: true, presetsIn: ['2x2', '3x3', '4x4', '5x5'], materials: MAT_ORACAL },
        { handle: 'oval-stickers', name: 'Oval Stickers', nameKo: 'Oval sticker',
          material: 'Oracal 4mil vinyl · 3"x2" to 8"x4" (landscape)', materialEn: 'Oracal 4 mil Vinyl',
          unit: 'in', w: 5, h: 3, fixedOnly: true, noFinishing: true, viewFt: 1,
          qty: 25, minQty: 25, fixedOnly: true, presetsIn: ['3x2', '4x2', '5x2', '4x3', '5x3', '6x3', '6x4', '7x4', '8x4'],
          materials: MAT_ORACAL }
      ]
    }
  ];

  var FINISHING = [
    { id: 'hem-grommets', ko: 'Hem + Grommets', en: 'Hem & Grommets', note: 'Standard · hem folded on all sides + grommets (sides 4ft and over: evenly spaced 30" or less; under 4ft: corners only)' },
    { id: 'hem-only', ko: 'Hem only', en: 'Hem Only', note: '1" hem sewn on all sides · no holes' },
    { id: 'grommets-only', ko: 'Grommets Only', en: 'No Hem / Grommets Only', note: 'Grommets right after cutting (sides 4ft and over: evenly spaced 30" or less; under 4ft: corners only)' },
    { id: 'none', ko: 'No hem, no grommets', en: 'No Hem & No Grommets', note: 'Cut only — no hanging hardware' },
    { id: 'pockets-both', ko: 'Pole Pockets (Top and Bottom)', en: 'Pole Pockets (Top and Bottom)', note: '4.5" at the top and bottom folds into a pocket' },
    { id: 'pockets-top', ko: 'Pole Pockets (Top Only)', en: 'Pole Pockets (Top Only)', note: 'The top 4.5" folds into a pocket' }
  ];

  window.__CAT = CATALOG; window.__setProduct = function (p) { state.product = p; };   // 테스트 훅
  var TIERS = [[2, 4, .02], [5, 9, .05], [10, 49, .1], [50, 99, .15], [100, 299, .2], [300, null, .3]];
  var MIN_FT = 2, MAX_FT = 50, ROLL_FT = 8;

  /* ────────────────────────────────────────────────────────────────
     두 벌을 따로 든다.

       state    팝업에서 «고르는 중» 인 초안 — 카드를 누르는 순간 바뀐다
       applied  메인 편집기에 «실제로 적용된» 것 — 「디자인 시작」 을 눌러야 바뀐다

     예전에는 한 벌뿐이었다. 그래서 상품을 골랐다가 X 로 닫아도 초안이 남아,
     메인의 단가·규격 칩·마감이 취소한 상품 것으로 보였다.
     메인 화면이 읽는 곳은 전부 applied 다.
     ──────────────────────────────────────────────────────────────── */
  var state   = { cat: 0, product: CATALOG[0].items[0], w: 8, h: 4, qty: 1, fin: 'hem-grommets', mat: null };
  var applied = { cat: 0, p:       CATALOG[0].items[0], w: 8, h: 4, qty: 1, fin: 'hem-grommets', mat: null };
  /* 「담고 다른 상품 디자인」 이 «첫 방문» 으로 되돌릴 때 쓸 처음 값 한 벌 (A24 · DC-127).
     위 줄을 고치면 여기도 저절로 따라오도록 값을 베껴 둔다. */
  var FIRST = { cat: applied.cat, p: applied.p, w: applied.w, h: applied.h,
                qty: applied.qty, fin: applied.fin, mat: applied.mat };

  /* ── 재질 (A19) ──────────────────────────────────────────────────
     matsOf(p)  : 이 상품이 재질을 고르게 하는가 → 목록 or null
     matDef(p)  : 기본 재질 id (목록 첫 항목 = 일반)
     matOk(p,id): 그 상품에 있는 재질 id 인가
     시작 팝업(state.mat)과 왼쪽 「재질」 패널(spec.material)이 같은 id 를 쓴다. */
  function matsOf(p) { return (p && p.materials && p.materials.list && p.materials.list.length) ? p.materials : null; }
  function matDef(p) { var M = matsOf(p); return M ? M.list[0].id : null; }
  function matOk(p, id) {
    var M = matsOf(p);
    return !!(M && id && M.list.some(function (m) { return m.id === id; }));
  }
  function matEntry(p, id) {
    var M = matsOf(p);
    if (!M) return null;
    for (var i = 0; i < M.list.length; i++) if (M.list[i].id === id) return M.list[i];
    return M.list[0];
  }
  window.__dcMaterialsFor = matsOf;                       // 다른 패치 층(sbdc-material·sbdc-cart)이 읽는다
  window.__dcMaterialEntry = function (p, id) { return matEntry(p, id); };
  window.__dcMaterialDefault = matDef;

  /* ── 마감 기본값 (A3) ────────────────────────────────────────────
     finDef(p) : 그 상품의 «기본 마감» id — 허용 목록(sbdc-finmap)의 첫 항목.
                 마감이 아예 없는 상품(스티커·리트랙터블)은 'none'.

     재질의 matDef 와 같은 짝이다. 재질에는 이 짝이 있었는데 마감에는 없어서,
     스티커를 거쳐 배너로 돌아오면 마감이 「헴·그로밋 없음」 인 채로 남았다.
     «없음» 은 배너에도 있는 정상 선택지라 «허용 목록에 있나» 검사로는 안 걸린다.

     ⚠ 허용 목록은 __dcPopupHandle(= state.product)을 기준으로 나온다.
        부르기 전에 state.product 를 먼저 갈아 끼워야 한다. */
  function finDef(p) {
    if (p && p.noFinishing) return 'none';
    var L = (typeof window !== 'undefined' && window.__dcFinishingFilterKo)
      ? window.__dcFinishingFilterKo(FINISHING) : FINISHING;
    return L.length ? L[0].id : 'none';
  }
  var everApplied = false;                 // 「디자인 시작」 을 한 번이라도 눌렀나
  function AP() { return applied.p; }      // 메인이 보는 상품
  window.__dcAppliedProduct = AP;          // 프루프·애드온·파일명이 이걸 본다

  // 팝업 자신이 그릴 때만 쓰는 «초안» 상품
  window.__dcPopupHandle = function () { return state.product ? state.product.handle : null; };
  var clipboard = null;
  var els = {};
  function pkey(p) { return p.key || p.handle; }

  /* ---------------------------------------------------------------- 가격 */
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  var lastW = 8, lastH = 4, lastQ = 1;   // 앱이 마지막으로 계산한 크기(피트)/수량 — 가격 훅이 참조
  function baseRate(p, w, h) {
    var m = p.rateBySize;
    if (m) { if (m[w + 'x' + h] != null) return m[w + 'x' + h]; if (m[h + 'x' + w] != null) return m[h + 'x' + w]; }
    return p.rate || 0;
  }
  // w,h 는 항상 "피트" 단위 (앱 내부 기준)
  function unitPriceFor(p, w, h) {
    if (!p || !(w > 0) || !(h > 0)) return 0;
    if (p.unit === 'in') {
      var wi = Math.round(w * 120) / 10, hi = Math.round(h * 120) / 10;
      if (stkTable(p)) return stkListEa(p, wi, hi);          // 25장 기준 장당 정가
      if (p.priceBySizeIn) {
        if (p.priceBySizeIn[wi + 'x' + hi] != null) return p.priceBySizeIn[wi + 'x' + hi];
        if (p.priceBySizeIn[hi + 'x' + wi] != null) return p.priceBySizeIn[hi + 'x' + wi];
      }
      if (p.piecePrice != null) return p.piecePrice;
      return 0;
    }
    var base = w * h * baseRate(p, w, h);
    var sp = p.specials && (p.specials[w + 'x' + h] != null ? p.specials[w + 'x' + h] : p.specials[h + 'x' + w]);
    return (sp != null && sp < base) ? sp : base;
  }
  // 이 규격이 «요율식보다 싼 고정 특가» 인가 (프리셋 칩의 특가 딱지에 쓴다)
  function isSpecialSize(p, w, h) {
    if (!p || p.unit === 'in' || !(w > 0) || !(h > 0)) return false;
    var base = w * h * (p.rate || 0);
    if (!(base > 0)) return false;
    return unitPriceFor(p, w, h) <= base * 0.99;      // 1% 이상 쌀 때만 (반올림 잡음 제외)
  }
  window.__dcIsSpecialSize = isSpecialSize;           // 시험용 훅
  /* 가격 대조기(sbdc-cart)가 «앱이 실제로 띄우는 값» 을 그대로 쓰게 하는 훅 (DC-105).
     스티커는 앱이 «수량표», 스토어가 «장당 정액» 이라 체계 자체가 달라 여기서 제외한다 —
     그건 DC-112 로 따로 다루며, 사장님 확인 전에는 대조하지 않는다. */
  window.__dcUnitPriceFor = function (p, wFt, hFt) {
    if (!p || stkTable(p)) return null;
    return unitPriceFor(p, wFt, hFt);
  };
  function rateFor(p, w, h) {
    if (!p) return 1.99;
    var a = w * h;
    if (p.unit === 'in') return a > 0 ? unitPriceFor(p, w, h) / a : 0;
    // ft 상품도 unitPriceFor 를 거쳐야 specials(고정 특가)가 «편집기 합계» 에까지 실린다.
    // 예전에는 baseRate 만 돌려줘서 8x8 비닐이 팝업엔 $98, 상단엔 $127.36 로 갈렸다 (DC-114).
    return a > 0 ? unitPriceFor(p, w, h) / a : baseRate(p, w, h);
  }
  // 앱의 가격 계산이 사이즈마다 호출한다 — 규격 패널에서 크기를 바꿔도 요율이 따라감
  window.__dcRate = function (w, h, q) {
    lastW = w; lastH = h;
    if (q) lastQ = q;
    var p = AP();
    if (!p) return 0;
    if (stkTable(p) && q > 0) {                       // 스티커: 그 수량의 실제 장당가
      var a = w * h;
      return a > 0 ? floor2(stkTotal(p, inW(), inH(), q) / q) / a : 0;
    }
    return rateFor(p, w, h);
  };
  // 규격 패널이 인치 모드로 그려질 때 쓰는 설정 / 가격 문구
  window.__dcInchCfg = function () {
    var p = AP() || {};
    return {
      min: p.minIn || 1, max: p.maxIn || 120, step: p.stepIn || 0.5,
      fixed: !!p.fixedOnly, minQty: p.minQty || 1,
      presets: (p.presetsIn || []).map(function (s) { var d = s.split('x'); return [+d[0], +d[1]]; })
    };
  };
  window.__dcHeadPrice = function () {
    var p = AP();
    if (!p || p.unit !== 'in') return null;
    var wIn = Math.round(lastW * 120) / 10, hIn = Math.round(lastH * 120) / 10;
    if (stkTable(p)) return money(stkListEa(p, wIn, hIn)) + '/pc (at 25 pcs)';
    return money(unitPriceFor(p, wIn / 12, hIn / 12)) + ' / each (fixed size)';
  };
  window.__dcPriceLabel = function (w, h) {
    var p = AP();
    if (!p || p.unit !== 'in') return null;
    var wi = Math.round(w * 120) / 10, hi = Math.round(h * 120) / 10;
    if (stkTable(p)) return wi + '" x ' + hi + '" · ' + lastQ.toLocaleString() + ' pc unit price';
    return wi + '" x ' + hi + '" list price';
  };
  function tierOf(q) {
    for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i][0] && (TIERS[i][1] === null || q <= TIERS[i][1])) return TIERS[i][2];
    return 0;
  }


  /* ================================================================
     스티커 전용 수량 가격표 (스토어 Price Table 그대로)
     값 = 해당 수량의 "총액". 사이즈 키는 인치(WxH), 원형은 지름.
     ================================================================ */
  var STK_Q = [25, 50, 100, 250, 500, 1000, 2000, 5000, 10000];
  var STK_TABLES = {
    'bumper-stickers': {
      '2x4':  [24.25, 26.5, 42, 80, 130, 210, 360, 750, 1300],
      '2x8':  [28.5, 42, 65, 117.5, 200, 340, 580, 1250, 2300],
      '3x5':  [26.5, 41, 62, 107.5, 185, 320, 560, 1200, 2200],
      '3x8':  [33, 53, 81, 152.5, 250, 410, 700, 1500, 2800],
      '3x10': [34, 55, 86, 167.5, 280, 470, 840, 1850, 3400],
      '3x11': [36.25, 59.5, 92, 180, 300, 510, 920, 2050, 3800],
      '3x12': [39.5, 66.5, 105, 192.5, 320, 540, 980, 2200, 4100],
      '4x4':  [28.5, 42, 65, 117.5, 200, 340, 580, 1250, 2300],
      '4x6':  [33, 53, 81, 152.5, 250, 410, 700, 1500, 2800],
      '4x8':  [34, 55, 86, 167.5, 280, 470, 840, 1850, 3400],
      '4x10': [41.75, 72.5, 110, 192.5, 320, 540, 980, 2200, 4100],
      '4x12': [45.25, 73.5, 111, 192.5, 320, 540, 980, 2200, 4100]
    },
    'kiss-cut-stickers': {
      '2x4':  [46.25, 80, 103, 145, 230, 370, 640, 1400, 2600],
      '3x5':  [66, 119.5, 144, 185, 270, 420, 740, 1600, 2900],
      '3x8':  [85.75, 159.5, 184, 222.5, 310, 470, 800, 1650, 2900],
      '3x10': [92.5, 172, 197, 237.5, 320, 520, 860, 1700, 2900],
      '4x8':  [99, 185, 210, 250, 335, 520, 940, 2100, 4000]
    },
    'round-stickers': {
      '2x2': [26.5, 46, 66, 115, 200, 350, 620, 1350, 2500],
      '3x3': [36.25, 59.5, 79, 137.5, 230, 390, 680, 1450, 2600],
      '4x4': [52.75, 72.5, 99, 155, 255, 420, 740, 1600, 2900],
      '5x5': [62.75, 92.5, 112, 175, 280, 450, 780, 1700, 3100]
    },
    'oval-stickers': {
      '2x3': [26.5, 46, 66, 115, 200, 350, 620, 1350, 2500],
      '2x4': [30.75, 53, 73, 127.5, 220, 380, 660, 1400, 2500],
      '2x5': [36.25, 59.5, 79, 140, 230, 390, 680, 1450, 2600],
      '3x4': [41.75, 66, 86, 152.5, 245, 400, 700, 1500, 2800],
      '3x5': [47.25, 72.5, 92, 167.5, 265, 420, 740, 1600, 2900],
      '3x6': [52.75, 79, 100, 177.5, 275, 430, 760, 1650, 3000],
      '4x6': [57.25, 86, 107, 190, 295, 470, 840, 1850, 3400],
      '4x7': [62.75, 92.5, 113, 202.5, 315, 490, 880, 1950, 3700],
      '4x8': [68.25, 99, 120, 212.5, 330, 520, 940, 2100, 4000]
    }
  };
  var STK_ROWS = {};
  function stkTable(p) { return p && STK_TABLES[p.handle]; }
  function stkRows(p) {
    var h = p.handle;
    if (!STK_ROWS[h]) {
      var t = STK_TABLES[h];
      STK_ROWS[h] = Object.keys(t).map(function (k) {
        var d = k.split('x');
        return { key: k, area: (+d[0]) * (+d[1]), px: t[k] };
      }).sort(function (a, b) { return a.area - b.area; });
    }
    return STK_ROWS[h];
  }
  // 사이즈 → 수량별 총액 배열 (표에 없는 사이즈는 면적 기준 보간)
  function stkPrices(p, wIn, hIn) {
    var t = stkTable(p);
    if (!t) return null;
    var k1 = wIn + 'x' + hIn, k2 = hIn + 'x' + wIn;
    if (t[k1]) return t[k1];
    if (t[k2]) return t[k2];
    var rows = stkRows(p), a = wIn * hIn;
    if (a <= rows[0].area) return rows[0].px;
    var last = rows[rows.length - 1];
    if (a >= last.area) return last.px.map(function (v) { return v * a / last.area; });
    for (var i = 1; i < rows.length; i++) {
      if (a <= rows[i].area) {
        var lo = rows[i - 1], hi = rows[i], f = (a - lo.area) / (hi.area - lo.area);
        return lo.px.map(function (v, j) { return v + (hi.px[j] - v) * f; });
      }
    }
    return last.px;
  }
  function stkTotal(p, wIn, hIn, qty) {
    var px = stkPrices(p, wIn, hIn);
    if (!px) return 0;
    if (qty <= STK_Q[0]) return px[0] / STK_Q[0] * qty;              // 25장 미만은 25장 장당가
    if (qty >= STK_Q[STK_Q.length - 1]) return px[px.length - 1] / STK_Q[STK_Q.length - 1] * qty;
    for (var i = 1; i < STK_Q.length; i++) {
      if (qty <= STK_Q[i]) {
        var f = (qty - STK_Q[i - 1]) / (STK_Q[i] - STK_Q[i - 1]);
        return px[i - 1] + (px[i] - px[i - 1]) * f;
      }
    }
    return px[px.length - 1];
  }
  function stkListEa(p, wIn, hIn) {                                   // 25장 기준 장당가 = 정가
    var px = stkPrices(p, wIn, hIn);
    return px ? px[0] / STK_Q[0] : 0;
  }
  function stkColOf(qty) {
    var c = STK_Q[0];
    for (var i = 0; i < STK_Q.length; i++) if (qty >= STK_Q[i]) c = STK_Q[i];
    return c;
  }
  function r2(n) { return Math.round(n * 100) / 100; }
  function floor2(n) { return Math.floor(n * 100) / 100; }
  function inW() { return Math.round(lastW * 120) / 10; }
  function inH() { return Math.round(lastH * 120) / 10; }

  // 앱 엔진 훅: 정가(25장 장당)로 소계를 만들고, 수량 할인율로 표의 실제 총액을 맞춘다
  // 소계 = 가격표 총액 그대로. 장당가는 내림 2자리라 "장당 x 수량 = 합계" 가 표와 정확히 맞는다
  window.__dcSubtotal = function (spec, unit) {
    var p = AP();
    if (!p || !stkTable(p)) return null;
    return r2(stkTotal(p, inW(), inH(), spec.quantity));
  };
  window.__dcTier = function (qty) {
    var p = AP();
    if (!p || !stkTable(p)) return null;
    snapQtyIfNeeded(qty);
    return { minQty: stkColOf(qty), maxQty: null, discount: 0, label: stkColOf(qty).toLocaleString() + ' pc unit price' };
  };
  window.__dcTierTable = function () {
    var p = AP();
    if (!p || !stkTable(p)) return null;
    var wIn = Math.round(lastW * 120) / 10, hIn = Math.round(lastH * 120) / 10;
    var px = stkPrices(p, wIn, hIn), base = px[0] / STK_Q[0];
    return STK_Q.map(function (q, i) {
      return { minQty: q, maxQty: null, discount: Math.max(0, 1 - (px[i] / q) / base), label: q.toLocaleString() + '' };
    });
  };
  window.__dcNextTier = function (qty, fallback) {
    var p = AP();
    if (!p || !stkTable(p)) return fallback ? fallback(qty) : void 0;
    var rows = window.__dcTierTable();
    for (var i = 0; i < rows.length; i++) if (rows[i].minQty > qty) return rows[i];
    return void 0;
  };

  /* 검사 6번 — 스티커 수량은 공식 가격표의 열(25/50/100/250/500/1,000/2,000/5,000/10,000)만
     판다. 표에 없는 수량의 가격을 앱이 만들어 내지 않도록:
       · 규격 패널·시작 팝업의 수량 칸이 select 로 바뀐다 (__dcQtyOptions)
       · 값이 어긋나 들어오면 다음 틱에 가장 가까운 열로 스냅한다
       · 장바구니 모듈이 마지막 방어선으로 열 밖 수량을 거절한다 (__dcStkQty) */
  window.__dcStkQty = STK_Q.slice();
  window.__dcQtyOptions = function () {
    var p = AP();
    return p && stkTable(p) ? STK_Q.slice() : null;
  };
  window.__dcQtySnap = function (q) {
    q = +q || STK_Q[0];
    var best = STK_Q[0], bd = Infinity;
    for (var i = 0; i < STK_Q.length; i++) {
      var d = Math.abs(STK_Q[i] - q);
      if (d < bd) { bd = d; best = STK_Q[i]; }
    }
    return best;
  };
  var _qtySnapPend = false;
  function snapQtyIfNeeded(qty) {
    if (STK_Q.indexOf(+qty) >= 0 || _qtySnapPend) return;
    _qtySnapPend = true;
    setTimeout(function () {
      _qtySnapPend = false;
      try {
        var a = window.__dcApi, p = AP();
        if (a && a.spec && p && stkTable(p) && STK_Q.indexOf(+a.spec.quantity) < 0) {
          a.setSpec({ quantity: window.__dcQtySnap(a.spec.quantity) });
        }
      } catch (e) {}
    }, 0);
  }

  /* ---------------------------------------------------------------- utils */
  function $(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function toast(msg) {
    if (!els.toast) { els.toast = $('div', 'sbdc-toast'); document.body.appendChild(els.toast); }
    els.toast.textContent = msg;
    els.toast.classList.add('is-on');
    clearTimeout(els.toastT);
    els.toastT = setTimeout(function () { els.toast.classList.remove('is-on'); }, 1500);
  }
  function isInch(p) { return (p || state.product).unit === 'in'; }
  function toF(p, v) { return p.unit === 'in' ? v / 12 : v; }
  function toFeet(v) { return isInch() ? v / 12 : v; }

  /* ═══════════════════════════════════════════ 상품별 «실제로 파는» 피트 규격 (A18 · A23)
     규칙을 여기 한 곳에만 적는다. 시작 팝업(clampSize)과 메인 «규격» 패널(번들)이
     둘 다 이것을 읽는다.

     예전에는 팝업만 ftSize 를 알고, 번들 패널은 «2~50ft · 짧은 변 8ft» 공통 규칙
     하나만 알았다. 그래서 팝업에서 패브릭 배너를 고른 뒤 패널에서 2×2ft 로 바꾸면
     그대로 통과했고(화면엔 내내 「주문 가능」), 디자인을 다 끝내고 승인을 누른
     뒤에야 「상품 규격을 찾지 못했습니다」로 막혔다 — 자유규격 4상품 928개 크기.
     규격형(fixedOnly) 상품은 팝업이 칸을 잠그는데 패널은 규격형인 줄도 몰라
     6개만 파는 상품에 637개가 열려 있었다 (A23).                              */
  function ftRuleOf(p) {
    if (!p || p.unit === 'in') return null;        // 인치 상품은 __dcInchCfg 가 따로 맡는다
    var fz = p.ftSize || {};
    var minSide = Math.max(fz.minSide != null ? fz.minSide : MIN_FT, p.min || MIN_FT);
    var maxSide = fz.maxSide != null ? fz.maxSide : MAX_FT;
    var maxShort = fz.maxShort != null ? fz.maxShort : ROLL_FT;
    var presets = null;
    if (p.fixedOnly) {
      presets = (p.presets || []).map(function (s) {
        var d = String(s).split('x'); return [+d[0], +d[1]];
      }).filter(function (q) { return q[0] > 0 && q[1] > 0; });
      if (!presets.length) presets = null;         // 규격 목록이 비면 자유규격처럼 다룬다
      if (presets) {
        // 규격형은 «파는 규격» 이 곧 한계다 — 칸의 「최대 N」 표시가 30ft 상품에 50 이라고
        // 뜨지 않게 여기서 맞춘다. 판정·정리는 아래에서 presets 목록만 본다.
        var dims = presets.reduce(function (a, q) { return a.concat(q); }, []);
        minSide = Math.min.apply(Math, dims);
        maxSide = Math.max.apply(Math, dims);
        maxShort = Math.max.apply(Math, presets.map(function (q) { return Math.min(q[0], q[1]); }));
      }
    }
    var hint = presets
      ? 'This product is sold in fixed sizes only. Pick one from the chips below.'
      : 'Choose in 1-foot steps. '
        + (minSide > MIN_FT ? 'min ' + minSide + 'ft and up, and ' : '')
        + 'One of width or height must be ' + maxShort + 'ft or less.';
    return { minSide: minSide, maxSide: maxSide, maxShort: maxShort, presets: presets, hint: hint };
  }
  // 이 크기를 파는가
  function ftFits(R, w, h) {
    if (!R) return true;
    if (R.presets) return R.presets.some(function (q) { return q[0] === w && q[1] === h; });
    return w === Math.round(w) && h === Math.round(h)
      && w >= R.minSide && h >= R.minSide && w <= R.maxSide && h <= R.maxSide
      && Math.min(w, h) <= R.maxShort;
  }
  /* 규칙 안으로 끌어당긴다. changed = 사람이 방금 만진 칸
     ('w'/'width' = 가로, 'h'/'height' = 세로). 팝업은 w/h, 번들은 width/height 로 부른다. */
  function ftPull(R, w, h, changed, soft) {
    var byW = changed !== 'h' && changed !== 'height';
    if (R.presets) {                               // 규격형: 파는 규격 중 가장 가까운 것으로
      var best = R.presets[0], bd = Infinity;
      for (var i = 0; i < R.presets.length; i++) {
        var q = R.presets[i];
        // 방금 만진 칸을 더 존중한다 (가중치 4)
        var d = byW ? Math.abs(q[0] - w) * 4 + Math.abs(q[1] - h)
                    : Math.abs(q[1] - h) * 4 + Math.abs(q[0] - w);
        if (d < bd) { bd = d; best = q; }
      }
      return [best[0], best[1]];
    }
    /* soft = 사람이 지금 «치고 있는» 칸. 그 칸만 최솟값으로 끌어올리지 않는다.
       최소 4ft 상품에서 12 를 치려면 «1» 을 지나가야 하는데 매 글자마다 4 로 올려
       버리면 «42» 가 된다. 최댓값·짧은변 규칙은 치는 중에도 그대로 적용한다. */
    var loW = (soft && byW) ? 1 : R.minSide;
    var loH = (soft && !byW) ? 1 : R.minSide;
    w = Math.round(w) || loW; h = Math.round(h) || loH;
    w = Math.max(loW, Math.min(R.maxSide, w));
    h = Math.max(loH, Math.min(R.maxSide, h));
    if (Math.min(w, h) > R.maxShort) { if (byW) h = R.maxShort; else w = R.maxShort; }
    return [w, h];
  }
  /* 번들이 물어보는 훅 넷 — 언제나 «지금 적용된» 상품 기준(AP()).
     규칙이 없으면(인치 상품 등) null 을 돌려, 번들이 예전 공통 규칙을 그대로 쓰게 둔다. */
  function appliedFtRule() { return ftRuleOf(AP()); }
  /* «규격» 패널의 가로·세로 칸을 사람이 치고 있는지 본다. 번들은 글자 하나마다
     setSpec 을 부르므로, 치는 중에 최솟값으로 올려 버리면 두 자리 숫자를 칠 수 없다.
     칸을 떠나거나(focusout) Enter 를 누르면 그때 규칙대로 한 번에 정리한다. */
  var typingSide = null;
  function sizeBoxSide(el) {
    if (!el || el.tagName !== 'INPUT' || typeof el.closest !== 'function') return null;
    var row = el.closest('.size-row');
    if (!row) return null;
    var bx = row.querySelectorAll('input');
    return bx[0] === el ? 'width' : (bx[1] === el ? 'height' : null);
  }
  function commitSizeBox() {
    setTimeout(function () {
      try {
        var a = window.__dcApi;
        if (a && a.spec) a.setSpec({ widthIn: a.spec.widthIn });   // soft 없이 다시 정리된다
      } catch (e) {}
    }, 0);
  }
  try {
    document.addEventListener('focusin', function (e) { typingSide = sizeBoxSide(e.target); }, true);
    document.addEventListener('focusout', function (e) {
      if (!sizeBoxSide(e.target)) return;
      typingSide = null; commitSizeBox();
    }, true);
    document.addEventListener('keydown', function (e) {                 // Enter 로 끝내도 정리
      if (e.key === 'Enter' && sizeBoxSide(e.target)) { try { e.target.blur(); } catch (x) {} }
    }, true);
    /* 포커스된 숫자 칸 위에서 휠을 굴리면 «브라우저가» 값을 올리내린다.
       칸을 한 번 누른 뒤 패널을 내려 보려고 스크롤하면 크기가 조용히 바뀐다.
       휠이 오면 칸에서 손을 떼게 해(그때 규칙대로 정리된다) 화면이 평소처럼 스크롤되게 한다. */
    document.addEventListener('wheel', function (e) {
      if (sizeBoxSide(e.target) && document.activeElement === e.target) {
        try { e.target.blur(); } catch (x) {}
      }
    }, true);
  } catch (e) {}
  window.__dcFtRule   = appliedFtRule;
  window.__dcFtSizeOk = function (w, h) { var R = appliedFtRule(); return R ? ftFits(R, w, h) : null; };
  window.__dcFtClamp  = function (w, h, changed) {
    var R = appliedFtRule();
    return R ? ftPull(R, w, h, changed, typingSide != null && typingSide === changed) : null;
  };
  window.__dcFtChips  = function (def) {           // 규격 칩: 규격형은 그 목록, 자유규격은 거른 것
    var R = appliedFtRule();
    if (!R) return def;
    if (R.presets) return R.presets;
    return (def || []).filter(function (q) { return ftFits(R, q[0], q[1]); });
  };

  // 팝업 안의 크기 값은 상품 단위(ft 또는 in) 그대로 다룬다
  function clampSize(w, h, changed) {
    var p = state.product;
    if (isInch(p)) {
      var lo = p.minIn || 1, hi = p.maxIn || 120, st = p.stepIn || 0;
      w = parseFloat(w) || lo; h = parseFloat(h) || lo;
      if (p.fixedOnly && p.presetsIn && p.presetsIn.length) {
        // 검사 6번 — 공식 가격표(프리셋)에 있는 규격만: 가장 가까운 것으로 스냅
        var _bp = null, _bd = Infinity;
        p.presetsIn.forEach(function (ps) {
          var d = ps.split('x'), dw = +d[0], dh = +d[1];
          var dist = Math.abs(dw - w) + Math.abs(dh - h);
          if (dist < _bd) { _bd = dist; _bp = [dw, dh]; }
        });
        if (_bp) return _bp;
      }
      if (st) { w = Math.round(w / st) * st; h = Math.round(h / st) * st; }
      return [Math.max(lo, Math.min(hi, w)), Math.max(lo, Math.min(hi, h))];
    }
    return ftPull(ftRuleOf(p), w, h, changed);     // 규칙은 위 ftRuleOf 한 곳에서만 나온다
  }

  /* ================================================================ 시작 팝업 */
  function buildModal() {
    var ov = $('div', 'sbdc-ov');
    ov.id = 'sbdc-start';
    var m = $('div', 'sbdc-modal');

    var head = $('div', 'sbdc-head');
    head.appendChild($('div', '', '<h2>What are you making?</h2><p>Pick the product, size and finishing first and the canvas will be set up for you.</p>'));
    var x = $('button', 'sbdc-x', '&times;');
    x.type = 'button'; x.onclick = close;
    head.appendChild(x);
    m.appendChild(head);

    var body = $('div', 'sbdc-body');

    var c1 = $('div', 'sbdc-col');
    c1.appendChild($('h3', '', '1. Choose product'));
    c1.appendChild($('p', 'sbdc-hint', 'Pick a category to see its products.'));
    els.cats = $('div', 'sbdc-cats'); c1.appendChild(els.cats);
    els.prods = $('div', 'sbdc-prods'); c1.appendChild(els.prods);
    body.appendChild(c1);

    var c2 = $('div', 'sbdc-col');
    c2.appendChild($('h3', '', '2. Size · Quantity'));
    els.sizeHint = $('p', 'sbdc-hint'); c2.appendChild(els.sizeHint);
    var row = $('div', 'sbdc-sizes');
    els.w = $('input'); els.w.type = 'number';
    els.h = $('input'); els.h.type = 'number';
    els.wl = $('span', '', 'Width'); els.hl = $('span', '', 'Height');
    var lw = $('label', 'sbdc-f'); lw.appendChild(els.wl); lw.appendChild(els.w);
    var lh = $('label', 'sbdc-f'); lh.appendChild(els.hl); lh.appendChild(els.h);
    row.appendChild(lw); row.appendChild(lh);
    c2.appendChild(row);
    els.presets = $('div', 'sbdc-presets'); c2.appendChild(els.presets);
    els.warn = $('p', 'sbdc-warn'); els.warn.style.display = 'none'; c2.appendChild(els.warn);
    c2.appendChild($('h3', 'is-mt', 'Qty'));
    els.qty = $('input'); els.qty.type = 'number'; els.qty.min = 1; els.qty.step = 1;
    els.qtyEl = els.qty;
    // 검사 6번 — 공식 수량표가 있는 상품(스티커)은 표의 열에서만 고른다
    els.qtySel = $('select'); els.qtySel.style.display = 'none';
    els.qtySel.onchange = function () { state.qty = +els.qtySel.value || STK_Q[0]; sync(); };
    var lq = $('label', 'sbdc-f'); lq.appendChild(els.qty); lq.appendChild(els.qtySel); c2.appendChild(lq);
    els.tier = $('p', 'sbdc-hint'); els.tier.style.marginTop = '8px'; c2.appendChild(els.tier);
    body.appendChild(c2);

    var c3 = $('div', 'sbdc-col');
    c3.appendChild($('h3', '', '3. Finishing Options'));
    els.finHint = $('p', 'sbdc-hint', 'All finishing is free. The hem folds, the grommets punch through, and the pole pocket swallows that much inward.');
    c3.appendChild(els.finHint);
    els.fins = $('div', 'sbdc-fins'); c3.appendChild(els.fins);

    // 4. 재질 (A19) — 재질이 있는 상품(스티커·윈도우 데칼)에서만 보인다
    els.matHead = $('h3', 'is-mt', '4. Material');
    els.matHint = $('p', 'sbdc-hint', 'Both materials cost the same. You can also change it later in the 「Material」 panel on the left.');
    els.mats = $('div', 'sbdc-fins');
    c3.appendChild(els.matHead); c3.appendChild(els.matHint); c3.appendChild(els.mats);
    body.appendChild(c3);

    m.appendChild(body);

    var foot = $('div', 'sbdc-foot');
    els.sum = $('div', 'sbdc-sum'); foot.appendChild(els.sum);
    foot.appendChild($('span', 'sbdc-sp'));
    var skip = $('button', 'sbdc-ghost', 'Set later'); skip.type = 'button'; skip.onclick = close;
    els.skip = skip;
    var go = $('button', 'sbdc-go', 'Start designing'); go.type = 'button'; go.onclick = apply;
    foot.appendChild(skip); foot.appendChild(go);
    m.appendChild(foot);

    ov.appendChild(m);
    ov.addEventListener('mousedown', function (e) { if (e.target === ov) close(); });
    document.body.appendChild(ov);
    els.ov = ov;

    /* 크기 규칙 때문에 «반대쪽 칸» 이 강제로 바뀌면, 그 칸의 화면 값도 같이 고친다.
       예전에는 sync(true) 로 입력칸을 통째로 안 고쳐서, 20×20 을 치면
       화면엔 20×20 이 남고 속은 8×20 이 되어 값과 가격이 어긋났다.
       지금 치고 있는 칸만 남겨 두는 이유는, 매 글자마다 덮어쓰면
       «1» 을 치고 «2» 를 못 붙이기 때문이다(최솟값 2 로 즉시 튄다). */
    function setSize(w, h, changed, keep) {
      var s = clampSize(w, h, changed);
      state.w = s[0]; state.h = s[1];
      sync(keep ? { preserve: keep } : null);
    }
    // 칸을 떠날 때 · 「디자인 시작」 직전 — 화면과 속을 완전히 같게 만든다
    function commitSize(changed) {
      setSize(els.w.value, els.h.value, changed || 'w', null);
    }
    els.commitSize = commitSize;

    els.w.oninput  = function () { setSize(els.w.value, state.h, 'w', 'w'); };
    els.h.oninput  = function () { setSize(state.w, els.h.value, 'h', 'h'); };
    els.w.onchange = function () { commitSize('w'); };
    els.h.onchange = function () { commitSize('h'); };
    els.qty.oninput = function () {
      var lo = state.product.minQty || 1;
      state.qty = Math.max(lo, Math.round(+els.qty.value) || lo);
      sync({ preserve: 'qty' });
    };
    els.qty.onchange = function () { sync(); };

    renderCats();
    sync();
  }

  // «디자인센터에서만» 감춘 상품을 걸러 낸다. 카탈로그 항목 자체는 그대로 두므로
  // hidden 한 줄만 지우면 되살아난다. (시작 팝업이 상품을 읽는 유일한 통로다.)
  function visible(items) {
    return (items || []).filter(function (x) { return !x.hidden; });
  }
  window.__dcVisibleItems = visible;                       // 시험용 훅
  function renderCats() {
    els.cats.innerHTML = '';
    CATALOG.forEach(function (g, i) {
      if (!visible(g.items).length) return;                 // 통째로 감춘 분류는 안 그린다
      var b = $('button', 'sbdc-cat' + (state.cat === i ? ' is-on' : ''), g.cat);
      b.type = 'button';
      b.onclick = function () { state.cat = i; renderCats(); var first = visible(CATALOG[i].items)[0]; if (first && pkey(first) !== pkey(state.product)) pickProduct(first); };
      els.cats.appendChild(b);
    });
    renderProds();
  }

  function pickProduct(p) {
    state.product = p;
    state.w = p.w; state.h = p.h;
    state.qty = p.qty || 1;
    state.fin = finDef(p);                                // A3 — 상품마다 그 상품의 기본 마감으로
    if (!matOk(p, state.mat)) state.mat = matDef(p);      // 재질 없는 상품이면 null 로 지워진다
    renderProds(); sync();
  }

  function renderProds() {
    els.prods.innerHTML = '';
    visible(CATALOG[state.cat].items).forEach(function (p) {
      var b = $('button', 'sbdc-prod' + (pkey(state.product) === pkey(p) ? ' is-on' : ''));
      b.type = 'button';
      b.setAttribute('data-handle', p.handle);   // 2026-09-15: 이름이 같은 상품(Pop-Up 8x8/10x8)을 카드로 구분
      var info = $('div', '');
      info.appendChild($('b', '', p.nameKo));
      info.appendChild($('em', '', p.material));
      b.appendChild(info);
      var label;
      if (stkTable(p)) label = money(stkListEa(p, p.w, p.h)) + '<small style="color:var(--ink-3)">per pc at 25</small>';
      else if (p.unit === 'in' || p.fixedOnly) label = money(unitPriceFor(p, toF(p, p.w), toF(p, p.h))) + '<small style="color:var(--ink-3)">fixed size</small>';
      else label = '$' + p.rate.toFixed(2) + '/sq.ft';
      b.appendChild($('div', 'sbdc-rate', label));
      b.onclick = function () { pickProduct(p); };
      els.prods.appendChild(b);
    });
  }

  function renderFins() {
    els.fins.innerHTML = '';
    var _list = (typeof window !== 'undefined' && window.__dcFinishingFilterKo) ? window.__dcFinishingFilterKo(FINISHING) : FINISHING;
    if (_list.length && _list.map(function(x){return x.id;}).indexOf(state.fin) < 0) state.fin = _list[0].id;
    _list.forEach(function (f) {
      var b = $('button', 'sbdc-fin' + (state.fin === f.id ? ' is-on' : ''));
      b.type = 'button';
      var d = $('div', '');
      d.appendChild($('b', '', f.ko));
      d.appendChild($('em', '', f.en + ' · ' + f.note));
      b.appendChild(d);
      b.appendChild($('span', 'sbdc-free', 'Free'));
      b.onclick = function () { state.fin = f.id; renderFins(); };
      els.fins.appendChild(b);
    });
  }

  /* 재질 목록 — 마감과 같은 단추 모양(.sbdc-fin)을 그대로 쓴다.
     가격이 같으므로 오른쪽 «무료» 자리에는 «가격 동일» 이라고 쓴다. */
  function renderMats() {
    var M = matsOf(state.product);
    var on = !!M;
    els.matHead.style.display = els.matHint.style.display = els.mats.style.display = on ? '' : 'none';
    els.mats.innerHTML = '';
    if (!on) return;
    if (!matOk(state.product, state.mat)) state.mat = matDef(state.product);
    M.list.forEach(function (m) {
      var b = $('button', 'sbdc-fin' + (state.mat === m.id ? ' is-on' : ''));
      b.type = 'button';
      var d = $('div', '');
      d.appendChild($('b', '', m.ko));
      d.appendChild($('em', '', m.en + ' · ' + m.note));
      b.appendChild(d);
      b.appendChild($('span', 'sbdc-free', 'Same price'));
      b.onclick = function () { state.mat = m.id; sync(); };
      els.mats.appendChild(b);
    });
  }

  /* opts.preserve — 지금 사람이 치고 있는 칸 하나만 그대로 둔다.
     아무것도 안 주면 세 칸 모두 state 값으로 다시 쓴다. */
  function sync(opts) {
    var p = state.product, inch = isInch(p), fixed = !!p.fixedOnly;
    var u = inch ? 'in' : 'ft', sym = inch ? '"' : "'";

    els.wl.textContent = 'Width (' + u + ')';
    els.hl.textContent = 'Height (' + u + ')';
    els.w.step = inch ? (p.stepIn || 0.5) : 1;
    els.h.step = els.w.step;
    els.w.min = inch ? (p.minIn || 1) : (p.min || MIN_FT);
    els.h.min = els.w.min;
    els.qty.min = p.minQty || 1;
    if (state.qty < (p.minQty || 1)) state.qty = p.minQty;
    var keep = (opts && opts.preserve) || null;
    if (keep !== 'w') els.w.value = state.w;
    if (keep !== 'h') els.h.value = state.h;
    if (keep !== 'qty') els.qty.value = state.qty;
    var _stk = !!stkTable(p);
    if (els.qtySel) {                                   // 검사 6번 — 스티커는 표의 열만
      if (_stk) {
        if (STK_Q.indexOf(+state.qty) < 0) state.qty = window.__dcQtySnap(state.qty);
        if (els.qtySel.options.length !== STK_Q.length) {
          els.qtySel.innerHTML = '';
          STK_Q.forEach(function (q) {
            var o = document.createElement('option');
            o.value = q; o.textContent = q.toLocaleString() + '';
            els.qtySel.appendChild(o);
          });
        }
        els.qtySel.value = String(state.qty);
      }
      els.qtySel.style.display = _stk ? '' : 'none';
      els.qty.style.display = _stk ? 'none' : '';
    }
    els.w.readOnly = fixed; els.h.readOnly = fixed;
    els.w.style.opacity = els.h.style.opacity = fixed ? .55 : 1;
    els.sizeHint.textContent = (inch
      ? 'This product is sized in inches — the feet limits do not apply.'
      : 'Choose in 1-foot steps. The roll is 8ft wide, so one of width or height must be 8ft or less.')
      + (DIE[p.handle] ? ' The artboard is shown in the actual cut shape.' : '');

    els.presets.innerHTML = '';
    ((inch ? p.presetsIn : p.presets) || []).forEach(function (ps) {
      var wh = ps.split('x');
      var b = $('button', 'sbdc-preset', wh[0] + sym + ' x ' + wh[1] + sym);
      b.type = 'button';
      if (!inch && isSpecialSize(p, +wh[0], +wh[1])) {                 // 특가 딱지
        b.classList.add('is-special');
        var tag = $('span', 'sbdc-preset-tag', 'Deal');
        b.appendChild(tag);
        b.title = 'This size is a fixed deal price — ' + money(unitPriceFor(p, +wh[0], +wh[1]));
      }
      b.onclick = function () { var s = clampSize(+wh[0], +wh[1], 'w'); state.w = s[0]; state.h = s[1]; sync(); };
      els.presets.appendChild(b);
    });

    var _fk = (typeof window !== 'undefined' && window.__dcFinishingFilterKo) ? window.__dcFinishingFilterKo(FINISHING) : FINISHING;
    if (p.noFinishing || _fk.length === 0) {
      state.fin = 'none';
      els.fins.innerHTML = '';
      els.finHint.textContent = 'This product has no finishing options. It ships cut to size.';
    } else {
      els.finHint.textContent = 'All finishing is free. The hem folds, the grommets punch through, and the pole pocket swallows that much inward.';
      renderFins();
    }
    renderMats();

    if (fixed) {
      els.warn.style.display = '';
      els.warn.textContent = 'The store sells this product in fixed sizes only. Choose one of the sizes below.';
    } else if (inch) {
      els.warn.style.display = '';
      els.warn.textContent = (p.minIn || 1) + '" ~ ' + (p.maxIn || 120) + '".';
    } else if (Math.min(state.w, state.h) >= ROLL_FT) {
      els.warn.style.display = '';
      els.warn.textContent = 'The roll is 8ft wide, so one side is capped at 8ft. Anything larger needs a seam quote.';
    } else if (p.min > MIN_FT) {
      els.warn.style.display = '';
      els.warn.textContent = 'This product starts at ' + p.min + 'ft and up.';
    } else els.warn.style.display = 'none';

    var wf = toFeet(state.w), hf = toFeet(state.h);
    var total, unit;
    if (stkTable(p)) {
      total = r2(stkTotal(p, state.w, state.h, state.qty));
      unit = floor2(total / Math.max(1, state.qty));
      var col = stkColOf(state.qty), px = stkPrices(p, state.w, state.h);
      var save = Math.round((1 - unit / (px[0] / STK_Q[0])) * 100);
      els.tier.textContent = 'Sticker quantity table applied — ' + col.toLocaleString() + ' pc tier'
        + (save > 0 ? ' (vs 25 pcs ' + save + '% less)' : '') + ' · min 25 pcs';
    } else {
      unit = unitPriceFor(p, wf, hf);
      var disc = tierOf(state.qty);
      total = unit * state.qty * (1 - disc);
      els.tier.textContent = disc > 0
        ? 'Quantity discount ' + Math.round(disc * 100) + '% applied'
        : 'Quantity discounts start at 2 pcs (2–4 pcs 2%, 5–9 pcs 5%, 10+ pcs 10% and up).';
    }
    var _me = matEntry(p, state.mat);
    els.sum.innerHTML = p.nameKo + ' · ' + state.w + sym + ' x ' + state.h + sym + ' · ' + state.qty + ''
      + (_me ? ' · ' + _me.ko : '') + '<br><b>'
      + money(total) + '</b> <span style="font-size:11.5px">(unit ' + money(unit) + ')</span>';
  }

  /* ---------------------------------------------------------------- 면(앞/뒤) 정리
     상품마다 «양면을 파는가» 가 다르다. 그런데 뒷면 문서(`back`)는 상품과 따로
     살아 있어서, 양면 상품에서 뒷면을 만든 뒤 단면 상품으로 바꾸면 그대로 남는다.
     화면엔 «뒷면 편집 중», 주문엔 «양면», 값은 단면 면적 — 셋이 어긋난다.
     그래서 상품을 적용하기 전에 면 상태를 먼저 맞춘다. */

  function backHasWork(api) {
    var b = api && api.back;
    if (!b) return false;
    if (b.layers && b.layers.length) return true;
    return !!(b.background && String(b.background).toLowerCase() !== '#ffffff');
  }

  /* 지운다고 알리고 묻는 창 — 시작 팝업과 같은 옷을 입는다.
     DC-120 에서 「처음부터」 도 같은 창을 쓰게 되어, 문구를 밖에서 받도록 열었다.
     opts = { title, html, yes, no, onYes, onNo } */
  function ask(o) {
    o = o || {};
    var ov = $('div', 'sbdc-ov sbdc-ask is-open');
    var m = $('div', 'sbdc-modal');
    var head = $('div', 'sbdc-head');
    head.appendChild($('div', '', '<h2 id="sbdc-ask-title">' + (o.title || 'Continue?') + '</h2>'));
    m.appendChild(head);
    var body = $('div', 'sbdc-ask-body');
    body.appendChild($('p', '', o.html || ''));
    m.appendChild(body);
    var foot = $('div', 'sbdc-foot');
    foot.appendChild($('span', 'sbdc-sp'));
    var onYes = o.onYes, onNo = o.onNo;
    var no = $('button', 'sbdc-ghost', o.no || 'Cancel');
    var yes = $('button', 'sbdc-go', o.yes || 'Continue');
    no.type = yes.type = 'button';
    foot.appendChild(no); foot.appendChild(yes);
    m.appendChild(foot);
    ov.appendChild(m);
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-labelledby', 'sbdc-ask-title');

    function shut(fn) {
      ov.remove();
      document.removeEventListener('keydown', esc, true);
      if (fn) fn();
    }
    function esc(e) { if (e.key === 'Escape') { e.stopPropagation(); shut(onNo); } }
    no.onclick = function () { shut(onNo); };
    yes.onclick = function () { shut(onYes); };
    ov.addEventListener('mousedown', function (e) { if (e.target === ov) shut(onNo); });
    document.addEventListener('keydown', esc, true);
    document.body.appendChild(ov);
    no.focus();                                  // 지우는 쪽이 아니라 «취소» 에 커서를 둔다
  }
  window.__dcAsk = ask;                          // 다른 패치 층(sbdc-reset)이 쓴다

  function askDropBack(onYes, onNo) {
    ask({
      title: 'The back design will be removed',
      html: 'The product you picked supports <b>single-sided printing only</b>. '
          + 'Changing the product <b>removes the back design</b>. Continue?',
      yes: 'Continue', onYes: onYes, onNo: onNo
    });
  }

  /* 초안을 버리고 «지금 적용된 것» 으로 되돌린다 — 취소·닫기 때 부른다.

     fresh = true  일 때만 화면(api.spec)을 마저 읽는다 (아래 DC-119 주석 참고).
     api.spec 은 React 상태라 setSpec 을 부른 «직후» 에는 아직 옛 값이다 (DC-128).
     그래서 「디자인 시작」 → close() 경로에서 읽으면, 손님이 방금 고른 마감·재질을
     바로 옛 값으로 도로 덮어쓴다. 그 경로에서는 읽지 않는다. */
  function restoreApplied(fresh) {
    state.cat = applied.cat; state.product = applied.p;
    state.w = applied.w; state.h = applied.h; state.qty = applied.qty; state.fin = applied.fin;
    state.mat = applied.mat;

    /* DC-119 — 마감·재질은 팝업 밖(왼쪽 레일)에서도 바뀐다.
       applied 는 「디자인 시작」 을 누를 때만 갱신되는 «사본» 이라, 레일에서 바꾼 값을 모른다.
       사본을 믿으면 이런 일이 난다 (실측):
         레일에서 폴포켓 선택 → 팝업 열어 크기만 바꾸고 「디자인 시작」 → 헴+그로밋으로 되돌아감
         레일에서 리무버블 선택 → 같은 순서 → 일반 비닐로 되돌아감 (A19 를 도로 무름)
       그래서 이 두 값만은 사본이 아니라 «화면에 실제로 적용된 것» 을 읽는다. */
    var sp = fresh && window.__dcApi && window.__dcApi.spec;
    if (sp) {
      if (sp.finishing) state.fin = sp.finishing;
      if (sp.material) state.mat = sp.material;
    }
    if (els.ov) { renderCats(); sync(); }   // 카테고리·상품 목록을 다시 그린다
  }

  function apply() {
    var api = window.__dcApi;
    if (!api) { toast('The design center is still loading. Please try again shortly.'); return; }
    // 칸을 떠나지 않고 바로 눌렀을 수도 있다 — 화면 값으로 마지막 한 번 맞춘다
    if (els.commitSize) els.commitSize();
    // 새 상품이 단면인데 뒷면이 남아 있으면 → 비어 있으면 그냥 지우고, 그린 게 있으면 묻는다
    if (api.back && !state.product.doubleSided && backHasWork(api)) {
      askDropBack(applyNow, function () { restoreApplied(true); });
      return;
    }
    applyNow();
  }

  /* ── 상품에 딸린 «되돌리기 기록 밖» 값들 (V56-R03) ──────────────────
     아래 넷은 본체(React)의 되돌리기 기록에 들어가지 않는다. 기록에 들어가는 것은
     규격(spec)과 디자인(front/back)뿐이다. 그래서 Ctrl+Z 를 누르면 규격만 옛 상품
     값으로 돌아가고 이 넷은 새 상품에 남아, 한 상품에도 없는 조합이 만들어졌다
     (실측: 리트랙터블인데 96×48 · $91.43).

     상품을 바꿀 때(applyNow)와 되돌리기 뒤 되맞춤이 «똑같은 코드» 를 쓰도록 뽑아 둔다.
     베껴 두면 나중에 한쪽만 고쳐 또 갈라진다 — DC-128 이 바로 그 사고였다.

     ⚠ 다듬은 값(fin·mat)은 여기서 다시 계산하지 않는다. 부르는 쪽이 한 번만
        계산해서 넘긴다 (DC-128 의 규칙).
     ⚠ 문서(doc)에 든 것 — 면 상태·시청 거리 — 은 여기 없다. 그건 기록 «안» 에
        있어서 되돌리기가 알아서 복원한다. */
  function pushGlobals(p, cat, w, h, fin, qty, mat) {
    var P = window.__dcProduct, inch = isInch(p);
    var wIn = inch ? w : w * 12, hIn = inch ? h : h * 12;
    applied = { p: p, cat: cat, w: w, h: h, qty: qty, fin: fin, mat: mat };
    window.__dcInch = inch;                     // 앱의 ft 스냅/검증 우회 플래그
    if (P) {
      P.id = p.handle; P.name = p.name; P.nameKo = p.nameKo;
      P.material = p.material; P.materialEn = p.materialEn || p.material;
      P.ratePerSqft = rateFor(p, wIn / 12, hIn / 12);
      P.doubleSidedOffered = !!p.doubleSided;
    }
    window.__dcSelectedProduct = { handle: p.handle, title: p.name, unit: p.unit, widthIn: wIn, heightIn: hIn };
  }

  function applyNow() {
    var api = window.__dcApi;
    if (!api) return;
    var p = state.product, inch = isInch(p);
    var wIn = inch ? state.w : state.w * 12;
    var hIn = inch ? state.h : state.h * 12;

    /* 손님이 고른 값이 그대로 들어가지 않는 경우가 둘 있다 (DC-128).
         · 마감이 없는 상품(스티커·리트랙터블) → 마감은 무조건 'none'
         · 그 상품에 없는 재질이 남아 있으면   → 그 상품의 기본 재질
       예전에는 applied 에 «고른 값», setSpec 에 «다듬은 값» 을 각각 넣어서
       두 벌이 여기서부터 갈라졌다. 한 번만 계산해서 양쪽에 같은 것을 쓴다. */
    var finNow = p.noFinishing ? 'none' : state.fin;
    var matNow = matOk(p, state.mat) ? state.mat : matDef(p);

    // 적용본과 상품 전역을 먼저 — 메인의 단가·규격 칩·마감·재단선이 모두 여기서 나온다
    pushGlobals(p, state.cat, state.w, state.h, finNow, state.qty, matNow);
    everApplied = true;

    // 면 상태를 그다음 — 상품·규격·가격보다 앞이어야 한 박자도 어긋나지 않는다
    try {
      if (api.back && !p.doubleSided) api.removeBackSide();   // 문서에서 실제로 지운다
      if (api.activeSide === 'back') api.setActiveSide('front');
    } catch (e) {}

    /* __dcProd = «이 규격은 어느 상품 것인가» 이름표 (V56-R03).
       본체 setSpec 은 «기존 규격에 새 값을 덮는» 방식이라 모르는 항목도 그대로
       살아남고, 되돌리기는 규격을 통째로 복원하므로 이름표도 함께 따라다닌다.
       재질(spec.material)도 원래 본체에 없던 것을 패치 층이 이렇게 넣어 쓰고 있다 (A19).
       handle 은 겹친다(리트랙터블 «배너만» / «배너+스탠드») — pkey 를 쓴다. */
    api.setSpec({ widthIn: wIn, heightIn: hIn, finishing: finNow,
                  quantity: state.qty, material: matNow, __dcProd: pkey(p) });

    /* 시청 거리는 규격 «뒤» 에, 기록을 남기지 않고 (V56-R03).

       예전에는 규격보다 «앞» 에서 기록을 남기며 바꿨다. 그러면 상품 한 번 바꿀 때
       되돌리기 칸이 두 개 생기고, Ctrl+Z 한 번은 «옛 규격 + 새 상품의 시청 거리» 라는
       중간 상태에 떨어진다 — 상품·규격은 맞는데 저해상도 경고가 사라져 「주문 가능」
       으로 보인다. 규격 뒤에 기록 없이 넣으면 기록에 쌓이는 «이전 상태» 가 옛 시청
       거리를 그대로 들고 있어, 되돌리기 한 번에 상품 변경 전체가 한꺼번에 돌아온다. */
    if (p.viewFt) { try { api.setViewingDistance(p.viewFt, false); } catch (e) {} }
    try { window.dispatchEvent(new CustomEvent('sbdc:product', { detail: window.__dcSelectedProduct })); } catch (e) {}
    logEvent('design_start', p.handle + ' ' + state.w + 'x' + state.h);
    close();
    toast(p.nameKo + ' · ' + state.w + (inch ? '"' : "'") + ' x ' + state.h + (inch ? '"' : "'") + ' set');
  }

  function open() {
    if (!els.ov) buildModal();
    restoreApplied(true);                // 늘 «지금 적용된 상품» 이 골라진 채로 열린다
    if (els.skip) els.skip.textContent = everApplied ? 'Cancel change' : 'Set later';
    sync();
    els.ov.classList.add('is-open');
  }
  function close() {
    if (els.ov) els.ov.classList.remove('is-open');
    restoreApplied();                    // 고르다 만 초안은 버린다
    if (!els.dndTold) {   // 드래그 앤 드롭이 된다는 걸 한 번은 알려 준다
      els.dndTold = true;
      setTimeout(function () { toast('Drop a logo or photo anywhere on the screen to upload it'); }, 700);
    }
  }
  function isOpen() { return !!(els.ov && els.ov.classList.contains('is-open')); }
  /* 시작 팝업을 «첫 방문» 상태로 (A24 · DC-127).
     「담고 다른 상품 디자인」 은 «다른 상품을 고르겠다» 는 뜻인데, 예전에는 팝업이
     방금 주문한 상품·크기를 그대로 물고 열렸다 (실측: 타원형 스티커 5"x3" 주문 뒤
     눌렀더니 팝업이 다시 타원형 스티커 5"x3"). 디자인만 비우고 고르는 자리는
     그대로면 «처음 방문» 이 아니다. 그래서 팝업의 초안·적용본·앱의 규격을 함께 되돌린다. */
  window.__dcResetStart = function () {
    applied = { cat: FIRST.cat, p: FIRST.p, w: FIRST.w, h: FIRST.h,
                qty: FIRST.qty, fin: FIRST.fin, mat: FIRST.mat };
    state.cat = FIRST.cat; state.product = FIRST.p; state.w = FIRST.w; state.h = FIRST.h;
    state.qty = FIRST.qty; state.fin = FIRST.fin; state.mat = FIRST.mat;
    everApplied = false;                       // 「나중에 설정」 문구도 첫 방문과 같아진다
    var inch = isInch(FIRST.p);
    window.__dcInch = inch;
    try {
      var api = window.__dcApi;
      var want = {
        widthIn:  inch ? FIRST.w : FIRST.w * 12,
        heightIn: inch ? FIRST.h : FIRST.h * 12,
        quantity: FIRST.qty,
        finishing: FIRST.p.noFinishing ? 'none' : FIRST.fin,
        material: matOk(FIRST.p, FIRST.mat) ? FIRST.mat : matDef(FIRST.p),
        __dcProd: pkey(FIRST.p)                  // 이름표도 첫 상품 것으로 (V56-R03)
      };
      var sp = api && api.spec;
      // 이미 그 값이면 아예 부르지 않는다 (쓸데없이 다시 그리지 않게)
      var same = !!sp && sp.widthIn === want.widthIn && sp.heightIn === want.heightIn
        && sp.quantity === want.quantity && sp.finishing === want.finishing
        && (sp.material || null) === (want.material || null)
        && (sp.__dcProd || null) === want.__dcProd;
      /* 두 번째 인자 false = «되돌리기 기록을 남기지 말고» 바꾼다.
         첫 방문에는 되돌릴 것이 없으므로 기록도 없어야 한다. 남겨 두면 손님이
         빈 화면에서 Ctrl+Z 를 눌렀을 때 방금 주문한 상품의 규격으로 되돌아가,
         팝업이 보여 주는 상품과 화면 규격이 어긋난다. */
      if (api && api.setSpec && !same) api.setSpec(want, false);
    } catch (e) {}
    try { if (els.ov) sync(); } catch (e) {}
  };

  /* ── 되돌리기 되맞춤 (V56-R03) ────────────────────────────────────
     Ctrl+Z · 다시하기 · 툴바 단추로 기록을 한 칸 옮긴 «뒤» 에 부른다 (sbdc-reset).
     복원된 규격에 붙어 있는 이름표(__dcProd)를 보고 상품 전역을 그 시점 것으로 맞춘다.

     이름표가 없는 옛 기록 — 팝업에서 「나중에 설정」 을 눌러 한 번도 상품을 고르지
     않은 채 만든 기록 — 은 첫 상품(FIRST)으로 본다. 그때 실제로 적용돼 있던 것이
     그것이라 따로 이름표를 심어 둘 필요가 없다.

     돌려주는 값: 무언가 달라졌으면 true. 글자 지우기 같은 평범한 편집의 되돌리기는
     상품도 규격도 그대로라 false 가 나오고, 부르는 쪽은 아무 일도 하지 않는다.
     ──────────────────────────────────────────────────────────────── */
  function prodByKey(k) {
    if (!k) return null;
    for (var i = 0; i < CATALOG.length; i++) {
      var L = CATALOG[i].items;
      for (var j = 0; j < L.length; j++) if (pkey(L[j]) === k) return { p: L[j], cat: i };
    }
    return null;
  }
  window.__dcSyncProductFromSpec = function () {
    var api = window.__dcApi;
    if (!api || !api.spec) return false;
    var sp = api.spec;
    var hit = prodByKey(sp.__dcProd) || { p: FIRST.p, cat: FIRST.cat };
    var inch = isInch(hit.p);
    var w = inch ? sp.widthIn : sp.widthIn / 12;
    var h = inch ? sp.heightIn : sp.heightIn / 12;
    var qty = sp.quantity, fin = sp.finishing, mat = sp.material == null ? null : sp.material;
    if (applied.p === hit.p && applied.cat === hit.cat
      && applied.w === w && applied.h === h && applied.qty === qty
      && applied.fin === fin && (applied.mat || null) === mat) return false;
    pushGlobals(hit.p, hit.cat, w, h, fin, qty, mat);
    /* everApplied 는 건드리지 않는다 — 되돌리기는 「디자인 시작」 을 누른 것이 아니다 */
    try { window.dispatchEvent(new CustomEvent('sbdc:product', { detail: window.__dcSelectedProduct })); } catch (e) {}
    try { if (els.ov) restoreApplied(true); } catch (e) {}   // 팝업이 열려 있으면 초안도 맞춘다
    return true;
  };

  window.__dcOpenStart = open;
  window.__dcToast = toast;          // 다른 스크립트(sbdc-textfit)도 같은 알림 줄을 쓴다

  /* ================================================================ 레이어 생성 */
  function newId(type) {
    return (type || 'layer') + '_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 6);
  }
  function board() {
    var api = window.__dcApi;
    var sp = (api && api.spec) || { widthIn: 96, heightIn: 48 };
    var r = (api && api.geometry && api.geometry.safeRect) || { x: 0, y: 0, width: sp.widthIn, height: sp.heightIn };
    return { sp: sp, r: r };
  }
  /**
   * 방금 넣은 글자를 바로 칠 수 있게 커서를 놓는다.
   *
   * 캔버스 인라인 편집칸은 앱(번들) 안에 있어 밖에서 열 수 없었다. 그래서 번들에
   * `window.__dcEdit(id, 값)` 한 줄을 심어 두고 여기서 부른다. 캔버스가 새 글자를
   * 그리기 전에는 편집칸도 없으므로, 생길 때까지 잠깐 기다렸다 글자를 통째로 고른다
   * — 그래야 «문구를 입력하세요» 를 지우지 않고 그냥 쳐서 덮어쓸 수 있다.
   */
  function editSoon(id, text) {
    var tries = 0;
    (function open() {
      if (typeof window.__dcEdit !== 'function') { if (++tries < 40) setTimeout(open, 30); return; }
      window.__dcEdit(id, text);
      var n = 0;
      (function focus() {
        var el = document.querySelector('textarea.inline-edit');
        if (!el) { if (++n < 40) setTimeout(focus, 25); return; }
        el.focus();
        el.select();
      })();
    })();
  }
  window.__dcEditSoon = editSoon;

  /* 2026-09-08 V0.0.5 — 레이어 패널 줄 더블클릭.
     번들의 레이어 목록(.layer-item .li-main)은 한 번 클릭(고르기)만 안다. 글자 줄을
     더블클릭하면 캔버스 더블클릭과 같은 인라인 편집칸을 `__dcEdit` 로 열고, 잠긴 줄이면
     안내만 띄운다(훅은 잠금을 안 보므로 여기서 막는다). 그림·도형 줄은 아무 일 없음.
     줄 차례는 번들과 같은 규칙: 목록 = doc.layers 를 뒤집은 것. */
  document.addEventListener('dblclick', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.layer-item .li-main');
    var api = window.__dcApi;
    if (!btn || !api || !api.doc) return;
    var li = btn.closest('.layer-item'), rows = li.parentNode.children;
    var L = api.doc.layers[api.doc.layers.length - 1 - Array.prototype.indexOf.call(rows, li)];
    if (!L) return;
    if (L.locked) { toast('This layer is locked — unlock it to edit'); return; }
    if (L.type === 'text' && typeof window.__dcEdit === 'function') window.__dcEdit(L.id, L.text);
  });

  function addTextLayer() {
    var api = window.__dcApi; if (!api) return;
    var b = board(), sp = b.sp;
    var wIn = Math.min(b.r.width || sp.widthIn * .7, sp.widthIn * .8);
    var hIn = Math.max(.4, sp.heightIn * .3);
    var made = {
      id: newId('text'), type: 'text', name: 'Text',
      xIn: Math.max(0, (sp.widthIn - wIn) / 2), yIn: Math.max(0, (sp.heightIn - hIn) / 2),
      widthIn: wIn, heightIn: hIn, rotation: 0, visible: true, locked: false,
      text: 'Enter your text', fontFamily: 'Archivo',
      fontSizeIn: Math.max(.12, Math.min(hIn * .7, sp.heightIn * .22)),
      fill: '#111111', stroke: '#ffffff', strokeWidthIn: 0, align: 'center',
      bold: true, italic: false, lineHeight: 1.15, stretchX: 1, stretchY: 1,
      underline: false, strikethrough: false, listStyle: 'none', curveDeg: 0
    };
    api.addLayer(made);
    editSoon(made.id, made.text);          // 넣자마자 커서를 글자에 놓는다
    toast('Text added — start typing');
  }
  function addImageLayer(src, nw, nh, fileName, isVector) {
    var api = window.__dcApi; if (!api) return;
    var b = board(), sp = b.sp;
    var ratio = (nh / nw) || 1;
    var wIn = Math.max(.25, (b.r.width || sp.widthIn) * .5), hIn = wIn * ratio;
    if (hIn > sp.heightIn * .9) { hIn = sp.heightIn * .9; wIn = hIn / ratio; }
    api.addLayer({
      id: newId('img'), type: 'image', name: fileName || 'Image',
      xIn: Math.max(0, (sp.widthIn - wIn) / 2), yIn: Math.max(0, (sp.heightIn - hIn) / 2),
      widthIn: wIn, heightIn: hIn, rotation: 0, visible: true, locked: false,
      src: src, naturalWidth: nw || 1, naturalHeight: nh || 1,
      fileName: fileName || 'Image', isVector: !!isVector
    });
  }

  /* ================================================================ 드래그 앤 드롭 */
  function handleFiles(files) {
    var list = Array.prototype.slice.call(files || []);
    if (!list.length) return;
    if (window.__dcShrinkFiles && !(files && files.__dcShrunk)) { window.__dcShrinkFiles(list).then(function (out) { out.__dcShrunk = true; handleFiles(out); }); return; }   // sb-dc-imgshrink.js: big photos are shrunk to print size first
    var ok = 0;
    list.forEach(function (f) {
      var name = f.name || '';
      var isImg = /^image\//.test(f.type) || /\.(png|jpe?g|gif|webp|svg)$/i.test(name);
      if (!isImg) return;
      if (f.size > 20 * 1024 * 1024) { toast('Only files up to 20MB can be uploaded: ' + name); return; }
      ok++;
      var vector = /svg/i.test(f.type) || /\.svg$/i.test(name);
      var fr = new FileReader();
      fr.onerror = function () { toast('Could not read the file: ' + name); };
      fr.onload = function () {
        var src = String(fr.result);
        var img = new window.Image();
        img.onerror = function () { toast('Could not recognize the image format: ' + name); };
        img.onload = function () {
          addImageLayer(src, img.naturalWidth || 1000, img.naturalHeight || 1000, name, vector);
          toast(name + ' added');
        };
        img.src = src;
      };
      fr.readAsDataURL(f);
    });
    if (!ok) toast('Only PNG · JPG · GIF · WEBP · SVG files can be uploaded');
  }
  function hasFiles(e) {
    var t = e.dataTransfer && e.dataTransfer.types;
    return !!t && Array.prototype.indexOf.call(t, 'Files') >= 0;
  }
  function initDrop() {
    if (els.drop) return;
    var zone = $('div', 'sbdc-drop', '<div class="sbdc-drop-in"><b>Drop it and it lands on the canvas</b><em>PNG · JPG · GIF · WEBP · SVG · up to 20MB</em></div>');
    document.body.appendChild(zone);
    els.drop = zone;
    var depth = 0;
    window.addEventListener('dragenter', function (e) { if (hasFiles(e)) { depth++; zone.classList.add('is-on'); } });
    window.addEventListener('dragover', function (e) { if (hasFiles(e)) { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; } });
    window.addEventListener('dragleave', function () { depth = Math.max(0, depth - 1); if (!depth) zone.classList.remove('is-on'); });
    window.addEventListener('drop', function (e) {
      if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
      e.preventDefault();
      depth = 0; zone.classList.remove('is-on');
      if (isOpen()) { toast('Choose a product first, then upload an image'); return; }
      handleFiles(e.dataTransfer.files);
    });
  }

  /* ================================================================ 왼쪽 레일 "텍스트" */
  function initRail() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.rail-btn') : null;
      if (!btn) return;
      var label = btn.querySelector('.rail-label');
      if (!label || label.textContent.trim() !== 'Text') return;
      if (btn.getAttribute('aria-pressed') === 'true') return;
      setTimeout(addTextLayer, 60);
    }, true);
  }

  /* ================================================================ 단축키 */
  var KEYS = [
    ['Ctrl / Cmd + C', 'Copy selection'],
    ['Ctrl / Cmd + X', 'Cut'],
    ['Ctrl / Cmd + V', 'Paste (offset 0.5")'],
    ['Ctrl / Cmd + D', 'Duplicate'],
    ['Ctrl / Cmd + Z', 'Undo'],
    ['Ctrl+Shift+Z · Ctrl+Y', 'Redo'],
    ['Delete · Backspace', 'Delete'],
    ['Arrow keys', 'Move 0.25"'],
    ['Shift + arrow keys', 'Move 2"'],
    ['Ctrl / Cmd + ]', 'Bring forward'],
    ['Ctrl / Cmd + [', 'Send backward'],
    ['Ctrl / Cmd + L', 'Lock / unlock'],
    ['Ctrl / Cmd + H', 'Hide / show'],
    ['Ctrl / Cmd + G', 'Align center'],
    ['T', 'Add text now'],
    ['I · S · Q · B · L · F', 'Image · Shape · QR · Background · Layers · Finishing panels'],
    ['Drag and drop images', 'Add straight to the canvas'],
    ['O', 'Open the product · finishing popup'],
    ['Esc', 'Deselect · close popup'],
    ['?', 'This help']
  ];
  function openKeys() {
    if (!els.keys) {
      var ov = $('div', 'sbdc-ov');
      var m = $('div', 'sbdc-modal sbdc-keys');
      var head = $('div', 'sbdc-head');
      head.appendChild($('div', '', '<h2>Shortcuts</h2><p>These work when the canvas has focus. They are off while you are typing text.</p>'));
      var x = $('button', 'sbdc-x', '&times;'); x.type = 'button';
      x.onclick = function () { ov.classList.remove('is-open'); };
      head.appendChild(x); m.appendChild(head);
      var g = $('div', 'sbdc-keygrid');
      KEYS.forEach(function (k) {
        var r = $('div', 'sbdc-keyrow');
        r.appendChild($('span', 'sbdc-kbd', k[0]));
        r.appendChild($('span', '', k[1]));
        g.appendChild(r);
      });
      m.appendChild(g); ov.appendChild(m);
      ov.addEventListener('mousedown', function (e) { if (e.target === ov) ov.classList.remove('is-open'); });
      document.body.appendChild(ov);
      els.keys = ov;
    }
    els.keys.classList.add('is-open');
  }
  function keysOpen() { return !!(els.keys && els.keys.classList.contains('is-open')); }

  function paste() {
    var api = window.__dcApi;
    if (!api || !clipboard) return;
    var c = JSON.parse(JSON.stringify(clipboard));
    c.id = newId(c.type);
    c.xIn = (c.xIn || 0) + .5;
    c.yIn = (c.yIn || 0) + .5;
    c.locked = false;
    api.addLayer(c);
    toast('Paste');
  }

  window.__dcShortcut = function (e) {
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return false;
    // 색 고르개 «판 자체에 포커스» 가 있을 때만 키를 색 조정에 양보한다.
    // 예전에는 판이 화면에 있기만 해도 전부 막아서, 도형을 고르면 도형 패널의
    // 상시 색 고르개 때문에 Ctrl+C/V 가 통째로 죽었다 (검사 5번).
    var _cpe = document.activeElement;
    if (_cpe && _cpe.classList && (_cpe.classList.contains('cp-sv') || _cpe.classList.contains('cp-hue'))) return false;
    if (isOpen() || keysOpen() || enhOpen()) {
      if (e.key === 'Escape') { close(); closeEnh(); if (els.keys) els.keys.classList.remove('is-open'); return true; }
      return true;
    }
    if (document.querySelector('.modal-backdrop')) return false;
    var api = window.__dcApi;
    if (!api) return false;
    var mod = e.metaKey || e.ctrlKey;
    var k = e.key;
    var low = k.length === 1 ? k.toLowerCase() : k;
    var sel = api.selected;
    var editable = sel && !sel.locked;

    if (mod) {
      switch (low) {
        case 'c': if (sel) { clipboard = JSON.parse(JSON.stringify(sel)); toast('Copied'); } e.preventDefault(); return true;
        case 'x': if (editable) { clipboard = JSON.parse(JSON.stringify(sel)); api.removeLayer(sel.id); toast('Cut'); } e.preventDefault(); return true;
        case 'v': paste(); e.preventDefault(); return true;
        case 'd': if (sel) { api.duplicateLayer(sel.id); toast('Duplicated'); } e.preventDefault(); return true;
        case 'z': e.shiftKey ? api.redo() : api.undo(); e.preventDefault(); return true;
        case 'y': api.redo(); e.preventDefault(); return true;
        case 'l': if (sel) { api.updateLayer(sel.id, { locked: !sel.locked }); toast(sel.locked ? 'Unlock' : 'Lock'); } e.preventDefault(); return true;
        case 'h': if (sel) { api.updateLayer(sel.id, { visible: !sel.visible }); toast(sel.visible ? 'Hidden' : 'Show'); } e.preventDefault(); return true;
        case ']': if (editable) api.reorderLayer(sel.id, 1); e.preventDefault(); return true;
        case '[': if (editable) api.reorderLayer(sel.id, -1); e.preventDefault(); return true;
        case 'g':
          if (editable) {
            var r = api.geometry.safeRect;
            api.updateLayer(sel.id, { xIn: r.x + (r.width - sel.widthIn) / 2, yIn: r.y + (r.height - sel.heightIn) / 2 });
            toast('Align center');
          }
          e.preventDefault(); return true;
      }
      return false;
    }

    if (k.indexOf('Arrow') === 0) {
      if (!editable) return false;
      var step = e.shiftKey ? 2 : .25;
      var patch = {};
      if (k === 'ArrowLeft') patch.xIn = sel.xIn - step;
      else if (k === 'ArrowRight') patch.xIn = sel.xIn + step;
      else if (k === 'ArrowUp') patch.yIn = sel.yIn - step;
      else if (k === 'ArrowDown') patch.yIn = sel.yIn + step;
      api.updateLayer(sel.id, patch);
      e.preventDefault();
      return true;
    }

    if (low === 't') { if (window.__dcUI) window.__dcUI.setPanel('text'); addTextLayer(); e.preventDefault(); return true; }
    var panels = { i: 'images', s: 'shapes', q: 'qr', b: 'background', l: 'layers', f: 'finishing' };
    if (panels[low] && window.__dcUI) { window.__dcUI.setPanel(panels[low]); e.preventDefault(); return true; }
    if (low === 'o') { open(); e.preventDefault(); return true; }
    if (k === '?' || (e.shiftKey && k === '/')) { openKeys(); e.preventDefault(); return true; }
    return false;
  };


  /* ================================================================
     저해상도 알림 + Resolution Enhancer
     (알고리즘은 v1 디자인센터(sb-design-center_13.html)에서 그대로 이식)
     ================================================================ */
  function unsharpPass(c, radius, amount, limit) {
    var w = c.width, h = c.height;
    var b = document.createElement('canvas'); b.width = w; b.height = h;
    var bx = b.getContext('2d'); bx.filter = 'blur(' + radius + 'px)'; bx.drawImage(c, 0, 0);
    var ctx = c.getContext('2d');
    var S = ctx.getImageData(0, 0, w, h), B = bx.getImageData(0, 0, w, h);
    var s = S.data, bl = B.data, L = limit || 255;
    for (var i = 0; i < s.length; i += 4) {
      var d0 = (s[i] - bl[i]) * amount, d1 = (s[i + 1] - bl[i + 1]) * amount, d2 = (s[i + 2] - bl[i + 2]) * amount;
      if (d0 > L) d0 = L; else if (d0 < -L) d0 = -L;
      if (d1 > L) d1 = L; else if (d1 < -L) d1 = -L;
      if (d2 > L) d2 = L; else if (d2 < -L) d2 = -L;
      s[i] += d0; s[i + 1] += d1; s[i + 2] += d2;
    }
    ctx.putImageData(S, 0, 0);
  }
  function popPass(c, sat, con) {
    var ctx = c.getContext('2d');
    var im = ctx.getImageData(0, 0, c.width, c.height), d = im.data;
    for (var i = 0; i < d.length; i += 4) {
      var r = d[i], g = d[i + 1], b = d[i + 2];
      var l = 0.299 * r + 0.587 * g + 0.114 * b;
      r = l + (r - l) * sat; g = l + (g - l) * sat; b = l + (b - l) * sat;
      d[i] = (r - 128) * con + 128; d[i + 1] = (g - 128) * con + 128; d[i + 2] = (b - 128) * con + 128;
    }
    ctx.putImageData(im, 0, 0);
  }
  var ENH_PRESETS = {
    natural: { cl: [.18, 160], e: [2.0, 0.9, 50], f: [0.8, .40, 40], pop: [1.04, 1.02] },
    strong:  { cl: [.32, 120], e: [2.4, 1.6, 70], f: [1.0, .65, 50], pop: [1.10, 1.05] },
    max:     { cl: [.45, 100], e: [2.8, 2.3, 90], f: [1.0, .95, 60], pop: [1.16, 1.08] }
  };
  function runEnhance(base, mode) {
    var c = document.createElement('canvas'); c.width = base.width; c.height = base.height;
    c.getContext('2d').drawImage(base, 0, 0);
    var P = ENH_PRESETS[mode] || ENH_PRESETS.strong;
    if (c.width * c.height <= 12e6) {
      unsharpPass(c, Math.max(6, c.width / P.cl[1]), P.cl[0], 255);   // 클래리티 / 로컬 대비
      unsharpPass(c, P.e[0], P.e[1], P.e[2]);                          // 주 엣지 샤프닝
      unsharpPass(c, P.f[0], P.f[1], P.f[2]);                          // 미세 디테일
      popPass(c, P.pop[0], P.pop[1]);                                  // 색 팝
    }
    return c;
  }

  /* ---------------------------------------------------------------- 해상도 판정 */
  function dpiBand(ft) {
    if (ft <= 10) return { minimum: 100, standard: 125, label: 'Near (0–10ft)' };
    if (ft <= 25) return { minimum: 72, standard: 125, label: 'Medium (10–25ft)' };
    return { minimum: 36, standard: 125, label: 'Far (25ft+)' };
  }
  function dpiOf(l) {
    return Math.min((l.naturalWidth || 1) / Math.max(.01, l.widthIn), (l.naturalHeight || 1) / Math.max(.01, l.heightIn));
  }
  function worstImage() {
    var api = window.__dcApi;
    if (!api || !api.doc) return null;
    var band = dpiBand(api.doc.viewingDistanceFt || 15);
    var worst = null;
    api.doc.layers.forEach(function (l) {
      if (l.type !== 'image' || !l.visible || l.isVector) return;
      var d = dpiOf(l);
      if (d >= band.standard) return;
      if (!worst || d < worst.dpi) worst = { layer: l, dpi: d, band: band };
    });
    return worst;
  }

  /* ---------------------------------------------------------------- 알림 바 */
  var lowresDismissed = {};
  function ensureNotice() {
    var fb = document.querySelector('.floatbar');
    if (!fb || !fb.parentNode) return null;
    if (els.low && els.low.parentNode === fb.parentNode) return els.low;
    var n = $('div', 'sbdc-lowres');
    n.innerHTML = '<span class="sbdc-lowres-dpi"></span><div class="sbdc-lowres-txt"><b></b><em></em></div>';
    var btn = $('button', 'sbdc-enh-btn', 'Improve resolution');
    btn.type = 'button';
    var x = $('button', 'sbdc-lowres-x', '&times;');
    x.type = 'button'; x.title = 'Close';
    n.appendChild(btn); n.appendChild(x);
    fb.parentNode.appendChild(n);   // React 자식들 뒤에 붙여야 재조정에 안 밀린다
    els.low = n;
    els.lowDpi = n.querySelector('.sbdc-lowres-dpi');
    els.lowTitle = n.querySelector('.sbdc-lowres-txt b');
    els.lowSub = n.querySelector('.sbdc-lowres-txt em');
    btn.onclick = function () { if (els.lowTarget) startEnhance(els.lowTarget.layer); };
    x.onclick = function () { if (els.lowTarget) lowresDismissed[els.lowTarget.layer.id] = true; n.classList.remove('is-on'); };
    return n;
  }
  function refreshNotice() {
    var n = ensureNotice();
    if (!n) return;
    var w = worstImage();
    els.lowTarget = w;
    if (!w || lowresDismissed[w.layer.id]) { n.classList.remove('is-on'); return; }
    var dpi = Math.round(w.dpi);
    var blocking = w.dpi < w.band.minimum;
    n.classList.toggle('is-block', blocking);
    n.classList.add('is-on');
    els.lowDpi.textContent = dpi + ' DPI';
    els.lowTitle.textContent = blocking
      ? '"' + w.layer.name + '" does not have enough resolution'
      : '"' + w.layer.name + '" is low resolution';
    els.lowSub.textContent = 'at print size ' + dpi + ' DPI · recommended ' + w.band.standard + ' DPI (' + w.band.label + ' floor ' + w.band.minimum + ')';
  }

  /* ---------------------------------------------------------------- 인핸서 모달 */
  var pendingEnh = null, enhFocus = { x: .5, y: .5 }, ENH_Z = 4;

  function buildEnhModal() {
    var ov = $('div', 'sbdc-ov');
    var m = $('div', 'sbdc-modal sbdc-enh');
    var head = $('div', 'sbdc-head');
    var ttl = $('div', '', '<h2 id="sbdc-enh-title">Enhance resolution</h2><p>Compare the upscaled and sharpened result against the original, then apply.</p>');
    head.appendChild(ttl);
    var x = $('button', 'sbdc-x', '&times;'); x.type = 'button';
    x.onclick = closeEnh; head.appendChild(x);
    m.appendChild(head);

    var body = $('div', 'sbdc-enh-body');
    els.chips = $('div', 'sbdc-chips');
    [['natural', 'Natural'], ['strong', 'Strong'], ['max', 'Max']].forEach(function (c) {
      var b = $('button', 'sbdc-chip' + (c[0] === 'strong' ? ' is-on' : ''), c[1]);
      b.type = 'button'; b.setAttribute('data-str', c[0]);
      b.onclick = function () { setStrength(c[0]); };
      els.chips.appendChild(b);
    });
    body.appendChild(els.chips);

    els.cmp = $('div', 'sbdc-cmp');
    els.nav = document.createElement('img'); els.nav.draggable = false;
    els.focus = $('div', 'sbdc-focus');
    els.cmp.appendChild(els.nav);
    els.cmp.appendChild(els.focus);
    els.cmp.appendChild($('span', 'sbdc-cmp-tag', 'Drag to choose the area to zoom into'));
    body.appendChild(els.cmp);

    var row = $('div', 'sbdc-det-row');
    els.detB = $('div', 'sbdc-det'); els.detBLab = $('b', '', 'Before'); els.detB.appendChild(els.detBLab);
    els.detA = $('div', 'sbdc-det'); els.detALab = $('b', '', 'After'); els.detA.appendChild(els.detALab);
    row.appendChild(els.detB); row.appendChild(els.detA);
    body.appendChild(row);
    body.appendChild($('p', 'sbdc-note', 'Move the orange box on the image above and the two panes below show that area at the original (Before) and enhanced (After) quality.'));
    m.appendChild(body);

    var foot = $('div', 'sbdc-foot');
    foot.appendChild($('span', 'sbdc-sp'));
    var cancel = $('button', 'sbdc-ghost', 'Cancel'); cancel.type = 'button'; cancel.onclick = closeEnh;
    var apply = $('button', 'sbdc-go', 'Apply'); apply.type = 'button'; apply.onclick = applyEnh;
    foot.appendChild(cancel); foot.appendChild(apply);
    m.appendChild(foot);

    ov.appendChild(m);
    ov.addEventListener('mousedown', function (e) { if (e.target === ov) closeEnh(); });
    document.body.appendChild(ov);
    els.enhOv = ov;

    var drag = false;
    var move = function (e) {
      if (!drag) return;
      var r = els.cmp.getBoundingClientRect();
      enhFocus = { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
      updateEnhViews();
    };
    els.cmp.addEventListener('pointerdown', function (e) { drag = true; try { els.cmp.setPointerCapture(e.pointerId); } catch (er) {} move(e); });
    els.cmp.addEventListener('pointermove', move);
    els.cmp.addEventListener('pointerup', function () { drag = false; });
    window.addEventListener('resize', function () { if (enhOpen()) updateEnhViews(); });
    return ov;
  }
  function enhOpen() { return !!(els.enhOv && els.enhOv.classList.contains('is-open')); }
  function closeEnh() { pendingEnh = null; if (els.enhOv) els.enhOv.classList.remove('is-open'); }

  function startEnhance(layer) {
    var api = window.__dcApi; if (!api || !layer) return;
    toast('Enhancing the image…');
    setTimeout(function () {
      var el = new window.Image();
      el.onerror = function () { toast('Could not read the image'); };
      el.onload = function () {
        var nw0 = el.naturalWidth || el.width, nh0 = el.naturalHeight || el.height;
        var cap = 3200, factor = 2;
        if (Math.max(nw0, nh0) * factor > cap) factor = cap / Math.max(nw0, nh0);
        if (factor <= 1.05) { toast('Already at the maximum size'); return; }
        var base = document.createElement('canvas');
        base.width = Math.round(nw0 * factor); base.height = Math.round(nh0 * factor);
        var x = base.getContext('2d');
        x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
        x.drawImage(el, 0, 0, base.width, base.height);
        var c = runEnhance(base, 'strong');
        var bc = document.createElement('canvas'); bc.width = nw0; bc.height = nh0;
        bc.getContext('2d').drawImage(el, 0, 0);
        pendingEnh = {
          layerId: layer.id, base: base, factor: factor, nw0: nw0, nh0: nh0,
          cw: c.width, ch: c.height, strength: 'strong',
          beforeURL: bc.toDataURL('image/png'), afterURL: c.toDataURL('image/png')
        };
        openEnhModal();
      };
      el.src = layer.src;
    }, 40);
  }
  function setStrength(mode) {
    if (!pendingEnh) return;
    Array.prototype.forEach.call(els.chips.children, function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-str') === mode);
    });
    toast('Recalculating…');
    setTimeout(function () {
      var c = runEnhance(pendingEnh.base, mode);
      pendingEnh.afterURL = c.toDataURL('image/png');
      pendingEnh.strength = mode;
      els.detA.style.backgroundImage = 'url(' + pendingEnh.afterURL + ')';
      updateEnhViews();
    }, 30);
  }
  function openEnhModal() {
    if (!els.enhOv) buildEnhModal();
    var p = pendingEnh;
    document.getElementById('sbdc-enh-title').textContent = 'Enhance · upscale x' + p.factor.toFixed(1);
    els.nav.src = p.beforeURL;
    els.detB.style.backgroundImage = 'url(' + p.beforeURL + ')';
    els.detA.style.backgroundImage = 'url(' + p.afterURL + ')';
    els.detBLab.textContent = 'Before · ' + p.nw0 + ' x ' + p.nh0 + ' px';
    els.detALab.textContent = 'After · ' + p.cw + ' x ' + p.ch + ' px';
    enhFocus = { x: .5, y: .5 };
    Array.prototype.forEach.call(els.chips.children, function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-str') === 'strong');
    });
    els.enhOv.classList.add('is-open');
    requestAnimationFrame(updateEnhViews);
  }
  function updateEnhViews() {
    var p = pendingEnh; if (!p) return;
    var topW = els.nav.clientWidth, topH = els.nav.clientHeight;
    if (!topW || !topH) { requestAnimationFrame(updateEnhViews); return; }
    var dw = els.detB.clientWidth, dh = els.detB.clientHeight;
    var ratio = p.nh0 / p.nw0;
    // After 가 자기 원본 픽셀(1:1) 이상으로 그려지도록 확대 — 안 그러면 브라우저 축소로 둘이 똑같아 보인다
    var bgW = Math.max(ENH_Z * dw, p.cw), bgH = bgW * ratio;
    var fracX = Math.min(1, dw / bgW), fracY = Math.min(1, dh / bgH);
    var fx = Math.max(fracX / 2, Math.min(1 - fracX / 2, enhFocus.x));
    var fy = Math.max(fracY / 2, Math.min(1 - fracY / 2, enhFocus.y));
    [els.detB, els.detA].forEach(function (el) {
      el.style.backgroundSize = bgW + 'px ' + bgH + 'px';
      el.style.backgroundPosition = (-(fx - fracX / 2) * bgW) + 'px ' + (-(fy - fracY / 2) * bgH) + 'px';
    });
    els.focus.style.width = (topW * fracX) + 'px';
    els.focus.style.height = (topH * fracY) + 'px';
    els.focus.style.left = ((fx - fracX / 2) * topW) + 'px';
    els.focus.style.top = ((fy - fracY / 2) * topH) + 'px';
  }
  function applyEnh() {
    var p = pendingEnh, api = window.__dcApi;
    if (!p || !api) return;
    api.updateLayer(p.layerId, { src: p.afterURL, naturalWidth: p.cw, naturalHeight: p.ch });
    toast('Upscale x' + p.factor.toFixed(1) + ' applied');
    closeEnh();
    setTimeout(refreshNotice, 120);
  }


  /* ================================================================
     선거(캠페인) 템플릿 — 상품 비율에 맞춰 그 자리에서 조판된다
     T = 텍스트 팩토리, S = 도형 팩토리 (앱 내부 것을 그대로 받음)
     이름·직책·날짜는 전부 예시 문구라 고객이 바꿔 쓰면 된다
     ================================================================ */
  var VC = {
    navy: '#0A2A5E', deep: '#071A3C', red: '#C8102E', crimson: '#9E0B22',
    gold: '#F2C230', cream: '#F6F1E4', white: '#FFFFFF', ink: '#16233A',
    sky: '#2E6FB7', slate: '#5A6B85', mint: '#0E7C66'
  };
  // 폰트별 대략적인 글자 폭 비율 (폰트크기 대비)
  var VW = { 'Anton': .42, 'Bebas Neue': .38, 'Oswald': .46, 'Archivo': .55, 'Montserrat': .58, 'Noto Sans KR': .62 };
  function fitFont(text, boxW, boxH, cap, font) {
    var lines = String(text).split('\n');
    var longest = 1;
    lines.forEach(function (l) { longest = Math.max(longest, l.length); });
    var wf = VW[font] || .55;
    return Math.max(.06, Math.min(cap || 999, boxW / (longest * wf), boxH / (lines.length * 1.18)));
  }
  // 가운데 정렬 텍스트 한 줄
  function line(T, o) {
    var f = o.font || 'Archivo';
    return T({
      name: o.name || o.text.slice(0, 18),
      text: o.text, fontFamily: f,
      xIn: o.x, yIn: o.y, widthIn: o.w, heightIn: o.h,
      fontSizeIn: o.size || fitFont(o.text, o.w, o.h, o.cap, f),
      fill: o.fill, align: o.align || 'center', bold: o.bold !== false,
      stroke: o.stroke || '#ffffff', strokeWidthIn: o.strokeW || 0,
      lineHeight: o.lh || 1.1
    });
  }
  function band(S, o) {
    return S({ name: o.name || 'Bar', xIn: o.x, yIn: o.y, widthIn: o.w, heightIn: o.h, fill: o.fill, allowBleed: o.bleed !== false, cornerRadiusIn: o.r || 0 });
  }
  function starRow(S, x, y, w, h, n, fill) {
    var out = [], gap = w / n;
    for (var i = 0; i < n; i++) {
      out.push(S({ name: 'Star', shape: 'star', starPoints: 5, starInnerRatio: .45,
        xIn: x + gap * i + (gap - h) / 2, yIn: y, widthIn: h, heightIn: h, fill: fill }));
    }
    return out;
  }

  var VOTE_TPL = [
    /* ---------------------------------------------------- 가로형 (배너·백드롭) */
    { id: 'vote-classic', name: 'VOTE · Classic', industry: 'Election · Horizontal', background: VC.navy,
      swatch: [VC.navy, VC.gold], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        return [
          band(S, { y: 0, x: 0, w: W, h: H * .06, fill: VC.red, name: 'Top bar' }),
          band(S, { y: H * .94, x: 0, w: W, h: H * .06, fill: VC.red, name: 'Bottom bar' }),
          line(T, { text: 'VOTE', font: 'Anton', x: W * .05, y: H * .12, w: W * .9, h: H * .17, fill: VC.gold, name: 'VOTE' }),
          line(T, { text: 'JORDAN ELLIS', font: 'Anton', x: W * .04, y: H * .30, w: W * .92, h: H * .30, fill: VC.white, name: 'Candidate name' }),
          line(T, { text: 'FOR CITY COUNCIL', font: 'Oswald', x: W * .06, y: H * .63, w: W * .88, h: H * .12, fill: VC.gold, name: 'Title' }),
          line(T, { text: 'NOVEMBER 3', font: 'Archivo', x: W * .06, y: H * .77, w: W * .88, h: H * .09, fill: VC.white, name: 'Election day' })
        ];
      } },

    { id: 'vote-block', name: 'VOTE · Color Block', industry: 'Election · Horizontal', background: VC.white,
      swatch: [VC.red, VC.navy], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        var bw = W * .26;
        return [
          band(S, { x: 0, y: 0, w: bw, h: H, fill: VC.red, name: 'Left block' }),
          line(T, { text: 'VOTE', font: 'Anton', x: bw * .08, y: H * .34, w: bw * .84, h: H * .32, fill: VC.white, name: 'VOTE' }),
          line(T, { text: 'MARIA CHEN', font: 'Anton', x: bw + W * .04, y: H * .20, w: W - bw - W * .08, h: H * .32, fill: VC.navy, align: 'left', name: 'Candidate name' }),
          band(S, { x: bw + W * .04, y: H * .56, w: (W - bw) * .30, h: H * .035, fill: VC.red, bleed: false, name: 'Underline' }),
          line(T, { text: 'FOR MAYOR  ·  NOVEMBER 3', font: 'Oswald', x: bw + W * .04, y: H * .64, w: W - bw - W * .08, h: H * .13, fill: VC.ink, align: 'left', name: 'Title · Date' })
        ];
      } },

    { id: 'reelect-serif', name: 'RE-ELECT · Minimal', industry: 'Election · Horizontal', background: VC.cream,
      swatch: [VC.cream, VC.navy], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        return [
          line(T, { text: 'RE-ELECT', font: 'Oswald', x: W * .1, y: H * .12, w: W * .8, h: H * .12, fill: VC.red, cap: H * .12, name: 'Lead' }),
          line(T, { text: 'DANIEL PARK', font: 'Anton', x: W * .05, y: H * .27, w: W * .9, h: H * .34, fill: VC.navy, name: 'Candidate name' }),
          band(S, { x: W * .35, y: H * .655, w: W * .30, h: H * .022, fill: VC.navy, bleed: false, name: 'Divider' }),
          line(T, { text: 'COUNTY COMMISSIONER  ·  DISTRICT 4', font: 'Archivo', x: W * .08, y: H * .72, w: W * .84, h: H * .11, fill: VC.ink, name: 'Title' })
        ];
      } },

    { id: 'vote-stars', name: 'VOTE · Star Line', industry: 'Election · Horizontal', background: VC.deep,
      swatch: [VC.deep, VC.gold], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        return starRow(S, W * .30, H * .08, W * .40, H * .10, 5, VC.gold).concat([
          line(T, { text: 'ALEX RIVERA', font: 'Anton', x: W * .04, y: H * .24, w: W * .92, h: H * .34, fill: VC.white, name: 'Candidate name' }),
          band(S, { x: 0, y: H * .62, w: W, h: H * .20, fill: VC.red, name: 'Bottom bar' }),
          line(T, { text: 'FOR STATE SENATE', font: 'Oswald', x: W * .06, y: H * .645, w: W * .88, h: H * .145, fill: VC.white, name: 'Title' })
        ]);
      } },

    { id: 'flag-band', name: 'Tri-color band', industry: 'Election · Horizontal', background: VC.white,
      swatch: [VC.red, VC.sky], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        return [
          band(S, { x: 0, y: 0, w: W, h: H * .13, fill: VC.navy, name: 'Top bar' }),
          band(S, { x: 0, y: H * .87, w: W, h: H * .13, fill: VC.red, name: 'Bottom bar' }),
          line(T, { text: 'ELECT', font: 'Oswald', x: W * .1, y: H * .19, w: W * .8, h: H * .12, fill: VC.red, cap: H * .12, name: 'Lead' }),
          line(T, { text: 'SARAH LOPEZ', font: 'Anton', x: W * .04, y: H * .33, w: W * .92, h: H * .30, fill: VC.navy, name: 'Candidate name' }),
          line(T, { text: 'SCHOOL BOARD  ·  VOTE NOV 3', font: 'Archivo', x: W * .08, y: H * .67, w: W * .84, h: H * .12, fill: VC.ink, name: 'Title · Date' })
        ];
      } },

    { id: 'early-voting', name: 'Early voting notice', industry: 'Election · Notice', background: VC.gold,
      swatch: [VC.gold, VC.navy], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        return [
          line(T, { text: 'EARLY VOTING', font: 'Anton', x: W * .04, y: H * .10, w: W * .92, h: H * .30, fill: VC.navy, name: 'Headline' }),
          band(S, { x: W * .06, y: H * .45, w: W * .88, h: H * .30, fill: VC.navy, bleed: false, r: H * .03, name: 'Info box' }),
          line(T, { text: 'OCT 21 – NOV 1  ·  8AM – 6PM', font: 'Oswald', x: W * .08, y: H * .49, w: W * .84, h: H * .10, fill: VC.gold, name: 'Dates' }),
          line(T, { text: 'CITY HALL  ·  123 MAIN STREET', font: 'Archivo', x: W * .08, y: H * .61, w: W * .84, h: H * .09, fill: VC.white, name: 'Place' }),
          line(T, { text: 'Please bring photo ID', font: 'Noto Sans KR', x: W * .08, y: H * .79, w: W * .84, h: H * .09, fill: VC.navy, bold: false, name: 'Info' })
        ];
      } },

    { id: 'polling-place', name: 'VOTE HERE · Polling place', industry: 'Election · Notice', background: VC.white,
      swatch: [VC.navy, VC.red], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        var bw = W * .38;
        return [
          band(S, { x: 0, y: 0, w: bw, h: H, fill: VC.navy, name: 'Left block' }),
          line(T, { text: 'VOTE\nHERE', font: 'Anton', x: bw * .08, y: H * .18, w: bw * .84, h: H * .64, fill: VC.white, lh: 1.02, name: 'VOTE HERE' }),
          line(T, { text: 'POLLING PLACE', font: 'Oswald', x: bw + W * .04, y: H * .22, w: W - bw - W * .08, h: H * .18, fill: VC.red, align: 'left', name: 'Headline' }),
          line(T, { text: 'OPEN 7AM – 8PM  ·  NOV 3', font: 'Archivo', x: bw + W * .04, y: H * .45, w: W - bw - W * .08, h: H * .12, fill: VC.ink, align: 'left', name: 'Hours' }),
          line(T, { text: 'PARKING IN REAR', font: 'Archivo', x: bw + W * .04, y: H * .62, w: W - bw - W * .08, h: H * .09, fill: VC.slate, align: 'left', bold: false, name: 'Subtext' })
        ];
      } },

    { id: 'thank-you', name: 'Thank you', industry: 'Election · Horizontal', background: VC.navy,
      swatch: [VC.navy, VC.gold], native: true, fit: ['wide'],
      build: function (W, H, T, S) {
        return [
          line(T, { text: 'THANK YOU', font: 'Anton', x: W * .04, y: H * .16, w: W * .92, h: H * .34, fill: VC.gold, name: 'Headline' }),
          line(T, { text: 'FOR YOUR VOTE', font: 'Oswald', x: W * .06, y: H * .53, w: W * .88, h: H * .16, fill: VC.white, name: 'Sub' })
        ].concat(starRow(S, W * .38, H * .74, W * .24, H * .09, 3, VC.red));
      } },

    /* ---------------------------------------------------- 세로형 (리트랙터블 · X배너) */
    { id: 'tall-profile', name: 'Profile (Vertical)', industry: 'Election · Vertical', background: VC.white,
      swatch: [VC.navy, VC.red], native: true, fit: ['tall'],
      build: function (W, H, T, S) {
        return [
          band(S, { x: 0, y: 0, w: W, h: H * .40, fill: VC.navy, name: 'Top block (photo area)' }),
          line(T, { text: 'VOTE', font: 'Anton', x: W * .1, y: H * .05, w: W * .8, h: H * .10, fill: VC.gold, name: 'VOTE' }),
          line(T, { text: 'Put the candidate photo here', font: 'Noto Sans KR', x: W * .1, y: H * .24, w: W * .8, h: H * .05, fill: '#7C93B8', bold: false, name: 'Photo note' }),
          line(T, { text: 'JORDAN ELLIS', font: 'Anton', x: W * .05, y: H * .44, w: W * .9, h: H * .10, fill: VC.navy, name: 'Candidate name' }),
          band(S, { x: W * .32, y: H * .555, w: W * .36, h: H * .008, fill: VC.red, bleed: false, name: 'Divider' }),
          line(T, { text: 'FOR CITY COUNCIL', font: 'Oswald', x: W * .08, y: H * .58, w: W * .84, h: H * .05, fill: VC.red, name: 'Title' }),
          line(T, { text: 'SAFER STREETS\nBETTER SCHOOLS\nLOWER TAXES', font: 'Archivo', x: W * .1, y: H * .67, w: W * .8, h: H * .16, fill: VC.ink, lh: 1.5, name: 'Pledge' }),
          band(S, { x: 0, y: H * .90, w: W, h: H * .10, fill: VC.navy, name: 'Bottom bar' }),
          line(T, { text: 'JORDANELLIS.COM  ·  NOV 3', font: 'Archivo', x: W * .06, y: H * .925, w: W * .88, h: H * .05, fill: VC.white, name: 'Website' })
        ];
      } },

    { id: 'tall-bold', name: 'Bold Stack (Vertical)', industry: 'Election · Vertical', background: VC.deep,
      swatch: [VC.deep, VC.gold], native: true, fit: ['tall'],
      build: function (W, H, T, S) {
        return [
          band(S, { x: 0, y: 0, w: W, h: H * .05, fill: VC.red, name: 'Top bar' }),
          line(T, { text: 'ELECT', font: 'Oswald', x: W * .1, y: H * .10, w: W * .8, h: H * .06, fill: VC.gold, name: 'Lead' }),
          line(T, { text: 'MARIA\nCHEN', font: 'Anton', x: W * .05, y: H * .19, w: W * .9, h: H * .26, fill: VC.white, lh: 1.0, name: 'Candidate name' }),
          band(S, { x: W * .1, y: H * .48, w: W * .8, h: H * .006, fill: VC.gold, bleed: false, name: 'Divider' })
        ].concat(starRow(S, W * .3, H * .52, W * .4, W * .12, 3, VC.gold)).concat([
          line(T, { text: 'FOR MAYOR', font: 'Oswald', x: W * .08, y: H * .66, w: W * .84, h: H * .07, fill: VC.white, name: 'Title' }),
          line(T, { text: 'A CITY THAT WORKS\nFOR EVERYONE', font: 'Archivo', x: W * .1, y: H * .76, w: W * .8, h: H * .10, fill: VC.gold, lh: 1.35, bold: false, name: 'Slogan' }),
          line(T, { text: 'VOTE NOVEMBER 3', font: 'Archivo', x: W * .1, y: H * .91, w: W * .8, h: H * .05, fill: VC.white, name: 'Election day' })
        ]);
      } },

    { id: 'tall-stripe', name: 'Side Stripe (Vertical)', industry: 'Election · Vertical', background: VC.cream,
      swatch: [VC.red, VC.navy], native: true, fit: ['tall'],
      build: function (W, H, T, S) {
        var sw = W * .10;
        return [
          band(S, { x: 0, y: 0, w: sw, h: H, fill: VC.navy, name: 'Left bar' }),
          band(S, { x: sw, y: 0, w: sw * .5, h: H, fill: VC.red, name: 'Left bar 2' }),
          line(T, { text: 'VOTE', font: 'Anton', x: W * .22, y: H * .08, w: W * .70, h: H * .09, fill: VC.red, align: 'left', name: 'VOTE' }),
          line(T, { text: 'DANIEL\nPARK', font: 'Anton', x: W * .22, y: H * .19, w: W * .72, h: H * .22, fill: VC.navy, align: 'left', lh: 1.0, name: 'Candidate name' }),
          line(T, { text: 'COUNTY COMMISSIONER', font: 'Oswald', x: W * .22, y: H * .45, w: W * .72, h: H * .05, fill: VC.ink, align: 'left', name: 'Title' }),
          band(S, { x: W * .22, y: H * .53, w: W * .5, h: H * .006, fill: VC.red, bleed: false, name: 'Divider' }),
          line(T, { text: '“Building a better\nneighborhood together”', font: 'Noto Sans KR', x: W * .22, y: H * .58, w: W * .72, h: H * .12, fill: VC.navy, align: 'left', lh: 1.45, bold: false, name: 'Slogan' }),
          line(T, { text: 'NOVEMBER 3', font: 'Anton', x: W * .22, y: H * .84, w: W * .72, h: H * .08, fill: VC.red, align: 'left', name: 'Election day' })
        ];
      } },

    { id: 'tall-clean', name: 'White Minimal (Vertical)', industry: 'Election · Vertical', background: VC.white,
      swatch: [VC.white, VC.mint], native: true, fit: ['tall'],
      build: function (W, H, T, S) {
        return [
          band(S, { x: 0, y: 0, w: W, h: H * .012, fill: VC.mint, name: 'Top line' }),
          line(T, { text: 'VOTE', font: 'Bebas Neue', x: W * .1, y: H * .12, w: W * .8, h: H * .12, fill: VC.mint, name: 'VOTE' }),
          line(T, { text: 'SARAH\nLOPEZ', font: 'Anton', x: W * .06, y: H * .28, w: W * .88, h: H * .24, fill: VC.ink, lh: 1.0, name: 'Candidate name' }),
          line(T, { text: 'SCHOOL BOARD · DISTRICT 4', font: 'Archivo', x: W * .08, y: H * .56, w: W * .84, h: H * .05, fill: VC.slate, bold: false, name: 'Title' }),
          band(S, { x: W * .4, y: H * .64, w: W * .2, h: H * .006, fill: VC.mint, bleed: false, name: 'Divider' }),
          line(T, { text: 'LISTEN. SERVE.\nDELIVER.', font: 'Oswald', x: W * .1, y: H * .69, w: W * .8, h: H * .12, fill: VC.mint, lh: 1.3, name: 'Slogan' }),
          line(T, { text: 'SARAHLOPEZ.COM', font: 'Archivo', x: W * .1, y: H * .90, w: W * .8, h: H * .05, fill: VC.ink, name: 'Website' })
        ];
      } },

    /* ---------------------------------------------------- 어디에나 (스티커 포함) */
    { id: 'chip-vote', name: 'VOTE Bar (sticker)', industry: 'Election · Sticker', background: VC.navy,
      swatch: [VC.navy, VC.gold], native: true, fit: ['wide', 'tall', 'square'],
      build: function (W, H, T, S) {
        var tall = H > W;
        if (tall) {
          return [
            line(T, { text: 'VOTE', font: 'Anton', x: W * .08, y: H * .12, w: W * .84, h: H * .26, fill: VC.gold, name: 'VOTE' }),
            line(T, { text: 'JORDAN\nELLIS', font: 'Anton', x: W * .06, y: H * .42, w: W * .88, h: H * .32, fill: VC.white, lh: 1.02, name: 'Candidate name' }),
            line(T, { text: 'NOV 3', font: 'Oswald', x: W * .1, y: H * .80, w: W * .8, h: H * .10, fill: VC.gold, name: 'Election day' })
          ];
        }
        return [
          band(S, { x: 0, y: 0, w: W * .30, h: H, fill: VC.gold, name: 'Left block' }),
          line(T, { text: 'VOTE', font: 'Anton', x: W * .02, y: H * .30, w: W * .26, h: H * .40, fill: VC.navy, name: 'VOTE' }),
          line(T, { text: 'JORDAN ELLIS', font: 'Anton', x: W * .33, y: H * .22, w: W * .64, h: H * .34, fill: VC.white, name: 'Candidate name' }),
          line(T, { text: 'FOR CITY COUNCIL', font: 'Archivo', x: W * .33, y: H * .60, w: W * .64, h: H * .16, fill: VC.gold, name: 'Title' })
        ];
      } },

    { id: 'badge-round', name: 'Badge (round sticker)', industry: 'Election · Sticker', background: VC.red,
      swatch: [VC.red, VC.white], native: true, fit: ['square', 'wide', 'tall'],
      build: function (W, H, T, S) {
        var d = Math.min(W, H);
        return [
          S({ name: 'White circle', shape: 'ellipse', xIn: (W - d * .88) / 2, yIn: (H - d * .88) / 2, widthIn: d * .88, heightIn: d * .88, fill: VC.white }),
          S({ name: 'Red circle', shape: 'ellipse', xIn: (W - d * .80) / 2, yIn: (H - d * .80) / 2, widthIn: d * .80, heightIn: d * .80, fill: VC.red }),
          line(T, { text: 'VOTE', font: 'Anton', x: (W - d * .62) / 2, y: H / 2 - d * .30, w: d * .62, h: d * .20, fill: VC.white, name: 'VOTE' }),
          line(T, { text: 'MARIA CHEN', font: 'Anton', x: (W - d * .68) / 2, y: H / 2 - d * .08, w: d * .68, h: d * .18, fill: VC.gold, name: 'Candidate name' }),
          line(T, { text: 'NOV 3', font: 'Oswald', x: (W - d * .5) / 2, y: H / 2 + d * .14, w: d * .5, h: d * .12, fill: VC.white, name: 'Election day' })
        ];
      } },

    { id: 'chip-clean', name: 'White Label (sticker)', industry: 'Election · Sticker', background: VC.white,
      swatch: [VC.white, VC.navy], native: true, fit: ['wide', 'tall', 'square'],
      build: function (W, H, T, S) {
        return [
          line(T, { text: 'ELECT', font: 'Oswald', x: W * .08, y: H * .16, w: W * .84, h: H * .16, fill: VC.red, name: 'Lead' }),
          line(T, { text: 'ALEX RIVERA', font: 'Anton', x: W * .05, y: H * .34, w: W * .9, h: H * .30, fill: VC.navy, name: 'Candidate name' }),
          band(S, { x: W * .35, y: H * .68, w: W * .3, h: H * .04, fill: VC.red, bleed: false, name: 'Underline' }),
          line(T, { text: 'STATE SENATE', font: 'Archivo', x: W * .1, y: H * .76, w: W * .8, h: H * .13, fill: VC.ink, name: 'Title' })
        ];
      } }
  ];

  window.__VOTE_TPL = VOTE_TPL;   // 테스트 훅
  // 앱의 템플릿 목록에 현재 상품 비율에 맞는 선거 템플릿을 덧붙인다
  window.__dcTemplateList = function (base) {
    var api = window.__dcApi;
    var sp = (api && api.spec) || { widthIn: 120, heightIn: 36 };
    var r = sp.widthIn / Math.max(.01, sp.heightIn);
    var bucket = r >= 1.35 ? 'wide' : (r <= .8 ? 'tall' : 'square');
    var fits = function (t) {
      return t.fit.indexOf(bucket) >= 0 || (bucket === 'square' && t.fit.indexOf('wide') >= 0);
    };
    var mine = VOTE_TPL.filter(fits);
    var admin = remoteTpls.filter(fits);
    var adminFirst = !(dcSettings.tpl_order && dcSettings.tpl_order.admin_first === false);
    return (adminFirst ? admin.concat(mine) : mine.concat(admin)).concat(base);
  };


  /* ================================================================
     스티커 아트보드를 실제 재단 문양(원형·타원·라운드 사각)으로
     ================================================================ */
  var DIE = {
    'round-stickers': { kind: 'ellipse', label: 'Round cut line' },
    'oval-stickers': { kind: 'ellipse', label: 'Oval cut line' },
    'kiss-cut-stickers': { kind: 'round', frac: .14, label: 'Shape cut line (example)' },
    'bumper-stickers': { kind: 'round', rIn: .25, label: 'Rounded corner cut line' }
  };
  window.__dcDieShape = function () {
    var p = AP();
    return (p && DIE[p.handle]) || null;
  };
  function radiusPx(s, w, h, E) {
    if (s.rIn != null) return Math.min(s.rIn * (E || 1), Math.min(w, h) / 2);
    return Math.min(w, h) * (s.frac || .12);
  }
  function pathRound(ctx, w, h, r) {
    ctx.moveTo(r, 0);
    ctx.lineTo(w - r, 0); ctx.arcTo(w, 0, w, r, r);
    ctx.lineTo(w, h - r); ctx.arcTo(w, h, w - r, h, r);
    ctx.lineTo(r, h); ctx.arcTo(0, h, 0, h - r, r);
    ctx.lineTo(0, r); ctx.arcTo(0, 0, r, 0, r);
    ctx.closePath();
  }
  // Konva Group 의 clipFunc — 재단선 바깥은 아예 그려지지 않는다
  window.__dcDieClip = function (w, h, E) {
    var s = window.__dcDieShape();
    if (!s || !(w > 0) || !(h > 0)) return null;
    if (s.kind === 'ellipse') {
      return { clipFunc: function (ctx) { ctx.ellipse(w / 2, h / 2, w / 2, h / 2, 0, 0, Math.PI * 2, false); } };
    }
    var r = radiusPx(s, w, h, E);
    return { clipFunc: function (ctx) { pathRound(ctx, w, h, r); } };
  };
  // 재단선 자체 (name 에 guide 가 있어 인쇄/프루프 렌더에서는 숨겨짐)
  window.__dcDieOutline = function (w, h, E, A) {
    var s = window.__dcDieShape();
    if (!s || !A || !(w > 0) || !(h > 0)) return null;
    var common = { name: 'guide diecut', stroke: '#A82662', strokeWidth: 1.4, dash: [7, 5], listening: false, fill: undefined };
    if (s.kind === 'ellipse') {
      return A.jsx('Ellipse', Object.assign({ x: w / 2, y: h / 2, radiusX: w / 2, radiusY: h / 2 }, common), 'diecut');
    }
    return A.jsx('Rect', Object.assign({ x: 0, y: 0, width: w, height: h, cornerRadius: radiusPx(s, w, h, E) }, common), 'diecut');
  };


  /* ================================================================
     안전 영역 — 끄지 않고, 상품마다 다르게 준다
     배너는 사방이 헴으로 접히고 그로밋이 뚫려 기본 여백 1" 가 필요하다.
     그런데 3" 스티커에는 그 1" 가 판을 다 먹는다. 그래서 «검사를 끄는» 대신
     «여백을 0 으로» 돌려준다 — 여백이 0 이면 침범할 자리가 없어 경고도 안 뜬다.
     ================================================================ */
  window.__dcBaseSafe = function (dflt) { return isInch(AP()) ? 0 : dflt; };
  // 사각 안전선은 배너에서만 뜻이 있다. 재단 문양이 있거나 여백이 0 인 상품에서는
  // 재단선·마감선과 겹쳐 오히려 헷갈리므로 감춘다.
  window.__dcShowSafe = function () { return !isInch(AP()) && !window.__dcDieShape(); };

  /* ================================================================
     보드 크기가 바뀌면 기존 디자인을 새 규격에 맞춰 다시 앉힌다
     (템플릿 적용 후 다른 상품/사이즈로 바꿔도 잘리지 않도록)
     ================================================================ */
  function refitSide(side, sx, sy, nw, nh) {
    if (!side || !side.layers || !side.layers.length) return side;
    var sm = Math.min(sx, sy);
    var sT = Math.sqrt(sx * sy);          // 글자 배율 — 되돌리면 제자리로 오는 값
    var layers = side.layers.map(function (l) {
      var o = {};
      for (var k in l) o[k] = l[k];
      if (l.type === 'image') {
        // 사진·로고는 비율을 지켜야 하니 균등 축소하고 위치만 비례 이동
        var cx = (l.xIn + l.widthIn / 2) * sx, cy = (l.yIn + l.heightIn / 2) * sy;
        o.widthIn = l.widthIn * sm; o.heightIn = l.heightIn * sm;
        o.xIn = cx - o.widthIn / 2; o.yIn = cy - o.heightIn / 2;
      } else {
        o.xIn = l.xIn * sx; o.yIn = l.yIn * sy;
        o.widthIn = l.widthIn * sx; o.heightIn = l.heightIn * sy;
      }
      if (l.type === 'text') {
        /* 「고객이 원한 크기」(fitMaxIn) 를 판과 같은 비율로 옮긴다.
           v39 까지는 이것을 안 옮기고 fontSizeIn 만 건드렸다. 그래서
             · 새 크기가 옛 fitMaxIn 을 넘어 글자가 상자 밖으로 잘리고
             · 다음에 문구를 한 자만 고쳐도 옛 fitMaxIn 으로 되돌아가
               글씨가 갑자기 쪼그라들었다.
           배율은 sT = √(sx·sy) — 넓이가 늘어난 만큼이다.
           큰 쪽(sM)을 쓰면 상자를 넘어 잘리고, 작은 쪽(sm)을 쓰면 8x4ft →
           3x7ft → 다시 8x4ft 로 되돌렸을 때 글씨가 갈수록 작아진다
           (0.375 x 0.571 = 0.21배). √(sx·sy) 는 되돌리면 정확히 제자리다
           (0.810 x 1.234 = 1.000).
           이 값은 「원하는 크기」일 뿐이고, 상자를 넘으면 아래 fitLayers() 가
           실제로 재서 줄인다. 줄여도 원하는 크기는 남아 있으므로 판을 되돌리면
           글씨도 원래대로 돌아온다. */
        var want = Math.max(.04, (l.fitMaxIn > 0 ? l.fitMaxIn : (l.fontSizeIn || 1)) * sT);
        o.fitMaxIn = want;
        o.fontSizeIn = want;
        o.strokeWidthIn = (l.strokeWidthIn || 0) * sm;
      } else if (l.type === 'shape') {
        o.cornerRadiusIn = (l.cornerRadiusIn || 0) * sm;
      }
      // 판 밖으로 나가지 않게 살짝 당겨준다
      if (o.widthIn <= nw) o.xIn = Math.max(0, Math.min(nw - o.widthIn, o.xIn));
      if (o.heightIn <= nh) o.yIn = Math.max(0, Math.min(nh - o.heightIn, o.yIn));
      return o;
    });
    var out = {};
    for (var k2 in side) out[k2] = side[k2];
    out.layers = fitLayers(layers);
    return out;
  }
  /* 새 상자에 대고 「실제로 그려 보며」 크기를 정한다.
     짐작(fitFont)이 아니라, 캔버스와 같은 Konva 에게 물어보는 sbdc-textfit 의 자로 잰다.
     훅이 없으면(스크립트가 빠졌거나 Konva 가 아직이면) 조용히 그대로 둔다. */
  function fitLayers(layers) {
    if (typeof window.__dcFitAll !== 'function') return layers;
    try { return window.__dcFitAll(layers) || layers; } catch (e) { return layers; }
  }
  window.__dcRefit = function (prev, next) {
    try {
      var ow = prev.spec.widthIn, oh = prev.spec.heightIn;
      var nw = next.spec.widthIn, nh = next.spec.heightIn;
      if (!(ow > 0 && oh > 0 && nw > 0 && nh > 0)) return next;
      if (Math.abs(ow - nw) < 1e-6 && Math.abs(oh - nh) < 1e-6) return next;
      var hasLayers = (next.front && next.front.layers && next.front.layers.length) ||
                      (next.back && next.back.layers && next.back.layers.length);
      if (!hasLayers) return next;
      var sx = nw / ow, sy = nh / oh;
      var out = {};
      for (var k in next) out[k] = next[k];
      out.front = refitSide(next.front, sx, sy, nw, nh);
      out.back = next.back ? refitSide(next.back, sx, sy, nw, nh) : next.back;
      return out;
    } catch (e) { return next; }
  };


  /* ================================================================
     관리자 패널 연동 — 업로드 템플릿 · 공지 · 설정 · 사용 이벤트
     (Supabase: dc_templates / dc_settings / dc_events)
     ================================================================ */
  var SUPA_URL = 'https://uktrkymhgmzlufzxsavf.supabase.co';
  var SUPA_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVrdHJreW1oZ216bHVmenhzYXZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc4Nzg0MjAsImV4cCI6MjEwMzQ1NDQyMH0.BBMLGRs0BkBhb45ZkY5MddnslJT355lQyBZvjMe7ndY';
  var remoteTpls = [];
  var dcSettings = {};
  var settingsLoaded = false;

  /* A4 — 실패를 «없음» 으로 바꾸지 않는다.
     예전에는 서버가 죽어도 500·401·무응답이 전부 cb(null) 로 들어와서, 부른 쪽이
     «서버가 죽었다» 와 «템플릿이 원래 없다» 를 구분하지 못했다. 그래서 손님도 관리자도
     템플릿이 26장에서 11장으로 줄어든 것을 눈치채지 못했다 (오류 주입으로 실측).
     이제 두 번째 인자로 «무엇이 잘못됐는지» 를 함께 준다. 값이 없으면 err 도 없다.
     시간 제한도 없었다 — 응답이 안 오면 영원히 기다렸다. 10초로 끊는다. */
  function restGet(path, cb) {
    var done = false;
    var fin = function (rows, err) { if (done) return; done = true; cb(rows, err || null); };
    try {
      var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var tm = setTimeout(function () {
        try { ctl && ctl.abort(); } catch (e) {}
        fin(null, { kind: 'timeout', detail: 'No response within 10 seconds' });
      }, 10000);
      fetch(SUPA_URL + '/rest/v1/' + path, {
        headers: { apikey: SUPA_ANON, authorization: 'Bearer ' + SUPA_ANON },
        signal: ctl ? ctl.signal : undefined
      }).then(function (r) {
        if (!r.ok) { clearTimeout(tm); fin(null, { kind: 'http', status: r.status, detail: 'HTTP ' + r.status }); return null; }
        return r.json().then(function (j) { clearTimeout(tm); fin(j, null); }, function (e) {
          clearTimeout(tm); fin(null, { kind: 'parse', detail: 'Could not read the response' });
        });
      }).catch(function (e) {
        clearTimeout(tm);
        fin(null, { kind: 'network', detail: (e && e.message) || 'Could not connect' });
      });
    } catch (e) { fin(null, { kind: 'network', detail: (e && e.message) || 'Could not connect' }); }
  }
  function logEvent(kind, ref) {
    try {
      fetch(SUPA_URL + '/rest/v1/dc_events', {
        method: 'POST',
        headers: { apikey: SUPA_ANON, authorization: 'Bearer ' + SUPA_ANON, 'content-type': 'application/json', prefer: 'return=minimal' },
        body: JSON.stringify({ kind: kind, ref: (ref || '').slice(0, 200) })
      }).catch(function () {});      // 통계는 실패해도 그만 — 잡지 않으면 unhandledrejection 이
                                     // 되어 __dcErrors(20칸) 를 채우고 진짜 오류를 밀어낸다 (DC-106)
    } catch (e) {}
  }
  // 템플릿 카드 클릭 시 번들이 호출
  window.__dcTplApplied = function (t) {
    if (t) logEvent('template_apply', String(t.id || '') + ':' + String(t.name || ''));
    // 올린 SVG 의 색을 인쇄 가능한 색으로 당겼다면 알려 준다.
    // 문구는 고객 색 고르개가 쓰는 것과 같은 문장을 쓴다.
    var moved = t && tplInkMoved[String(t.id || '')];
    if (moved && moved.length) setTimeout(function () {
      toast('Swapped for the closest printable color');
    }, 400);
  };


  /* ================================================================
     __dcPathFit — «그림(자유 도형)» 레이어를 어떻게 앉힐지 계산한다 (v37)

     레이어에는 원본 좌표(pathData)와 두 가지가 같이 들어 있다.
       pathMat  그룹·transform 을 푼 행렬  (원본 좌표 → SVG viewBox 좌표)
       pathBox  그 행렬을 먹인 뒤의 원본 상자
     여기서 «pathBox 를 레이어 상자에 맞추는 행렬» 을 앞에 한 번 더 곱한다.
       최종 = 맞춤 ∘ pathMat
     SVG 렌더러는 이 행렬을 matrix(...) 로 그대로 쓰고,
     캔버스(Konva)는 행렬을 못 받으므로 x·기울기·회전·배율로 풀어서 준다.
     ================================================================ */
  window.__dcPathFit = function (L, boxW, boxH) {
    var b = L && L.pathBox;
    if (!b || !(b.w > 0) || !(b.h > 0) || !(boxW > 0) || !(boxH > 0)) return null;
    var m = (L.pathMat && L.pathMat.length === 6) ? L.pathMat : [1, 0, 0, 1, 0, 0];
    var kx = boxW / b.w, ky = boxH / b.h;
    // [a,b,c,d,e,f] : x' = a·x + c·y + e ,  y' = b·x + d·y + f
    var a = kx * m[0], bb = ky * m[1], c = kx * m[2], d = ky * m[3],
        e = kx * (m[4] - b.x), f = ky * (m[5] - b.y);
    if (![a, bb, c, d, e, f].every(isFinite)) return null;
    var scaleX = Math.sqrt(a * a + bb * bb), det = a * d - bb * c;
    if (!(scaleX > 1e-9) || !isFinite(det) || Math.abs(det) < 1e-12) return null;
    return {
      mat: [a, bb, c, d, e, f],
      x: e, y: f,
      rotation: Math.atan2(bb, a) * 180 / Math.PI,
      scaleX: scaleX,
      scaleY: det / scaleX,
      skewX: (a * c + bb * d) / det
    };
  };

  /* -------- SVG 를 레이어로 뜯는 변환기 v2 (v35, 2026-08-23) -------- */


  var FONT_MAP = [
    [/anton/i, 'Anton'], [/bebas/i, 'Bebas Neue'], [/oswald/i, 'Oswald'],
    [/montserrat/i, 'Montserrat'], [/noto|malgun|nanum|gothic|명조|고딕/i, 'Noto Sans KR'],
    [/black|impact|heavy|arial *black/i, 'Anton'], [/./, 'Archivo']
  ];
  var APP_FONTS = ['Anton', 'Archivo', 'Oswald', 'Bebas Neue', 'Montserrat', 'Noto Sans KR'];

  function pickFont(el, cs) {
    var d = el.getAttribute('data-dc-font');
    if (d && APP_FONTS.indexOf(d) >= 0) return d;
    var f = (cs.fontFamily || '').replace(/["']/g, '');
    /* V0.1.2: 고르개 35종은 «정확히 같은 이름» 을 먼저 본다 — 아래 «이름 일부 포함» 검사가 먼저 돌면
       'Archivo Black' 이 'Archivo' 에 걸려 기본 글꼴로 떨어진다(2026-09-09 검토에서 발견). */
    var extra = pickerFont(d) || pickerFont(f.split(',')[0]);
    if (extra) return extra;
    for (var i = 0; i < APP_FONTS.length; i++) {
      if (f.toLowerCase().indexOf(APP_FONTS[i].toLowerCase()) >= 0) return APP_FONTS[i];
    }
    for (var j = 0; j < FONT_MAP.length; j++) if (FONT_MAP[j][0].test(f)) return FONT_MAP[j][1];
    return 'Archivo';
  }

  /* ================================================================
     V0.1.2 (2026-09-09) — 곡선 글자와 고르개 글꼴을 «변환하는 그 자리에서» 읽는다.

     전에는 변환기가 curveDeg 를 무조건 0 으로 두고, sb-dc-tplcurve.js 가 나중에
     «레이어 이름» 으로 파일을 다시 뒤져 곡선·글꼴을 되살렸다. 이름은 글자 앞 18자라
     «YOUR TEXT» 가 세 줄이면 어느 줄인지 몰라 통째로 버렸고, 그래서 디자이너가
     곡선을 넣어도 편집기에서 직선이 됐다(2026-09-08 밤 확인). 여기서 <text> 를
     레이어로 만드는 순간 그 요소의 표기를 직접 읽으면 이름은 아예 필요 없다.

       · data-dc-curve="60" [data-dc-curve-ratio="0.6"]  (관리자 업로드가 적는 쪽지)
       · 없으면 <textPath href="#id"> 의 경로를 스무 점 찍어 «원» 이면 반지름,
         «가로로 누운 타원» 이면 가로 반지름 + 납작한 정도(세로/가로) 를 되읽는다.
         세운 타원은 편집기가 못 그리므로 꼭대기 곡률의 원으로 근사한다.
         물결·자유 곡선은 손대지 않는다(직선).
       · 각도 = 글자 길이 ÷ 가로 반지름 — 편집기 배치식(Qe) 과 같은 정의.

     tplcurve.js 는 그대로 두었다 — 이미 curveDeg 가 있으면 건드리지 않으므로 충돌 없음.
     ================================================================ */
  function normName(v) { return String(v || '').replace(/["']/g, '').replace(/\s+/g, '').toLowerCase(); }
  function pickerFont(name) {
    var list = window.__dcFonts;
    if (!list || !name) return '';
    var k = normName(String(name).replace(/-(regular|bold|italic|bolditalic|medium|light|semibold|extrabold|black)$/i, ''));
    if (!k) return '';
    for (var i = 0; i < list.length; i++) {
      if (normName(list[i]) === k && APP_FONTS.indexOf(list[i]) < 0) return list[i];
    }
    return '';
  }
  /* 고르개 글꼴은 캔버스가 받기 전에 그리면 대체 글꼴로 굳는다(sb-dc-fonts.js).
     레이어가 편집기에 들어온 뒤 한 번 되그린다. 한 타이머로 모아서 본다. */
  var fontQueue = {}, fontTick = null;
  function queueFont(id, fam) {
    fontQueue[id] = { f: fam, t: Date.now() };
    try { if (window.__dcEnsureFont) window.__dcEnsureFont(fam); } catch (e) {}
    if (fontTick) return;
    fontTick = setInterval(function () {
      var a = window.__dcApi, ls = a && a.doc && a.doc.layers, now = Date.now(), left = 0;
      for (var id in fontQueue) {
        var q = fontQueue[id], hit = false;
        if (ls) for (var i = 0; i < ls.length; i++) if (ls[i] && ls[i].id === id) { hit = true; break; }
        if (hit) {
          delete fontQueue[id];
          (function (id, f) {
            var pr = null;
            try { pr = window.__dcEnsureFont && window.__dcEnsureFont(f); } catch (e) {}
            (pr || Promise.resolve()).then(function () { try { a.updateLayer(id, { fontFamily: f }); } catch (e) {} });
          })(id, q.f);
        } else if (now - q.t > 60000) delete fontQueue[id];   // 미리보기용 변환 등 — 편집기에 안 실린 레이어
        else left++;
      }
      if (!left) { clearInterval(fontTick); fontTick = null; }
    }, 300);
  }

  function curveAttr(el) {          // 관리자 curveOf 와 같이 조상 4단계까지
    for (var i = 0, n = el; n && n.nodeType === 1 && i < 5; n = n.parentNode, i++) {
      if (!n.getAttribute) continue;
      var raw = n.getAttribute('data-dc-curve');
      if (raw == null || String(raw).trim() === '') continue;
      var v = parseFloat(raw);
      if (!isFinite(v) || !v) return null;
      var k = parseFloat(n.getAttribute('data-dc-curve-ratio'));
      return { deg: Math.max(-180, Math.min(180, v)), k: (k > 0 && k < 1) ? Math.max(0.25, k) : 1 };
    }
    return null;
  }
  function fitCircle(A, B, C) {
    var d = 2 * (A.x * (B.y - C.y) + B.x * (C.y - A.y) + C.x * (A.y - B.y));
    if (Math.abs(d) < 1e-9) return null;
    var a2 = A.x * A.x + A.y * A.y, b2 = B.x * B.x + B.y * B.y, c2 = C.x * C.x + C.y * C.y;
    var x = (a2 * (B.y - C.y) + b2 * (C.y - A.y) + c2 * (A.y - B.y)) / d;
    var y = (a2 * (C.x - B.x) + b2 * (A.x - C.x) + c2 * (B.x - A.x)) / d;
    return { x: x, y: y, r: Math.hypot(A.x - x, A.y - y) };
  }
  /* 축이 기울지 않은 타원 최소제곱: A u² + B v² + C u + D v = 1 (좌표를 가운데·크기로 정규화한 뒤) */
  function fitEllipse(pts) {
    var n = pts.length, mx = 0, my = 0, i;
    for (i = 0; i < n; i++) { mx += pts[i].x; my += pts[i].y; }
    mx /= n; my /= n;
    var sc = 0;
    for (i = 0; i < n; i++) sc = Math.max(sc, Math.abs(pts[i].x - mx), Math.abs(pts[i].y - my));
    if (!(sc > 0)) return null;
    var M = [[0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 0, 0, 0, 0], [0, 0, 0, 0, 0]];
    for (i = 0; i < n; i++) {
      var u = (pts[i].x - mx) / sc, v = (pts[i].y - my) / sc, row = [u * u, v * v, u, v];
      for (var r = 0; r < 4; r++) { for (var c = 0; c < 4; c++) M[r][c] += row[r] * row[c]; M[r][4] += row[r]; }
    }
    for (var col = 0; col < 4; col++) {                       // 가우스 소거
      var piv = col;
      for (r = col + 1; r < 4; r++) if (Math.abs(M[r][col]) > Math.abs(M[piv][col])) piv = r;
      if (Math.abs(M[piv][col]) < 1e-12) return null;
      var tmp = M[col]; M[col] = M[piv]; M[piv] = tmp;
      for (r = 0; r < 4; r++) {
        if (r === col) continue;
        var f = M[r][col] / M[col][col];
        for (c = col; c < 5; c++) M[r][c] -= f * M[col][c];
      }
    }
    var A = M[0][4] / M[0][0], B = M[1][4] / M[1][1], C = M[2][4] / M[2][2], D = M[3][4] / M[3][3];
    if (!(A > 0) || !(B > 0)) return null;
    var uc = -C / (2 * A), vc = -D / (2 * B), F = 1 + A * uc * uc + B * vc * vc;
    if (!(F > 0)) return null;
    var e = { cx: mx + uc * sc, cy: my + vc * sc, rx: Math.sqrt(F / A) * sc, ry: Math.sqrt(F / B) * sc };
    for (i = 0; i < n; i++) {                                 // 스무 점이 그 타원 위에 있는가 (2%)
      var dx = (pts[i].x - e.cx) / e.rx, dy = (pts[i].y - e.cy) / e.ry;
      if (Math.abs(dx * dx + dy * dy - 1) > 0.02) return null;
    }
    return e;
  }
  function curveFromPath(svg, t, font, bold) {
    var tp = t.querySelector('textPath');
    if (!tp) return null;
    /* 각도 = 글자 길이 ÷ 반지름 이므로 길이는 «편집기가 쓸 진짜 글꼴» 로 재야 한다. 일러스트레이터 이름('Oswald-Bold')은
       브라우저가 모르는 글꼴이라 대체 글꼴(더 넓음)로 재면 각도가 부풀어 편집기에서 더 많이 휜다(타원 100° vs 81°).
       tplcurve.js parse 가 하던 것과 같다. 관리자 업로드가 적은 쪽지가 있으면 여기까지 오지 않는다. */
    if (font) {
      try {
        t.style.fontFamily = '"' + font + '"'; t.style.fontWeight = bold ? '700' : '400';
        var inner = t.querySelectorAll('tspan, textPath');
        for (var q = 0; q < inner.length; q++) { inner[q].style.fontFamily = '"' + font + '"'; inner[q].style.fontWeight = bold ? '700' : '400'; }
      } catch (e) {}
    }
    var href = tp.getAttribute('href') || tp.getAttribute('xlink:href') ||
      tp.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '';
    if (href.charAt(0) !== '#') return null;
    var path = svg.querySelector('[id="' + href.slice(1).replace(/"/g, '') + '"]');
    if (!path || !path.getTotalLength) return null;
    var L, W;
    try { L = path.getTotalLength(); W = t.getComputedTextLength(); } catch (e) { return null; }
    if (!(L > 0) || !(W > 0)) return null;
    var pts = [];
    for (var i = 0; i <= 20; i++) { var p = path.getPointAtLength(L * i / 20); pts.push({ x: p.x, y: p.y }); }
    var M = pts[10], r = 0, k = 1, cy = 0;
    var c = fitCircle(pts[0], M, pts[20]);
    var round = !!(c && c.r > 0 && L / c.r >= 0.15);
    if (round) for (i = 0; i < pts.length; i++) if (Math.abs(Math.hypot(pts[i].x - c.x, pts[i].y - c.y) - c.r) > c.r * 0.01) { round = false; break; }
    if (round) { r = c.r; cy = c.y; }
    else {
      var e = fitEllipse(pts);
      if (!e) return null;
      cy = e.cy;
      /* 누운 타원: 가로 반지름 rx 그대로 + k = ry/rx (편집기 배치식 A = R, B = k·R 과 같은 정의 → 파일 타원이 그대로 복원).
         세운 타원(ry > rx)은 편집기가 못 그리므로 꼭대기 곡률 반지름 rx²/ry 의 원으로 근사. */
      if (e.ry <= e.rx) { r = e.rx; k = Math.max(0.25, e.ry / e.rx); }
      else r = e.rx * e.rx / e.ry;
    }
    var deg = Math.round(W / r * 180 / Math.PI);
    if (!(deg >= 5)) return null;
    deg = Math.min(180, deg);
    /* 위·아래는 «글자가 중심보다 위에 있나» 로 — 경로 중간점으로 하면 일러스트레이터식 «닫힌 원 전체» 경로에서 뒤집힌다 */
    var ty = M.y;
    try { var tb = t.getBBox(); if (tb && tb.height) ty = tb.y + tb.height / 2; } catch (e) {}
    return { deg: cy > ty ? deg : -deg, k: Math.round(k * 100) / 100 };
  }
  function curveOfText(svg, t, font, bold) { return curveAttr(t) || curveFromPath(svg, t, font, bold); }
  window.__dcCurveOfText = curveOfText;                        // 시험 훅

  var uid = 0;
  function nid(t) { return t + '_svg' + Date.now().toString(36) + (uid++); }
  function base(type, name, x, y, w, h) {
    return { id: nid(type), type: type, name: name, xIn: x, yIn: y, widthIn: w, heightIn: h,
             rotation: 0, visible: true, locked: false };
  }
  // 브라우저가 알려준 색을 #RRGGBB 로
  function toHex(c) {
    if (!c) return null;
    if (c.charAt(0) === '#') return c.length === 4
      ? '#' + c[1] + c[1] + c[2] + c[2] + c[3] + c[3] : c.toUpperCase();
    var m = c.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(',').map(function (v) { return parseFloat(v); });
    if (p.length > 3 && p[3] === 0) return null;               // 완전 투명 = 색 없음
    return '#' + p.slice(0, 3).map(function (v) {
      return ('0' + Math.round(v).toString(16)).slice(-2);
    }).join('').toUpperCase();
  }
  // 2026-09-07 그라데이션: 계산값이 url("#id") 면 그라데이션·패턴 참조 — 색 하나로 못 적는다
  function isPaintRef(v) { return /^url\(/.test(v || ''); }

  /**
   * 인쇄로 낼 수 없는 색을 «가장 비슷한 인쇄 가능한 색» 으로 당긴다.
   *
   * 고객 색 고르개는 번들 안에서 이미 이렇게 하고 있었는데(고르면 조용히 바뀐다),
   * 올린 SVG 의 색은 고르개를 거치지 않아 그대로 들어왔다. 같은 함수를 태워 맞춘다.
   * 무엇이 바뀌었는지는 모아 두었다가 템플릿을 고른 순간 알려 준다.
   */
  var inkMoved = null;                     // svgToLayers 도는 동안 모이는 변경 목록
  function inkFit(hex) {
    if (!hex) return hex;
    var g = window.__dcGamut;
    if (typeof g !== 'function') return hex;               // 훅이 없으면 손대지 않는다
    try {
      var r = g(hex);
      if (!r || r.printable || !r.hex || r.hex === hex) return hex;
      if (inkMoved && !inkMoved.some(function (m) { return m.from === hex; }))
        inkMoved.push({ from: hex, to: r.hex });
      return r.hex;
    } catch (e) { return hex; }
  }

  function svgToLayers(svgText, boardW, boardH) {
    if (typeof document === 'undefined') throw new Error('Browser only');
    var doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
    if (doc.querySelector('parsererror')) throw new Error('Could not read the SVG');
    var svg = document.importNode(doc.documentElement, true);

    var vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    var VW, VH;
    if (vb.length === 4 && vb.every(isFinite)) { VW = vb[2]; VH = vb[3]; }
    else { VW = parseFloat(svg.getAttribute('width')) || 0; VH = parseFloat(svg.getAttribute('height')) || 0; }
    if (!(VW > 0 && VH > 0)) throw new Error('Could not read the SVG size (viewBox)');

    // 좌표를 viewBox 단위 그대로 읽으려고 크기를 맞춰 둔다
    svg.setAttribute('width', VW); svg.setAttribute('height', VH);
    var host = document.createElement('div');
    host.setAttribute('aria-hidden', 'true');
    host.style.cssText = 'position:absolute;left:-99999px;top:0;width:0;height:0;overflow:hidden';
    host.appendChild(svg);
    document.body.appendChild(host);

    var layers = [], background = null, skipped = [];
    inkMoved = [];
    try {
      var rootM = svg.getScreenCTM();
      // 요소의 실제 자리를 viewBox 좌표로 — 그룹과 transform 을 브라우저가 풀어 준다
      function box(el) {
        var bb, m;
        try { bb = el.getBBox(); m = el.getScreenCTM(); } catch (e) { return null; }
        if (!bb || !m || !rootM || !(bb.width || bb.height)) return null;
        m = rootM.inverse().multiply(m);
        var pt = [[bb.x, bb.y], [bb.x + bb.width, bb.y],
                  [bb.x + bb.width, bb.y + bb.height], [bb.x, bb.y + bb.height]];
        var xs = [], ys = [];
        pt.forEach(function (p) {
          xs.push(m.a * p[0] + m.c * p[1] + m.e);
          ys.push(m.b * p[0] + m.d * p[1] + m.f);
        });
        var x0 = Math.min.apply(null, xs), y0 = Math.min.apply(null, ys);
        return { x: x0, y: y0, w: Math.max.apply(null, xs) - x0, h: Math.max.apply(null, ys) - y0 };
      }

      // ★ 비율 맞추기 — 띠·판은 가로세로를 따로 늘려 꽉 채우고,
      //    원·별·글자는 균일 배율로 «모양을 지킨 채» 자리만 옮긴다
      var sx = boardW / VW, sy = boardH / VH, sMin = Math.min(sx, sy);
      function stretched(b) { return [b.x * sx, b.y * sy, b.w * sx, b.h * sy]; }
      function keptShape(b) {
        var w = b.w * sMin, h = b.h * sMin;
        return [(b.x + b.w / 2) * sx - w / 2, (b.y + b.h / 2) * sy - h / 2, w, h];
      }

      function polyKind(el) {
        var n = (el.getAttribute('points') || '').trim().split(/\s+/).filter(Boolean).length;
        if (n >= 10 && n % 2 === 0) return { shape: 'star', starPoints: n / 2 };
        if (n === 4) return { shape: 'rhombus' };
        return null;
      }

      function addText(el, txt, b, cs) {
        if (!txt || !b) return;
        var L = base('text', el.getAttribute('data-dc-name') || txt.slice(0, 18),
                     b.x * sx, b.y * sy, b.w * sx, b.h * sy);
        var fs = parseFloat(cs.fontSize) || 16;
        L.text = txt;
        L.fontFamily = pickFont(el, cs);
        if (APP_FONTS.indexOf(L.fontFamily) < 0) queueFont(L.id, L.fontFamily);   // V0.1.2
        // 원래 크기 × 판 배율. 글자 폭을 짐작하지 않는다 —  (v37 에서 합침)
        // 상자 b 는 이 글꼴·이 문구를 브라우저가 fs 로 실제 그려서 잰 것이므로
        // 배율을 sMin 으로 두면 폭도 높이도 자동으로 상자 안에 들어온다.
        L.fontSizeIn = Math.max(0.04, fs * sMin);
        /* 2026-09-07 그라데이션 글자: 조각(그림)으로 만들면 <img> 안에서 페이지 웹폰트를 못 써
           글꼴이 바뀐다. 편집 가능한 글자로 두고 첫 <stop> 색을 대표색으로 쓴다.
           정확한 모양이 필요하면 디자이너가 윤곽선(패스)으로 내보내면 자동으로 조각이 된다. */
        L.fill = inkFit(toHex(cs.fill) || stopHex(cs.fill) || '#111111');
        if (isPaintRef(cs.fill)) skipped.push('text(gradient\u2192' + L.fill + ')');
        /* 2026-09-07: 파일에 테두리 색이 있을 때만 테두리를 넣는다.
           stroke 가 none 이어도 strokeWidth 계산값은 «1px» 라서, 전에는 글자마다
           흰 테두리 1단위가 기본으로 붙었다. 3000단위 파일은 0.001in 라 안 보였지만
           피그마처럼 495단위 파일은 0.006in 가 되어 글자 가장자리에 흰 선이 보였다. */
        var strokeHex = toHex(cs.stroke) || stopHex(cs.stroke);
        L.stroke = strokeHex || '#ffffff';
        L.strokeWidthIn = strokeHex ? (parseFloat(cs.strokeWidth) || 0) * sMin : 0;
        var a = cs.textAnchor || el.getAttribute('text-anchor') || 'start';
        L.align = a === 'middle' ? 'center' : (a === 'end' ? 'right' : 'left');
        /* 글상자에 여유를 준다 — 안 주면 끝 글자가 잘린다.
           b 는 «브라우저가 SVG 로 그렸을 때» 의 글자 상자인데, 앱은 캔버스로 다시 잰다.
           두 값이 몇 % 어긋나므로 딱 맞는 상자에서는 마지막 글자가 다음 줄로 밀려 사라진다. */
        var padX = Math.max(L.widthIn * 0.07, L.fontSizeIn * 0.15);
        L.widthIn += padX;
        if (L.align === 'center') L.xIn -= padX / 2;
        else if (L.align === 'right') L.xIn -= padX;
        var minH = L.fontSizeIn * 1.3;
        if (L.heightIn < minH) { L.yIn -= (minH - L.heightIn) / 2; L.heightIn = minH; }
        L.bold = (parseInt(cs.fontWeight, 10) || 400) >= 600 || cs.fontWeight === 'bold';
        L.italic = cs.fontStyle === 'italic';
        /* V0.1.2: 일러스트레이터는 굵기·기울임을 이름 접미사로 적는다('Oswald-Bold', 'PlayfairDisplay-Italic') */
        var famRaw = String(cs.fontFamily || '');
        if (/-(bold|black|heavy|semibold|extrabold)\b/i.test(famRaw)) L.bold = true;
        if (/-(italic|oblique|bolditalic)\b/i.test(famRaw)) L.italic = true;
        L.lineHeight = 1.15; L.stretchX = 1; L.stretchY = 1;
        L.underline = false; L.strikethrough = false; L.listStyle = 'none'; L.curveDeg = 0;
        layers.push(L);
      }

      /* ── 자유 도형(path·polyline·line·별 아닌 polygon) → «그림» 레이어 ──
         피그마는 별·곡선을 전부 <path> 로 내보낸다. v36 까지는 통째로 버렸다.
         좌표는 원본 그대로 두고 세 가지만 적어 둔다.
           pathData  원본 d
           pathMat   그룹·transform 을 푼 행렬 (원본 → viewBox 좌표)
           pathBox   그 행렬을 먹인 뒤의 원본 크기
         렌더러가 pathBox 를 레이어 상자에 맞춰 늘린다 — 좌표를 다시 쓸 일이 없다. */
      function matOf(el) {
        try {
          var m = el.getScreenCTM();
          if (!m || !rootM) return [1, 0, 0, 1, 0, 0];
          m = rootM.inverse().multiply(m);
          return [m.a, m.b, m.c, m.d, m.e, m.f];
        } catch (e) { return [1, 0, 0, 1, 0, 0]; }
      }
      function num(el, a) { var v = parseFloat(el.getAttribute(a)); return isFinite(v) ? v : 0; }
      function pathD(el, tag) {
        if (tag === 'path') return (el.getAttribute('d') || '').trim();
        if (tag === 'rect') {                    // 테두리만 있는 사각형
          var x = num(el, 'x'), y = num(el, 'y'), w = num(el, 'width'), h = num(el, 'height');
          if (!(w > 0 && h > 0)) return '';
          var rx = Math.min(num(el, 'rx') || num(el, 'ry'), w / 2),
              ry = Math.min(num(el, 'ry') || num(el, 'rx'), h / 2);
          if (!(rx > 0 && ry > 0))
            return 'M' + x + ' ' + y + 'H' + (x + w) + 'V' + (y + h) + 'H' + x + 'Z';
          var A = function (ex, ey) { return 'A' + rx + ' ' + ry + ' 0 0 1 ' + ex + ' ' + ey; };
          return 'M' + (x + rx) + ' ' + y + 'H' + (x + w - rx) + A(x + w, y + ry)
               + 'V' + (y + h - ry) + A(x + w - rx, y + h)
               + 'H' + (x + rx) + A(x, y + h - ry)
               + 'V' + (y + ry) + A(x + rx, y) + 'Z';
        }
        if (tag === 'circle' || tag === 'ellipse') {   // 테두리만 있는 원
          var cx = num(el, 'cx'), cy = num(el, 'cy');
          var ex = tag === 'circle' ? num(el, 'r') : num(el, 'rx'),
              ey = tag === 'circle' ? num(el, 'r') : num(el, 'ry');
          if (!(ex > 0 && ey > 0)) return '';
          return 'M' + (cx - ex) + ' ' + cy
               + 'A' + ex + ' ' + ey + ' 0 1 0 ' + (cx + ex) + ' ' + cy
               + 'A' + ex + ' ' + ey + ' 0 1 0 ' + (cx - ex) + ' ' + cy + 'Z';
        }
        if (tag === 'line') return 'M' + num(el, 'x1') + ' ' + num(el, 'y1')
                                 + 'L' + num(el, 'x2') + ' ' + num(el, 'y2');
        var p = (el.getAttribute('points') || '').trim().split(/[\s,]+/)
                  .filter(function (v) { return v !== ''; });
        if (p.length < 4) return '';
        var d = 'M' + p[0] + ' ' + p[1];
        for (var i = 2; i + 1 < p.length; i += 2) d += 'L' + p[i] + ' ' + p[i + 1];
        return tag === 'polygon' ? d + 'Z' : d;
      }
      function sameMat(a, b) {
        for (var i = 0; i < 6; i++) if (Math.abs(a[i] - b[i]) > 1e-6) return false;
        return true;
      }

      /* ── 2026-09-07 그라데이션·패턴 ─────────────────────────────────────────
         toHex 는 url("#id") 를 null 로 돌려줘서, 그라데이션 도형은 «색 없음» 으로
         addPath 에서 버려지고(:2994) 글자는 #111111 로 뭉개졌다. <defs> 는 심어 둔
         DOM 에 살아 있으므로 브라우저는 알고 있다 — 우리가 안 읽었을 뿐이다. */
      function stopHex(ref) {              // url("#id") → 첫 <stop> 색 (일러스트 xlink:href 사슬 3단까지)
        var m = /url\(["']?#([^"')]+)/.exec(ref || '');
        var g = m && svg.querySelector('[id="' + m[1] + '"]');
        for (var i = 0; g && i < 3 && !g.querySelector('stop'); i++) {
          var h = g.getAttribute('href') || g.getAttribute('xlink:href') || '';
          g = h.charAt(0) === '#' ? svg.querySelector('[id="' + h.slice(1) + '"]') : null;
        }
        var st = g && g.querySelector('stop');
        return st ? toHex(window.getComputedStyle(st).stopColor) : null;
      }
      /* 그라데이션·패턴 채움은 색 하나로 못 적는다. 그 요소를 조상 <g> 사슬·<defs>·<style>·
         (일러스트가 defs 밖에 두는) 그라데이션 정의와 함께 작은 SVG 로 잘라 «그림 조각»
         레이어로 넣는다 — 관리자 아트보드가 path 를 올리는 방식과 같다. 좌표계는 원본
         그대로 두고 viewBox 만 상자로 자르므로 userSpaceOnUse·gradientTransform 도 맞는다.
         화면도 인쇄 PNG 도 브라우저가 SVG 를 그려 주므로 그라데이션이 그대로 나온다.
         ponytail: 조각마다 정의 전체를 실음 — 큰 <pattern> 비트맵이 든 파일은 조각 수만큼 커진다.
                   같은 그라데이션 조각 여러 개는 합치지 않는다(단색 path 만 합침). */
      function chunkPaint(c, tag, b, cs, nm) {
        var mm = matOf(c), kk = Math.sqrt(Math.abs(mm[0] * mm[3] - mm[1] * mm[2])) || 1;
        var pad = (cs.stroke !== 'none' ? parseFloat(cs.strokeWidth) || 0 : 0) * kk / 2;   // 선은 반 두께 번짐
        var bx = { x: b.x - pad, y: b.y - pad, w: b.w + pad * 2, h: b.h + pad * 2 };
        var out = svg.cloneNode(false);
        out.setAttribute('viewBox', [bx.x, bx.y, bx.w, bx.h].join(' '));
        out.setAttribute('width', bx.w); out.setAttribute('height', bx.h);   // <img> 고유 크기(사파리·파폭)
        out.setAttribute('preserveAspectRatio', 'none');
        Array.prototype.forEach.call(
          svg.querySelectorAll('defs, style, linearGradient, radialGradient, pattern, clipPath, mask, filter, symbol'),
          function (d) {                                     // 문서 어디에 있든 — 단 defs 안의 것은 defs 로 한 번만
            if (d.parentNode && d.parentNode.closest && d.parentNode.closest('defs')) return;
            out.appendChild(d.cloneNode(true));
          });
        var chain = [], p = c.parentNode, cur = out;         // 조상 <g>/<svg> 를 얕게 복제해 겹친다
        while (p && p !== svg) { chain.unshift(p); p = p.parentNode; }   //  → transform·상속 fill·class 그대로
        chain.forEach(function (a) { var sh = a.cloneNode(false); cur.appendChild(sh); cur = sh; });
        cur.appendChild(c.cloneNode(true));
        var q = tag === 'rect' ? stretched(bx) : keptShape(bx);          // 아래 rect / ellipse 와 같은 규칙
        var I = base('image', nm || 'Gradient', q[0], q[1], q[2], q[3]);
        I.src = 'data:image/svg+xml;base64,'
              + btoa(unescape(encodeURIComponent(new XMLSerializer().serializeToString(out))));
        I.naturalWidth = Math.max(1, Math.round(bx.w)); I.naturalHeight = Math.max(1, Math.round(bx.h));
        I.isVector = true; I.fileName = I.name;
        layers.push(I);
      }
      var vectorParts = 0;

      function walk(el) {
        // 같은 색·같은 변형으로 나란히 놓인 조각들은 한 레이어로 묶는다.
        // (피그마가 별 34개를 path 34개로 내보내면 목록이 34줄이 된다)
        var pend = null;
        function flushPath() {
          if (!pend) return;
          var bx = pend.box, n = pend.parts.length;
          if (pend.sw > 0) {                       // 선은 상자 밖으로 반 두께만큼 번진다
            var mm = pend.mat, kk = Math.sqrt(Math.abs(mm[0] * mm[3] - mm[1] * mm[2])) || 1;
            var pad = pend.sw * kk / 2;
            bx = { x: bx.x - pad, y: bx.y - pad, w: bx.w + pad * 2, h: bx.h + pad * 2 };
          }
          var q = keptShape(bx);
          var P = base('shape', pend.name || (n > 1 ? 'Art ' + n + '' : 'Art'),
                       q[0], q[1], q[2], q[3]);
          P.shape = 'path'; P.cornerRadiusIn = 0;
          P.fill = pend.fill || null;
          P.pathStroke = pend.stroke || null;
          P.pathStrokeWidth = pend.sw || 0;
          if (pend.rule === 'evenodd') P.pathFillRule = 'evenodd';
          P.pathData = pend.parts.join(' ');
          P.pathMat = pend.mat;
          P.pathBox = { x: bx.x, y: bx.y, w: bx.w, h: bx.h };
          P.pathParts = n;
          layers.push(P); vectorParts += n; pend = null;
        }
        function addPath(c, tag, b, cs, fill, nm) {
          var d = pathD(c, tag);
          if (!d) { skipped.push(tag + '(no shape)'); return; }
          var stroke = inkFit(toHex(cs.stroke));
          var sw = stroke ? (parseFloat(cs.strokeWidth) || 1) : 0;
          if (!fill && !stroke) { skipped.push(tag + '(no color)'); return; }
          var rule = cs.fillRule === 'evenodd' ? 'evenodd' : 'nonzero';
          var mat = matOf(c);
          // 이어붙이기는 «절대 좌표 M 으로 시작 · 겹쳐도 안전한 nonzero» 일 때만
          var joinable = window.__dcMergePaths !== false
                      && d.charAt(0) === 'M' && rule === 'nonzero' && !nm;
          if (pend && joinable && pend.joinable && pend.fill === fill
              && pend.stroke === stroke && pend.sw === sw && sameMat(pend.mat, mat)) {
            pend.parts.push(d);
            var o = pend.box;
            var x1 = Math.min(o.x, b.x), y1 = Math.min(o.y, b.y);
            pend.box = { x: x1, y: y1,
                         w: Math.max(o.x + o.w, b.x + b.w) - x1,
                         h: Math.max(o.y + o.h, b.y + b.h) - y1 };
            return;
          }
          flushPath();
          pend = { parts: [d], box: { x: b.x, y: b.y, w: b.w, h: b.h }, fill: fill,
                   stroke: stroke, sw: sw, rule: rule, mat: mat, name: nm, joinable: joinable };
        }

        for (var i = 0; i < el.children.length; i++) {
          var c = el.children[i], tag = c.tagName.toLowerCase();
          if (tag === 'defs' || tag === 'style' || tag === 'title' || tag === 'desc'
              || tag === 'clippath' || tag === 'mask' || tag === 'metadata') continue;
          if (tag === 'g' || tag === 'svg') { flushPath(); walk(c); continue; }   // ← 그룹 안쪽까지

          var cs = window.getComputedStyle(c);
          if (cs.display === 'none' || cs.visibility === 'hidden') continue;
          var fill = inkFit(toHex(cs.fill));
          var b = box(c);
          if (!b) { skipped.push(tag); continue; }
          var nm = c.getAttribute('data-dc-name');

          // 2026-09-07 그라데이션·패턴 채움/테두리 → 그림 조각 (글자는 addText 가 대표색으로 처리)
          if (tag !== 'text' && tag !== 'image' && (isPaintRef(cs.fill) || isPaintRef(cs.stroke))) {
            flushPath();                                    // 앞서 모은 path 먼저 내보내 z 순서 유지
            if (background === null && tag === 'rect' && b.x <= VW * 0.01 && b.y <= VH * 0.01
                && b.w >= VW * 0.98 && b.h >= VH * 0.98)
              background = inkFit(stopHex(cs.fill)) || '#FFFFFF';   // 판 전체 그라데이션: 카드 색상표 대표색. 판은 맨 아래 조각으로 깔린다
            chunkPaint(c, tag, b, cs, nm); continue;
          }

          if (tag === 'text') {
            flushPath();
            var sp = c.querySelectorAll('tspan');
            var tpEl = c.querySelector('textPath');
            if (sp.length > 1 && !tpEl) {                          // 줄마다 따로 레이어로
              for (var k = 0; k < sp.length; k++) addText(sp[k], (sp[k].textContent || '').trim(), box(sp[k]), window.getComputedStyle(sp[k]));
            } else {
              /* 2026-09-08 V0.0.4: 일러스트레이터는 곡선 글자(<textPath>)의 색·크기·글꼴 class 를 바깥 <text> 가
                 아니라 안쪽 <tspan> 에 적는다. 바깥 계산값만 읽으면 검정·기본 크기(16)·Archivo 가 된다.
                 계산값은 상속되므로 가장 안쪽 요소를 읽으면 바깥에 적힌 파일(피그마 등)도 값이 같다. */
              var deep = sp[0] || tpEl;
              var n0 = layers.length;
              addText(c, (c.textContent || '').trim(), b, deep ? window.getComputedStyle(deep) : cs);
              /* V0.1.2: 곡선을 여기서 바로 읽는다 — 이름으로 다시 찾지 않는다 (위 curveOfText 주석) */
              if (layers.length > n0) {
                var cv = null;
                try { cv = curveOfText(svg, c, layers[n0].fontFamily, layers[n0].bold); } catch (e) { cv = null; }
                if (cv) { layers[n0].curveDeg = cv.deg; if (cv.k < 1) layers[n0].curveRatio = cv.k; }
              }
            }
            continue;
          }

          // 별·마름모는 «꼭짓점·깊이» 를 고칠 수 있는 진짜 도형으로 (예전 그대로)
          if (tag === 'polygon' && fill && polyKind(c)) {
            flushPath();
            var k2 = polyKind(c), q = keptShape(b);
            var P = base('shape', nm || (k2.shape === 'star' ? 'Star' : 'Diamond'), q[0], q[1], q[2], q[3]);
            P.shape = k2.shape; P.fill = fill; P.cornerRadiusIn = 0;
            if (k2.starPoints) { P.starPoints = k2.starPoints; P.starInnerRatio = 0.42; }
            layers.push(P); continue;
          }

          if (tag === 'rect' || tag === 'circle' || tag === 'ellipse' || tag === 'image') {
            flushPath();
            if (tag === 'image') {
              var href = c.getAttribute('href') || c.getAttribute('xlink:href') || '';
              if (!href) { skipped.push('image (no href)'); continue; }
              var im = keptShape(b);
              var I = base('image', nm || 'Image', im[0], im[1], im[2], im[3]);
              I.src = href; I.naturalWidth = Math.round(b.w); I.naturalHeight = Math.round(b.h);
              I.isVector = /svg/i.test(href); I.fileName = I.name;
              layers.push(I); continue;
            }
            if (!fill) {                 // 채움 없이 테두리만 → 자유 도형(그림)으로 살린다
              addPath(c, tag, b, cs, null, nm); continue;
            }
            if (tag === 'rect') {
              // 판 전체를 덮는 첫 사각형은 배경색으로 뺀다
              if (background === null && b.x <= VW * 0.01 && b.y <= VH * 0.01
                  && b.w >= VW * 0.98 && b.h >= VH * 0.98) { background = fill; continue; }
              var r = stretched(b);
              var R = base('shape', nm || 'Rectangle', r[0], r[1], r[2], r[3]);
              R.shape = 'rect'; R.fill = fill;
              R.cornerRadiusIn = (parseFloat(c.getAttribute('rx')) || 0) * sMin;
              if (b.x <= VW * 0.01 && b.w >= VW * 0.98) R.allowBleed = true;   // 가장자리까지 닿는 띠
              if (c.getAttribute('data-dc-bleed') === 'true') R.allowBleed = true;
              layers.push(R); continue;
            }
            var e = keptShape(b);
            var E = base('shape', nm || 'Circle', e[0], e[1], e[2], e[3]);
            E.shape = 'ellipse'; E.fill = fill; E.cornerRadiusIn = 0;
            layers.push(E); continue;
          }

          if (tag === 'path' || tag === 'polyline' || tag === 'line' || tag === 'polygon') {
            addPath(c, tag, b, cs, fill, nm); continue;
          }

          flushPath();
          skipped.push(tag);
        }
        flushPath();
      }
      walk(svg);
    } finally {
      document.body.removeChild(host);
    }

    return { layers: layers, background: background || '#FFFFFF',
             refW: VW, refH: VH, skipped: skipped, inkMoved: inkMoved || [],
             vectorParts: vectorParts };
  }
  var svgCache = {}, cutCache = {};        // 템플릿 id → SVG 본문 / 뜯은 결과
  var tplInkMoved = {};                    // 템플릿 id → 인쇄 가능한 색으로 당긴 색 목록

  /* 원본에 적힌 곡률이 그 자리에 비해 과해서 넣으면 오히려 나빠지는 템플릿 (sb-dc-tplcurve.js SKIP 과 같은 목록).
     V0.1.2 부터 변환기가 곡선을 직접 읽으므로 여기서도 빼야 예전과 같다.
     ⚠ 코드가 아니라 «자료» 문제다 — 관리자 고치기에서 그 글자의 곡선을 0 으로 저장하면 이 줄을 지운다. */
  var CURVE_SKIP = { '8aad907b-52c4-4a38-96a6-487dbdb9b4ea': 'Round Sticker Political 10 · 슬로건이 초상화에 묻힘' };
  function cutSvg(id, raw, W, H) {
    if (window.SBDC914?.host && raw.includes('id="sbdc-layout-914"')) { const n = window.SBDC914.host.fromSVG(raw,W,H); if(n) return n; }         // 같은 판 크기면 다시 안 뜯는다
    var k = id + '|' + W + 'x' + H;
    if (!(k in cutCache)) {
      try { cutCache[k] = svgToLayers(raw, W, H); } catch (e) { cutCache[k] = null; }
      if (cutCache[k] && CURVE_SKIP[id]) cutCache[k].layers.forEach(function (l) { if (l.type === 'text') { l.curveDeg = 0; delete l.curveRatio; } });
    }
    var out = cutCache[k];
    // 색은 판 크기와 무관하므로 미리보기(100×100)에서 이미 확정된다
    if (out) tplInkMoved['r_' + id] = out.inkMoved || [];
    return out;
  }
  window.__dcSvgToLayers = svgToLayers; window.__dcCutSvg = cutSvg;   // 테스트 훅

  function remoteToTpl(r) {
    var vec = /svg/.test(r.content_type || '');
    var raw = svgCache[r.id] || null;
    var probe = raw ? cutSvg(r.id, raw, 100, 100) : null;
    var layered = !!(probe && probe.layers.length);
    return {
      id: 'r_' + r.id,
      name: r.name,
      industry: r.category || 'Uploads',
      background: layered ? probe.background : '#FFFFFF',
      swatch: layered ? [probe.background, '#00697F'] : ['#FFFFFF', '#00697F'],
      native: true,
      remote: true,
      layered: layered,
      srB: (r.doc && r.doc.srB) || null,
      fit: (r.fit && r.fit.length) ? r.fit : ['wide', 'tall', 'square'],
      build: function (W, H) {
        if (r.doc && r.doc.srB) return [];   // Step & Repeat template: stamped by sb-dc-steprepeat.js on __dcTplApplied
        if (raw) {                          // 레이어가 살아 있는 SVG → 판에 맞춰 뜯는다
          var out = cutSvg(r.id, raw, W, H);
          if (out && out.layers.length) return out.layers;
        }
        var nw = r.width_px || 1000, nh = r.height_px || 1000, ar = nh / nw;
        var w = W * .96, h = w * ar;
        if (h > H * .96) { h = H * .96; w = h / ar; }
        return [{
          id: newId('img'), type: 'image', name: r.name,
          xIn: (W - w) / 2, yIn: (H - h) / 2, widthIn: w, heightIn: h,
          rotation: 0, visible: true, locked: false,
          src: r.file_url, naturalWidth: nw, naturalHeight: nh,
          fileName: r.name, isVector: vec
        }];
      }
    };
  }
  // Shopify "Design Templates" 페이지에서 ?tpl=<id> 로 들어오면 그 템플릿을 바로 적용
  var _tplApplied = false;
  function applyTplFromUrl() {
    if (_tplApplied) return;
    var m = /[?&]tpl=([^&]+)/.exec(location.search);
    if (!m) return;
    var want = 'r_' + decodeURIComponent(m[1]);
    var tpl = remoteTpls.filter(function (t) { return t.id === want; })[0];
    if (!tpl) return;                 // 아직 못 받았으면 다음 세팅 때 다시 시도
    var api = window.__dcApi;
    if (!api || !api.spec || !api.loadTemplate) { setTimeout(applyTplFromUrl, 200); return; }
    _tplApplied = true;
    try {
      var W = api.spec.widthIn, H = api.spec.heightIn;
      var layers = tpl.build(W, H);
      api.loadTemplate(layers, tpl.background);
      if (typeof window.__dcTplApplied === 'function') window.__dcTplApplied(tpl);
    } catch (e) { _tplApplied = false; }
  }

  function fetchRemote() {
    restGet('dc_templates?active=eq.true&select=*&order=sort.asc,created_at.desc', function (rows, err) {
      if (err) { tplTrouble.listFailed = err; showTplTrouble(); return; }
      if (!rows || !rows.length) return;         // 진짜로 한 장도 없는 것 — 알릴 일이 아니다
      // SVG 는 본문을 먼저 받아 둔다 — 다 받은 뒤에야 목록을 세운다
      var doneOnce = false;
      var finish = function () {
        if (doneOnce) return;
        doneOnce = true;
        if (loadingBar) { try { loadingBar.remove(); } catch (e) {} }
        /* A4 — 본문(SVG)을 못 받은 것은 목록에서 뺀다.
           남겨 두면 카드는 보이는데 누르면 «레이어 없는 그림 한 장» 이 얹혀서,
           손님이 글자를 못 고친다(그것도 주소가 죽었으니 깨진 그림이다).
           ⚠ 조건을 «본문이 없다» 로 잡으면 안 된다 — PNG·JPG 로 올린 템플릿은
              원래 한 장짜리가 정상이다. «SVG 인데 본문을 못 받은 것» 만 뺀다. */
        var 뺀장수 = 0;
        var 쓸것 = rows.filter(function (r) {
          if (/svg/.test(r.content_type || '') && r.file_url && !svgCache[r.id]) { 뺀장수++; return false; }
          return true;
        });
        remoteTpls = 쓸것.map(remoteToTpl);
        if (뺀장수) { tplTrouble.svgFailed = 뺀장수; showTplTrouble(); }
        applyTplFromUrl();
      };
      var waiting = 0, settle = function () { if (--waiting <= 0) finish(); };
      var loadingBar = /[?&]tpl=/.test(location.search) ? 띠('Loading your design… large templates can take a few seconds on a slow connection', false) : null;   // 2026-09-16: the board stayed blank while the template file downloaded
      rows.forEach(function (r) {
        // V1.0.2 draft 2026-09-29: the real server drops doc.srB from a Step & Repeat row; admin v6.7 also writes it into the preview PNG (tEXt «sbdc-srB»).
        if (/png/.test(r.content_type || '') && r.file_url && !(r.doc && r.doc.srB) && /(^|,)(step-repeat|popup-backdrop)(,|$)/.test(String(r.products || ''))) {
          waiting++;
          fetch(r.file_url).then(function (x) { return x.ok ? x.arrayBuffer() : null; }).then(function (b) {
            var u = b && new Uint8Array(b), p = 8;
            while (u && p + 12 <= u.length) {
              var n = ((u[p] << 24) | (u[p + 1] << 16) | (u[p + 2] << 8) | u[p + 3]) >>> 0, s = p + 8, z = u.indexOf(0, s);
              if (String.fromCharCode(u[p + 4], u[p + 5], u[p + 6], u[p + 7]) === 'tEXt' && z > s && z < s + n && new TextDecoder('latin1').decode(u.subarray(s, z)) === 'sbdc-srB') {
                var j = JSON.parse(new TextDecoder('latin1').decode(u.subarray(z + 1, s + n)));
                r.doc = Object.assign({}, r.doc, { srB: j.srB, sr: j.sr }); break;
              }
              p += 12 + n;
            }
            settle();
          }).catch(function () { settle(); });
          return;
        }
        if (!/svg/.test(r.content_type || '') || !r.file_url) return;
        waiting++;
        // SVG 하나가 느려도 전체 목록이 무한 대기하지 않게 — 개별 10초 제한
        var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var tm = setTimeout(function () { try { ctl && ctl.abort(); } catch (e) {} }, 45000);   // 2026-09-16: 10s dropped a 3.6MB template on a 4Mbps line («could not load»); 45s
        fetch(r.file_url, ctl ? { signal: ctl.signal } : {})
          .then(function (x) { return x.ok ? x.text() : null; })
          .then(function (t) { clearTimeout(tm); if (t) svgCache[r.id] = t; settle(); })
          .catch(function () { clearTimeout(tm); settle(); });
      });
      if (!waiting) finish();
      else setTimeout(finish, 50000);   // 마지막 안전망 — 12초 뒤엔 받은 것만으로 목록을 세운다
    });
    restGet('dc_settings?select=*', function (rows, err) {
      settingsLoaded = true;                 // 실패해도 «다 봤다» — 시작 팝업을 붙잡아 두지 않는다
      if (!err && rows) rows.forEach(function (x) { dcSettings[x.key] = x.value || {}; });
      showAnnouncement();
    });
  }
  function showAnnouncement() {
    var a = dcSettings.announcement;
    if (!a || !a.enabled || !a.text || els.ann) return;
    els.ann = 띠(a.text, false);
    if (els.tplBar) els.tplBar.style.top = '104px';   // 공지가 먼저 자리를 잡는다
  }

  /* ---------------------------------------------------------------- A4 안내
     템플릿을 다 못 받았을 때 «한 줄» 을 띄운다. 관리자 공지에 쓰던 띠를 그대로 쓴다 —
     새 UI 를 만들지 않는다. 손님도 사장님도 «원래 이만큼» 이라고 오해하지 않게 하는 것이
     목적이므로, 몇 장을 못 받았는지까지 적는다. */
  var tplTrouble = { listFailed: null, svgFailed: 0 };
  function 띠(text, warn) {
    var bar = $('div', 'sbdc-announce' + (warn ? ' is-warn' : ''));
    bar.innerHTML = '<span></span>';
    bar.querySelector('span').textContent = text;
    var x = $('button', '', '&times;');
    x.type = 'button';
    x.onclick = function () { bar.remove(); };
    bar.appendChild(x);
    document.body.appendChild(bar);
    return bar;
  }
  function tplTroubleText() {
    if (tplTrouble.listFailed) {
      return 'Uploaded templates could not be loaded — only the built-in ones are shown ('
        + (tplTrouble.listFailed.detail || 'Connection failed') + ')';
    }
    if (tplTrouble.svgFailed) {
      /* «업로드 템플릿» 이라고 못 박는다. 목록은 상품 비율로 한 번 더 걸러지므로
         손님 화면에서 줄어든 장수와 이 숫자는 다를 수 있다 — 여기 숫자는
         «관리자가 올린 것 중 몇 장을 못 받았나» 이다. */
      return 'Uploaded templates ' + tplTrouble.svgFailed + ' could not be loaded and were removed from the list — try refreshing shortly';
    }
    return '';
  }
  function showTplTrouble() {
    var t = tplTroubleText();
    if (!t) return;
    if (els.tplBar) { els.tplBar.querySelector('span').textContent = t; return; }
    els.tplBar = 띠(t, true);
    if (els.ann) els.tplBar.style.top = '104px';     // 공지와 겹치지 않게 한 칸 아래로
  }
  window.__dcTplTrouble = function () {              // 시험용 훅
    return { listFailed: tplTrouble.listFailed, svgFailed: tplTrouble.svgFailed, text: tplTroubleText() };
  };

  /* ================================================================ boot */
  function injectBar() {
    var bar = document.querySelector('.appbar .help-line');
    if (!bar || document.getElementById('sbdc-openbtn')) return;
    var b = $('button', 'sbdc-open-btn', 'Change product · finishing');
    b.type = 'button'; b.id = 'sbdc-openbtn'; b.onclick = open;
    var k = $('button', 'sbdc-open-btn', 'Shortcuts ?');
    k.type = 'button'; k.onclick = openKeys;
    bar.parentNode.insertBefore(k, bar.nextSibling);
    bar.parentNode.insertBefore(b, bar.nextSibling);
  }
  function boot() {
    fetchRemote();
    initDrop();
    initRail();
    setInterval(function () { try { refreshNotice(); } catch (e) {} }, 700);
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      injectBar();
      if (window.__dcApi) {
        clearInterval(iv);
        if (location.search.indexOf('nostart=1') === -1) {
          var w2 = 0, iv2 = setInterval(function () {
            w2++;
            if (settingsLoaded || w2 > 12) {
              clearInterval(iv2);
              if (!(dcSettings.start_popup && dcSettings.start_popup.enabled === false)) open();
            }
          }, 180);
        }
      } else if (tries > 120) clearInterval(iv);
    }, 120);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

    

/* ===== sbdc-multiselect ===== */

/* =====================================================================
   원하는 것만 고르기 — 드래그 상자 · Shift 클릭

   지금까지는 한 번에 하나만 골라졌다. 고객이 «이 셋만 오른쪽으로» 하려면
   세 번을 따로 옮겨야 했다.

   여기서 하는 일:
     빈 곳에서 드래그   지나간 자리에 닿은 것들이 한꺼번에 골라진다
     Shift(⌘/Ctrl) 클릭  하나씩 더하고 뺀다
     레이어 목록        Shift = 사이까지 한꺼번에 · ⌘/Ctrl = 하나씩
     Ctrl/⌘ + A         전부 고르기

   여럿을 골랐을 때:
     옮기기      아무거나 하나를 끌면 나머지가 같이 따라온다 (Konva 트랜스포머가
                 붙은 것들을 같은 거리만큼 옮겨 준다)
     크기·회전   골라진 것들을 감싼 상자의 손잡이로 한꺼번에
     색·글꼴     오른쪽 패널에서 바꾸면 골라진 것 모두에 퍼진다 (__dcFan)
     맞춤        캔버스 위에 뜨는 작은 막대에서 왼쪽/가운데/오른쪽·위/중간/아래
     지우기·복제 Delete · Ctrl/⌘+D

   번들에는 열 자리를 얹었다 — 자세한 것은 VERSION.md 의 «손댄 자리».
   ===================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     상태
     ids        : 여럿을 골랐을 때의 목록. 하나 이하이면 빈 배열로 둔다
                  (하나짜리는 앱이 원래 쓰던 selectedId 가 그대로 진실이다)
     expecting  : setSelectedId 를 부른 직후, 아직 화면에 반영되지 않은 기준 id
     ------------------------------------------------------------------ */
  var ids = [];
  var expecting;               // undefined = 기다리는 것 없음
  var ver = 0, subs = [];
  var pending = null;          // 눌렀지만 «끌지 않으면 하나로 좁힐» 대상
  var downPt = null, dragged = false;
  var raf = 0;

  function api() { return window.__dcApi || null; }
  function geom() { return window.__dcGeom || null; }
  function bump() { ver++; for (var i = 0; i < subs.length; i++) { try { subs[i](); } catch (e) {} } }

  /* 번들이 다시 그리도록 알리는 창구 (useSyncExternalStore) */
  window.__dcSub = function (cb) {
    subs.push(cb);
    return function () { var i = subs.indexOf(cb); if (i >= 0) subs.splice(i, 1); };
  };
  window.__dcVer = function () { return ver; };

  function index() {
    var a = api(), m = {};
    if (a) for (var i = 0; i < a.doc.layers.length; i++) m[a.doc.layers[i].id] = a.doc.layers[i];
    return m;
  }
  function anchorId() {
    if (expecting !== undefined) return expecting;
    var a = api(); return a ? a.selectedId : null;
  }

  /* 앱이 우리 모르게 선택을 바꿨으면(템플릿 적용·새 요소 추가 등) 목록을 접는다 */
  function sync() {
    var a = api(); if (!a) return;
    if (expecting !== undefined) {
      if (a.selectedId === expecting) expecting = undefined;
      else return;
    }
    if (!ids.length) return;
    var live = {}, ls = a.doc.layers, i;
    for (i = 0; i < ls.length; i++) live[ls[i].id] = 1;
    ids = ids.filter(function (id) { return live[id]; });
    if (a.selectedId == null || ids.indexOf(a.selectedId) < 0) ids = [];
  }

  function selIds() {
    sync();
    if (ids.length > 1) return ids.slice();
    var id = anchorId();
    return id ? [id] : [];
  }
  function isMulti() { sync(); return ids.length > 1; }

  function setSel(list, anchor) {
    var a = api(); if (!a) return;
    list = (list || []).filter(function (id, i, arr) { return arr.indexOf(id) === i; });
    if (!list.length) { ids = []; expecting = null; a.setSelectedId(null); after(); return; }
    if (anchor == null || list.indexOf(anchor) < 0) anchor = list[list.length - 1];
    ids = list.length > 1 ? list : [];
    expecting = anchor;
    a.setSelectedId(anchor);
    after();
  }
  function setAnchorOnly(id) {
    var a = api(); if (!a || a.selectedId === id) return;
    expecting = id; a.setSelectedId(id); after();
  }
  function toggle(id) {
    var cur = selIds(), i = cur.indexOf(id);
    if (i >= 0) { cur.splice(i, 1); setSel(cur, cur.length ? cur[cur.length - 1] : null); }
    else { cur.push(id); setSel(cur, id); }
  }
  function after() { applyTr(); bump(); tick(); }

  /* ------------------------------------------------------------------
     크기 상자 — 골라진 것들을 트랜스포머에 붙인다
     ------------------------------------------------------------------ */
  window.__dcTrNodes = function (n, map, preview, rotating) {
    sync();
    if (preview || rotating) return n ? [n] : [];
    var list = selIds();
    if (list.length < 2) return n ? [n] : [];
    var byId = index(), out = [];
    for (var i = 0; i < list.length; i++) {
      var L = byId[list[i]], nd = map && map[list[i]];
      if (L && L.visible && !L.locked && nd) out.push(nd);
    }
    return out.length > 1 ? out : (n ? [n] : []);
  };

  function applyTr() {
    var g = geom();
    if (!g || !g.tr || !g.tr.current || !g.nodes) return;
    var map = g.nodes.current || {}, id = anchorId(), byId = index();
    var L = id ? byId[id] : null;
    var n = (L && !L.locked && !g.pv && !g.rot && map[id]) ? map[id] : null;
    var ns = window.__dcTrNodes(n, map, g.pv, g.rot);
    try {
      var tr = g.tr.current;
      tr.nodes(ns);
      tr.visible(ns.length > 0);
      var lay = tr.getLayer(); if (lay) lay.batchDraw();
    } catch (e) {}
  }

  /* ------------------------------------------------------------------
     캔버스에서 고르기
     ------------------------------------------------------------------ */
  window.__dcMultiOn = function () { return isMulti(); };
  window.__dcInSel = function (id) { sync(); return ids.length > 1 && ids.indexOf(id) >= 0; };

  window.__dcPick = function (id, ke) {
    sync();
    var evt = (ke && ke.evt) || {};
    if (evt.shiftKey || evt.metaKey || evt.ctrlKey) { pending = null; toggle(id); return; }
    var cur = selIds();
    if (cur.length > 1 && cur.indexOf(id) >= 0) {
      /* 이미 골라진 것을 눌렀다 — 끌면 다 같이 움직이고, 끌지 않으면 이것 하나만 */
      pending = id;
      setAnchorOnly(id);
      return;
    }
    pending = null;
    setSel([id], id);
  };

  window.__dcPickList = function (id, ev) {
    var a = api(); if (!a) return;
    sync();
    ev = ev || {};
    if (ev.shiftKey) {
      var order = a.doc.layers.map(function (L) { return L.id; }).reverse();  // 목록에 보이는 차례
      var from = order.indexOf(anchorId()), to = order.indexOf(id);
      if (from < 0 || to < 0) { setSel([id], id); return; }
      var s = Math.min(from, to), e = Math.max(from, to);
      setSel(order.slice(s, e + 1), id);
      return;
    }
    if (ev.metaKey || ev.ctrlKey) { toggle(id); return; }
    setSel([id], id);
  };

  /* ------------------------------------------------------------------
     빈 곳에서 드래그 — 지나간 상자에 닿은 것을 고른다
     ------------------------------------------------------------------ */
  function aabb(L) {
    var w = L.widthIn || 0, h = L.heightIn || 0;
    var cx = (L.xIn || 0) + w / 2, cy = (L.yIn || 0) + h / 2;
    var r = (L.rotation || 0) * Math.PI / 180;
    var c = Math.abs(Math.cos(r)), s = Math.abs(Math.sin(r));
    var W = w * c + h * s, H = w * s + h * c;
    return { x: cx - W / 2, y: cy - H / 2, w: W, h: H, cx: cx, cy: cy };
  }

  window.__dcMarquee = function (ke, clear) {
    var evt = ke && ke.evt;
    var g = geom();
    var vp = g && g.vp && g.vp.current;
    if (!evt || evt.touches || (evt.button !== undefined && evt.button !== 0) || !vp) {
      if (clear) clear();
      return;
    }
    var add = !!(evt.shiftKey || evt.metaKey || evt.ctrlKey);
    var base = add ? selIds() : [];
    if (!add) { ids = []; if (clear) clear(); }

    var r0 = vp.getBoundingClientRect();
    var x0 = evt.clientX - r0.left, y0 = evt.clientY - r0.top;
    var box = null, moved = false;

    function px2in(px, py) { return { x: (px - g.ox) / g.scale, y: (py - g.oy) / g.scale }; }

    function draw(x1, y1) {
      var l = Math.min(x0, x1), t = Math.min(y0, y1);
      box.style.left = l + 'px'; box.style.top = t + 'px';
      box.style.width = Math.abs(x1 - x0) + 'px';
      box.style.height = Math.abs(y1 - y0) + 'px';
    }
    function cancel() { up({ type: 'pointercancel' }); }
    function move(e) {
      if (e.buttons === 0) { cancel(); return; }
      var x1 = e.clientX - r0.left, y1 = e.clientY - r0.top;
      if (!moved && Math.abs(x1 - x0) + Math.abs(y1 - y0) < 4) return;
      if (!moved) {
        moved = true;
        box = document.createElement('div');
        box.className = 'dc-marquee';
        vp.appendChild(box);
      }
      draw(x1, y1);
    }
    function up(e) {
      window.removeEventListener('pointermove', move, true);
      window.removeEventListener('pointerup', up, true);
      window.removeEventListener('pointercancel', up, true);
      window.removeEventListener('blur', cancel, true);
      if (box && box.parentNode) box.parentNode.removeChild(box);
      if (!moved || e.type === 'pointercancel') return;
      var x1 = e.clientX - r0.left, y1 = e.clientY - r0.top;
      var a1 = px2in(Math.min(x0, x1), Math.min(y0, y1));
      var b1 = px2in(Math.max(x0, x1), Math.max(y0, y1));
      var a = api(); if (!a) return;
      var hit = base.slice();
      a.doc.layers.forEach(function (L) {
        if (!L.visible || L.locked) return;
        var b = aabb(L);
        if (b.x > b1.x || b.x + b.w < a1.x || b.y > b1.y || b.y + b.h < a1.y) return;
        if (hit.indexOf(L.id) < 0) hit.push(L.id);
      });
      setSel(hit, hit[hit.length - 1]);
    }
    window.addEventListener('pointermove', move, true);
    window.addEventListener('pointerup', up, true);
    window.addEventListener('pointercancel', up, true);
    window.addEventListener('blur', cancel, true);
  };

  /* ------------------------------------------------------------------
     한 번에 여럿 고치기 — 색·글꼴처럼 «생김새» 는 골라진 모두에게
     __dcNoFan 이 켜져 있을 때(= 캔버스에서 끌거나 크기를 잴 때)는 퍼뜨리지 않는다.
     그때는 Konva 가 이미 하나하나를 옮겨 놓았기 때문이다.
     ------------------------------------------------------------------ */
  var NEVER = { text: 1, name: 1, id: 1, widthIn: 1, heightIn: 1 };

  window.__dcFan = function (anchor, patch, ls) {
    if (window.__dcNoFan) return null;
    sync();
    if (ids.length < 2 || ids.indexOf(anchor) < 0) return null;
    var keys = Object.keys(patch || {});
    if (!keys.length) return null;
    var base = null, i;
    for (i = 0; i < ls.length; i++) if (ls[i].id === anchor) base = ls[i];
    if (!base) return null;
    var dx = ('xIn' in patch) ? patch.xIn - (base.xIn || 0) : 0;
    var dy = ('yIn' in patch) ? patch.yIn - (base.yIn || 0) : 0;
    var out = {}; out[anchor] = patch;
    for (i = 0; i < ls.length; i++) {
      var L = ls[i];
      if (L.id === anchor || ids.indexOf(L.id) < 0 || L.locked) continue;
      var p = {};
      for (var k = 0; k < keys.length; k++) {
        var key = keys[k];
        if (NEVER[key]) continue;
        if (key === 'xIn') { p.xIn = (L.xIn || 0) + dx; continue; }
        if (key === 'yIn') { p.yIn = (L.yIn || 0) + dy; continue; }
        if (!(key in L)) continue;          /* 도형에 굵게 같은 것을 붙이지 않는다 */
        p[key] = patch[key];
      }
      if (Object.keys(p).length) out[L.id] = p;
    }
    return Object.keys(out).length > 1 ? out : null;
  };

  /* ------------------------------------------------------------------
     지우기 · 복제 · 전부 고르기
     ------------------------------------------------------------------ */
  window.__dcDelSel = function () {
    sync();
    var a = api(); if (!a || ids.length < 2) return false;
    var byId = index();
    var kill = ids.filter(function (id) { return byId[id] && !byId[id].locked; });
    if (!kill.length) return false;
    a.setDoc({ layers: a.doc.layers.filter(function (L) { return kill.indexOf(L.id) < 0; }) });
    ids = []; expecting = null; a.setSelectedId(null); after();
    return true;
  };

  function dupAll() {
    sync();
    var a = api(); if (!a || ids.length < 2) return false;
    var stamp = Date.now().toString(36), copies = [], fresh = [];
    a.doc.layers.forEach(function (L) {
      if (ids.indexOf(L.id) < 0) return;
      var c = JSON.parse(JSON.stringify(L));
      c.id = L.type + '_' + stamp + '_' + Math.random().toString(36).slice(2, 6);
      c.name = L.name + ' copy';
      c.xIn = (L.xIn || 0) + 1; c.yIn = (L.yIn || 0) + 1;
      c.locked = false;
      if (window.__dcCopyTag) window.__dcCopyTag(c, L, stamp);
      copies.push(c); fresh.push(c.id);
    });
    if (!copies.length) return false;
    a.setDoc({ layers: a.doc.layers.concat(copies) });
    setSel(fresh, fresh[fresh.length - 1]);
    return true;
  }
  window.__dcDupSel = dupAll;

  function selectAll() {
    var a = api(); if (!a) return false;
    var list = a.doc.layers.filter(function (L) { return L.visible && !L.locked; })
                           .map(function (L) { return L.id; });
    if (!list.length) return false;
    setSel(list, list[list.length - 1]);
    return true;
  }

  function overlayOpen() {
    if (document.querySelector('.modal-backdrop')) return true;
    var els = document.querySelectorAll('.is-open');
    for (var i = 0; i < els.length; i++) {
      var s = getComputedStyle(els[i]);
      if (s.position === 'fixed' && s.display !== 'none' && s.visibility !== 'hidden') return true;
    }
    return false;
  }

  var prevShortcut = window.__dcShortcut;
  window.__dcShortcut = function (e) {
    var t = e.target;
    var typing = t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' ||
                       t.tagName === 'SELECT' || t.isContentEditable);
    var mod = e.metaKey || e.ctrlKey;
    var low = e.key && e.key.length === 1 ? e.key.toLowerCase() : e.key;

    /* 먼저 가로채야 하는 것 — 팀원 단축키가 «고른 하나» 로 처리해 버리기 때문 */
    if (!typing && mod && !overlayOpen()) {
      if (low === 'a') { if (selectAll()) { e.preventDefault(); return true; } }
      if (low === 'd' && isMulti()) { if (dupAll()) { e.preventDefault(); return true; } }
    }

    var handled = prevShortcut ? prevShortcut(e) : false;
    if (handled) return true;
    if (typing) return false;

    if ((e.key === 'Delete' || e.key === 'Backspace') && isMulti()) {
      if (window.__dcDelSel()) { e.preventDefault(); return true; }
    }
    if (e.key === 'Escape' && isMulti()) { setSel([], null); e.preventDefault(); return true; }
    return false;
  };

  /* ------------------------------------------------------------------
     맞춤 막대 — 둘 이상 골랐을 때 캔버스 위에 뜬다
     ------------------------------------------------------------------ */
  var bar = null, countEl = null, spreadBtns = [];

  function nudge(patches) {
    var a = api(); if (!a) return;
    window.__dcNoFan = true;
    a.beginDrag();                                   /* 되돌리기 한 걸음만 남긴다 */
    Object.keys(patches).forEach(function (id) { a.updateLayer(id, patches[id], false); });
    a.endDrag();
    setTimeout(function () { window.__dcNoFan = false; }, 0);
    tick();
  }

  function align(how) {
    var byId = index(), list = selIds(), boxes = [], i;
    for (i = 0; i < list.length; i++) {
      var L = byId[list[i]];
      if (L && !L.locked) boxes.push({ L: L, b: aabb(L) });
    }
    if (boxes.length < 2) return;
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    boxes.forEach(function (o) {
      minX = Math.min(minX, o.b.x); maxX = Math.max(maxX, o.b.x + o.b.w);
      minY = Math.min(minY, o.b.y); maxY = Math.max(maxY, o.b.y + o.b.h);
    });
    var patches = {};
    boxes.forEach(function (o) {
      var p = {};
      if (how === 'left')   p.xIn = o.L.xIn + (minX - o.b.x);
      if (how === 'hcen')   p.xIn = o.L.xIn + ((minX + maxX) / 2 - o.b.cx);
      if (how === 'right')  p.xIn = o.L.xIn + (maxX - (o.b.x + o.b.w));
      if (how === 'top')    p.yIn = o.L.yIn + (minY - o.b.y);
      if (how === 'vcen')   p.yIn = o.L.yIn + ((minY + maxY) / 2 - o.b.cy);
      if (how === 'bottom') p.yIn = o.L.yIn + (maxY - (o.b.y + o.b.h));
      if (Object.keys(p).length) patches[o.L.id] = p;
    });
    nudge(patches);
  }

  function spread(axis) {
    var byId = index(), list = selIds(), boxes = [], i;
    for (i = 0; i < list.length; i++) {
      var L = byId[list[i]];
      if (L && !L.locked) boxes.push({ L: L, b: aabb(L) });
    }
    if (boxes.length < 3) return;
    var key = axis === 'x' ? 'cx' : 'cy';
    boxes.sort(function (p, q) { return p.b[key] - q.b[key]; });
    var first = boxes[0].b[key], last = boxes[boxes.length - 1].b[key];
    var step = (last - first) / (boxes.length - 1);
    var patches = {};
    boxes.forEach(function (o, n) {
      if (n === 0 || n === boxes.length - 1) return;
      var want = first + step * n, p = {};
      if (axis === 'x') p.xIn = o.L.xIn + (want - o.b.cx);
      else p.yIn = o.L.yIn + (want - o.b.cy);
      patches[o.L.id] = p;
    });
    nudge(patches);
  }

  function svgBtn(title, d, fn) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'dcms-btn'; b.title = title;
    b.setAttribute('aria-label', title);
    b.innerHTML = '<svg viewBox="0 0 20 20" width="17" height="17" fill="none" stroke="currentColor" ' +
                  'stroke-width="1.6" stroke-linecap="round">' + d + '</svg>';
    b.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    b.addEventListener('click', function (e) { e.preventDefault(); fn(); });
    return b;
  }

  function buildBar() {
    bar = document.createElement('div');
    bar.className = 'dcms-bar';
    countEl = document.createElement('span');
    countEl.className = 'dcms-count';
    bar.appendChild(countEl);

    var g = [
      ['Align left',   '<path d="M3 3v14"/><rect x="6" y="5" width="10" height="3.4"/><rect x="6" y="11.6" width="6" height="3.4"/>', function () { align('left'); }],
      ['Center horizontally', '<path d="M10 3v14"/><rect x="4" y="5" width="12" height="3.4"/><rect x="6.5" y="11.6" width="7" height="3.4"/>', function () { align('hcen'); }],
      ['Align right', '<path d="M17 3v14"/><rect x="4" y="5" width="10" height="3.4"/><rect x="8" y="11.6" width="6" height="3.4"/>', function () { align('right'); }],
      ['Align top',     '<path d="M3 3h14"/><rect x="5" y="6" width="3.4" height="10"/><rect x="11.6" y="6" width="3.4" height="6"/>', function () { align('top'); }],
      ['Center vertically', '<path d="M3 10h14"/><rect x="5" y="4" width="3.4" height="12"/><rect x="11.6" y="6.5" width="3.4" height="7"/>', function () { align('vcen'); }],
      ['Align bottom',   '<path d="M3 17h14"/><rect x="5" y="4" width="3.4" height="10"/><rect x="11.6" y="8" width="3.4" height="6"/>', function () { align('bottom'); }]
    ];
    g.forEach(function (o) { bar.appendChild(svgBtn(o[0], o[1], o[2])); });

    var sx = svgBtn('Distribute horizontally', '<rect x="2" y="5" width="3" height="10"/><rect x="8.5" y="5" width="3" height="10"/><rect x="15" y="5" width="3" height="10"/>', function () { spread('x'); });
    var sy = svgBtn('Distribute vertically', '<rect x="5" y="2" width="10" height="3"/><rect x="5" y="8.5" width="10" height="3"/><rect x="5" y="15" width="10" height="3"/>', function () { spread('y'); });
    spreadBtns = [sx, sy];
    bar.appendChild(sx); bar.appendChild(sy);

    var sep = document.createElement('i'); sep.className = 'dcms-sep'; bar.appendChild(sep);
    bar.appendChild(svgBtn('Duplicate (⌘/Ctrl+D)', '<rect x="3" y="3" width="9" height="9"/><path d="M8 8h9v9H8z"/>', dupAll));
    var del = svgBtn('Delete', '<path d="M4 6h12M8 6V4h4v2M6 6l1 11h6l1-11"/>', function () { window.__dcDelSel(); });
    del.classList.add('is-danger');
    bar.appendChild(del);
  }

  function place() {
    var g = geom(), host = document.querySelector('.canvas-viewport');
    var show = isMulti() && !dragged && g && !g.pv;
    if (!show || !host) {
      if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
      return;
    }
    if (!bar) buildBar();
    if (bar.parentNode !== host) host.appendChild(bar);

    var byId = index(), list = selIds();
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity, n = 0;
    list.forEach(function (id) {
      var L = byId[id]; if (!L) return;
      var b = aabb(L); n++;
      minX = Math.min(minX, b.x); maxX = Math.max(maxX, b.x + b.w);
      minY = Math.min(minY, b.y); maxY = Math.max(maxY, b.y + b.h);
    });
    if (!n || !isFinite(minX)) return;
    var left = g.ox + ((minX + maxX) / 2) * g.scale;
    var top = g.oy + minY * g.scale - 78;      /* 회전 손잡이를 가리지 않게 */
    if (top < 6) top = g.oy + maxY * g.scale + 30;
    bar.style.left = Math.round(left) + 'px';
    bar.style.top = Math.round(top) + 'px';
    countEl.textContent = list.length + ' selected';
    spreadBtns.forEach(function (b) { b.style.display = list.length >= 3 ? '' : 'none'; });
  }

  function tick() {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = 0;
      place();
      if (isMulti()) tick();      /* 확대·이동을 따라다닌다 */
    });
  }

  /* ------------------------------------------------------------------
     누름 / 끎 감시 — 끌고 있는 동안에는 막대를 감추고, 캔버스에서 난 고침은
     퍼뜨리지 않는다
     ------------------------------------------------------------------ */
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.canvas-viewport') && !(t.closest && t.closest('.dcms-bar'))) {
      window.__dcNoFan = true;
      downPt = { x: e.clientX, y: e.clientY };
      dragged = false;
    }
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!downPt || dragged) return;
    if (Math.abs(e.clientX - downPt.x) + Math.abs(e.clientY - downPt.y) > 3) { dragged = true; place(); }
  }, true);

  document.addEventListener('pointerup', function () {
    if (pending && !dragged) { var id = pending; pending = null; setSel([id], id); }
    pending = null; downPt = null;
    setTimeout(function () {
      dragged = false;
      window.__dcNoFan = false;
      applyTr();
      tick();
    }, 0);
  }, true);

  /* ------------------------------------------------------------------
     겉모습
     ------------------------------------------------------------------ */
  var css = document.createElement('style');
  css.textContent = [
    '.dc-marquee{position:absolute;z-index:7;pointer-events:none;border:1.5px solid var(--accent,#00697F);',
    'background:color-mix(in srgb, var(--accent,#00697F) 12%, transparent);border-radius:2px}',
    '.dcms-bar{position:absolute;z-index:8;transform:translateX(-50%);display:flex;align-items:center;gap:2px;',
    'padding:5px 8px;border-radius:9px;background:var(--surface,#fff);border:1.5px solid var(--rule-2,#cdd8da);',
    'box-shadow:var(--shadow-md,0 6px 20px rgba(0,0,0,.16));white-space:nowrap}',
    '.dcms-count{font-size:12px;font-weight:700;color:var(--accent,#00697F);padding:0 6px 0 2px}',
    '.dcms-btn{width:28px;height:28px;display:grid;place-items:center;border:none;border-radius:6px;',
    'background:0 0;color:var(--ink-2,#39494d);cursor:pointer}',
    '.dcms-btn:hover{background:var(--surface-2,#e8edee);color:var(--accent,#00697F)}',
    '.dcms-btn.is-danger:hover{background:#fdecec;color:#b3261e}',
    '.dcms-btn svg rect{fill:currentColor;stroke:none;opacity:.85}',
    '.dcms-sep{width:1px;height:18px;background:var(--rule-2,#cdd8da);margin:0 4px}',
    '.layer-item.is-multi{background:var(--accent-soft,#e2f0f2);border-color:var(--accent,#00697F)}'
  ].join('');
  document.head.appendChild(css);
})();
    

/* ===== sbdc-grommet ===== */

/* ================================================================
   그로멧 배치 규칙 (2026-08-25 확정)
     한 변이 4ft(48″) 이상  → 그 변에 30″ 를 넘지 않게 «균등 분배»
     한 변이 4ft 미만        → 그 변은 모서리에만
   변마다 따로 판정한다. 96″ x 36″ 이면 가로만 4구간(23.5″), 세로는 모서리.
   번들의 Be() 가 이 객체를 읽는다 — 값만 바꾸면 배치가 따라온다.
     mode 'even'  : 30″ 이하로 균등 (생산 기준, 기본값)
     mode 'exact' : 정확히 30″ 씩 찍고 마지막 칸만 남는 만큼
   ================================================================ */
(function () {
  'use strict';
  window.__dcGrommetRule = { minSideIn: 48, maxGapIn: 30, mode: 'even' };

  // 마감 패널 readout 문구 — 지금 규격에서 실제로 어떻게 찍히는지 보여준다
  window.__dcGrommetLabel = function (wIn, hIn) {
    var R = window.__dcGrommetRule, w = +wIn || 0, h = +hIn || 0;
    var lw = w >= R.minSideIn, lh = h >= R.minSideIn;
    if (!lw && !lh) return 'corners only';
    var gap = function (L) {
      var span = L - 2;                                  // 양 끝 1″ 인셋
      if (span <= 0) return 0;
      var seg = Math.max(1, Math.ceil(span / R.maxGapIn));
      return R.mode === 'exact' ? R.maxGapIn : span / seg;
    };
    var parts = [];
    if (lw) parts.push('Width ' + gap(w).toFixed(1).replace(/\.0$/, '') + '″');
    if (lh) parts.push('Height ' + gap(h).toFixed(1).replace(/\.0$/, '') + '″');
    return parts.join(' · ') + (lw && lh ? '' : ' · corners only elsewhere');
  };
})();


/* ===== sbdc-finmap ===== */


  /* ================================================================
     상품별 마감(Finishing) 옵션 매핑
     스토어 실사 기준:
       - 리트랙터블 / X배너 : Shopify 태그 hide_finishing_options → 마감 없음
       - 접착배너·윈도우데칼 : 접착식이라 걸이 하드웨어 불필요 → '없음'만
       - 패브릭류(패브릭배너·패브릭 스텝앤리피트·팝업 백드롭) : 그로밋 대신 봉제/포켓
       - 스티커 전부 : 다이컷 재단 → 마감 없음
       - 그 외 배너/비닐 스텝앤리피트 : 표준 6종 전부
     ae = 번들의 마감 정의 배열(각 항목에 id 있음)
     ================================================================ */
  (function () {
    'use strict';

    // id 목록 (번들 ae 의 id 와 동일)
    var ALL = ['hem-grommets', 'hem-only', 'grommets-only', 'none', 'pockets-both', 'pockets-top'];
    var FABRIC = ['hem-only', 'none', 'pockets-both', 'pockets-top'];   // 패브릭: 그로밋 X
    var DECAL = ['none'];                                                // 접착: 재단만
    var NONE = [];                                                       // 마감 자체 없음

    // handle → 허용 마감 id 배열. 없거나 빈 배열이면 마감 패널을 숨긴다.
    var MAP = {
      'custom-vinyl-banners': ALL,
      'mesh-banners': ALL,
      'fabric-banners': FABRIC,
      'window-decals': DECAL,
      'custom-step-and-repeat-banner': ALL,
      'fabric-step-repeat-banners': FABRIC,
      'vinyl-step-and-repeat-banner': ALL,
      'fabric-step-and-repeat-banner': FABRIC,
      '10x8-fabric-pop-up-display-backdrop-banner-only': FABRIC,
      'pop-up-retractable-banner': NONE,   // hide_finishing_options
      'x-banner': NONE,                    // hide_finishing_options
      'double-sided-x-banner': NONE,       // hide_finishing_options
      'bumper-stickers': NONE,
      'kiss-cut-stickers': NONE,
      'round-stickers': NONE,
      'oval-stickers': NONE
    };

    function idsFor(handle) {
      // 명시되지 않은 신규 상품은 안전하게 표준 전체 허용
      return Object.prototype.hasOwnProperty.call(MAP, handle) ? MAP[handle] : ALL;
    }
    // 메인 화면이 보는 상품 — 「디자인 시작」 으로 실제 적용된 것
    function appliedHandle() {
      var p = window.__dcProduct;
      return (p && p.id) || (window.__dcSelectedProduct && window.__dcSelectedProduct.handle) || 'custom-vinyl-banners';
    }
    // 시작 팝업이 «고르는 중» 인 상품 — 팝업 자신을 그릴 때만 쓴다
    function draftHandle() {
      var h = (typeof window.__dcPopupHandle === 'function') && window.__dcPopupHandle();
      return h || appliedHandle();
    }
    function allowedIds() { return idsFor(appliedHandle()); }
    window.__dcFinishingAllowed = allowedIds;
    window.__dcHasFinishing = function () { return allowedIds().length > 0; };

    // 번들 마감 패널: 허용된 마감만 남긴다 (순서는 원본 유지)
    window.__dcFinishingList = function (ae) {
      var ok = allowedIds();
      var list = ae.filter(function (o) { return ok.indexOf(o.id) >= 0; });
      // 현재 선택이 목록에 없으면 첫 항목으로 스냅
      try {
        var api = window.__dcApi;
        if (api && api.spec && list.length && ok.indexOf(api.spec.finishing) < 0) {
          // 렌더 도중 setState 를 피하려고 다음 틱으로 미룬다
          setTimeout(function () {
            try {
              var a2 = window.__dcApi;
              if (a2 && a2.spec && allowedIds().indexOf(a2.spec.finishing) < 0) a2.setSpec({ finishing: list[0].id });
            } catch (e) {}
          }, 0);
        }
      } catch (e) {}
      return list;
    };

    // 좌측 레일: 마감 없는 상품이면 '마감' 버튼 자체를 숨긴다
    window.__dcPanels = function (ct) {
      if (window.__dcHasFinishing()) return ct;
      return ct.filter(function (p) { return p.id !== 'finishing'; });
    };

    // 시작 팝업(증강)의 마감 목록도 같은 필터를 쓰도록 노출
    window.__dcFinishingFilterKo = function (FIN) {
      var ok = idsFor(draftHandle());          // 팝업은 «고르는 중» 인 상품 기준
      return FIN.filter(function (f) { return ok.indexOf(f.id) >= 0; });
    };

    // 캔버스에 폴포켓 밴드 + "POLE POCKET" 라벨을 그린다
    // spec=n, fe/pe=보드 px, E=px/inch, A=jsx 팩토리
    var POCKET_IN = 4.5;
    window.__dcPocketOverlay = function (spec, fe, pe, E, A) {
      if (!spec || !A) return null;
      var fin = spec.finishing;
      if (fin !== 'pockets-both' && fin !== 'pockets-top') return null;
      var band = POCKET_IN * E;
      if (!(band > 0) || !(fe > 0)) return null;
      var kids = [];
      function makeBand(yTop, key) {
        // 반투명 흰 밴드 + 하단 스티치 점선 + 가운데 라벨
        kids.push(A.jsx('Rect', {
          name: 'guide pocket', x: 0, y: yTop, width: fe, height: band,
          fill: '#ffffff', opacity: 0.72, listening: false
        }, 'pk-bg-' + key));
        var stitchY = key === 'top' ? yTop + band : yTop;
        kids.push(A.jsx('Line', {
          name: 'guide pocket', points: [0, stitchY, fe, stitchY],
          stroke: '#5b6b6f', strokeWidth: 1, dash: [6, 4], listening: false
        }, 'pk-st-' + key));
        kids.push(A.jsx('Text', {
          name: 'guide pocket', text: 'POLE POCKET', x: 0, y: yTop + band / 2 - Math.min(band * 0.32, 9),
          width: fe, align: 'center', fill: '#5b6b6f',
          fontSize: Math.max(8, Math.min(band * 0.5, 14)), fontStyle: 'bold',
          fontFamily: 'Archivo', letterSpacing: 2, listening: false
        }, 'pk-lb-' + key));
      }
      makeBand(0, 'top');
      if (fin === 'pockets-both') makeBand(pe - band, 'bottom');
      return A.jsxs('Group', { name: 'guide pocket-group', listening: false, children: kids }, 'pocketgrp');
    };
  })();

    

/* ===== sbdc-material ===== */


  /* ================================================================
     재질 선택 — 일반(Regular) / 리무버블(Removable)          [A19]

     스토어에는 «같은 크기 · 다른 재질» 변형이 둘씩 있는데, 앱에는 고르는 칸이
     없었다. 장바구니 모듈이 PREFER 라는 내부 표로 늘 Regular 를 골라, 뗐다
     붙이는 리무버블을 원한 손님도 일반을 받았다.

     고르는 자리는 두 곳이고 값은 하나다.
       ① 시작 팝업 「4. 재질」            (sbdc-aug · state.mat)
       ② 왼쪽 레일 「재질」 패널           (여기 · spec.material)
     ①에서 「디자인 시작」을 누르면 setSpec({material}) 로 ②에 그대로 넘어간다.

     자리는 마감(Finishing)과 똑같이 잡았다 — 레일에서 「규격」 바로 아래,
     패널 안은 같은 라디오 목록(.opt-list). 마감이 없는 스티커에서는 마감
     단추가 숨고 그 자리에 재질 단추가 선다.

     2026-08-27 스토어 실측 — 두 재질의 가격이 419쌍 전부 같고, 한쪽만 있는
     규격도 품절도 없다. 그래서 가격·면적·마감 계산은 하나도 건드리지 않는다.
     ================================================================ */
  (function () {
    'use strict';

    function prod() {
      try { return window.__dcAppliedProduct ? window.__dcAppliedProduct() : null; } catch (e) { return null; }
    }
    function mats() {
      try { return window.__dcMaterialsFor ? window.__dcMaterialsFor(prod()) : null; } catch (e) { return null; }
    }
    function has(M, id) {
      return !!(M && id && M.list.some(function (m) { return m.id === id; }));
    }

    /* 지금 고른 재질 id. 아직 안 골랐으면 첫 항목(일반)으로 본다.
       화면과 장바구니가 «같은 답» 을 보게 하려고 한 곳에서만 정한다. */
    window.__dcMaterialId = function () {
      var M = mats();
      if (!M) return null;
      var api = window.__dcApi, cur = api && api.spec && api.spec.material;
      return has(M, cur) ? cur : M.list[0].id;
    };
    window.__dcMaterialLabel = function () {
      var M = mats(), id = window.__dcMaterialId();
      if (!M || !id) return null;
      for (var i = 0; i < M.list.length; i++) if (M.list[i].id === id) return M.list[i].ko;
      return null;
    };

    /* 상품을 바꿔서 지금 값이 그 상품에 없는 재질이면 기본값으로 되돌린다.
       (그리는 도중 setState 를 피하려고 다음 틱으로 미룬다 — 마감이 쓰는 방식과 같다) */
    var fixing = false;
    function snap() {
      if (fixing) return;
      var M = mats(), api = window.__dcApi;
      if (!api || !api.spec) return;
      var cur = api.spec.material;
      var want = M ? (has(M, cur) ? cur : M.list[0].id) : null;
      if (cur === want || (cur == null && want == null)) return;
      fixing = true;
      setTimeout(function () {
        fixing = false;
        try {
          var a2 = window.__dcApi;
          if (a2 && a2.spec && a2.spec.material !== want) a2.setSpec({ material: want }, false);
        } catch (e) {}
      }, 0);
    }

    /* 좌측 레일 — 「규격」 바로 아래에 「재질」 을 끼운다.
       아이콘은 번들이 이미 들고 있는 마감 아이콘을 빌려 쓴다 (새로 그리지 않는다). */
    var prevPanels = window.__dcPanels;
    window.__dcPanels = function (ct) {
      var out = (typeof prevPanels === 'function') ? prevPanels(ct) : ct;
      snap();
      if (!mats()) return out;
      var icon = null, at = 0, i;
      for (i = 0; i < ct.length; i++) if (ct[i].id === 'finishing') icon = ct[i].icon;
      out = out.slice();
      for (i = 0; i < out.length; i++) if (out[i].id === 'spec') at = i + 1;
      out.splice(at, 0, { id: 'material', label: 'Material', icon: icon });
      return out;
    };

    /* 「재질」 패널 본문. 번들이 자기 jsx 팩토리(A)와 api 를 넘겨 준다 —
       폴포켓 겹그림(__dcPocketOverlay)이 쓰는 방식과 같다. */
    window.__dcMaterialPanel = function (A, api) {
      if (!A) return null;
      var M = mats();
      if (!M) return A.jsx('p', { className: 'fp-hint', children: 'This product has no material choice.' });
      var cur = window.__dcMaterialId();
      var rows = M.list.map(function (m) {
        return A.jsxs('label', { className: 'opt' + (cur === m.id ? ' is-active' : ''), children: [
          A.jsx('input', { type: 'radio', name: 'sbdc-material', checked: cur === m.id,
            onChange: function () { try { api.setSpec({ material: m.id }); } catch (e) {} } }),
          A.jsxs('span', { className: 'opt-main', children: [
            A.jsx('span', { className: 'opt-label', children: m.ko }),
            A.jsx('span', { className: 'opt-note', children: m.en + ' · ' + m.note })
          ] }),
          A.jsx('span', { className: 'opt-price is-free', children: 'Same price' })
        ] }, m.id);
      });
      var pick = null;
      for (var i = 0; i < M.list.length; i++) if (M.list[i].id === cur) pick = M.list[i];
      return A.jsxs(A.Fragment, { children: [
        A.jsx('p', { className: 'fp-hint',
          children: 'Only the adhesive differs; the price is the same. Choose regular for long-term use, removable if you will take it off later.' }),
        A.jsx('div', { className: 'opt-list', children: rows }),
        A.jsx('div', { className: 'readout', children:
          A.jsxs('div', { children: [
            A.jsx('span', { children: 'Options added to the order' }),
            A.jsx('b', { children: pick ? pick.en : '—' })
          ] })
        })
      ] });
    };
  })();

    

/* ===== sbdc-reset ===== */

/* =====================================================================
   「처음부터」 는 디자인만 지운다 — 고른 상품과 규격은 남긴다

   본체의 reset 은 «처음 켠 상태» 로 통째로 되돌린다.

     spec  → 96" × 36" · 헴+그로밋 · 1장      (배너 기본값)
     front → 빈 캔버스 · 시청 거리 15ft

   그런데 «어떤 상품인지» 는 본체가 모른다. 상품은 시작 팝업(sbdc-aug)이
   따로 들고 있고 reset 이 건드리지 않는다. 그래서 둘이 어긋난다.

     양면 X-배너 30"×69" $70  →  「처음부터」  →
       상품 이름 : 양면 X-배너 (그대로)
       단가      : $0.00      ← 96×36 은 이 상품에 없는 규격
       실제 규격 : 96" × 36"  ← 배너 기본값으로 돌아감
       합계      : $116.87    ← 24sq.ft × (70÷14.375sq.ft)

   버튼이 하겠다고 말하는 일은 «디자인 초기화» 뿐이다. 그래서 reset 을
   감싸서, 상품에 딸린 값(규격·마감·수량·시청 거리)은 그대로 되돌려 놓는다.
   레이어·배경은 본체가 지운 그대로 둔다.

   되돌릴 때는 patch(기록 안 남김)로 넣는다. reset 이 이미 되돌리기 기록을
   비웠으므로, 여기서 기록을 하나 만들면 되돌리기가 «빈 96×36» 으로 간다.
   ===================================================================== */
(function () {
  'use strict';

  function keepOf(api) {
    var s = api.spec || {}, d = api.doc || {};
    return {
      widthIn: s.widthIn, heightIn: s.heightIn,
      finishing: s.finishing, quantity: s.quantity,
      material: s.material,                       // 재질도 상품에 딸린 값이다 (A19)
      prod: s.__dcProd,                           // «어느 상품 것인가» 이름표 (V56-R03)
      viewFt: d.viewingDistanceFt
    };
  }

  function restore(api, k) {
    try {
      if (k.widthIn > 0 && k.heightIn > 0) {
        api.setSpec({
          widthIn: k.widthIn, heightIn: k.heightIn,
          finishing: k.finishing, quantity: k.quantity, material: k.material,
          __dcProd: k.prod                        // 이름표도 되살린다 (V56-R03)
        }, false);
      }
      if (k.viewFt > 0) api.setViewingDistance(k.viewFt, false);
    } catch (e) { /* 되돌리기에 실패해도 초기화 자체는 이미 끝났다 */ }
  }

  /* ── DC-120 ────────────────────────────────────────────────────────
     「처음부터」 는 묻지도 않고 지웠고, 되돌릴 수도 없었다.

     실측(2026-08-27): 손님이 만든 배너 위에서 「처음부터」 가 눌리면 확인 창 없이
     즉시 모두 지워지고, Ctrl+Z 를 눌러도 아무것도 돌아오지 않았다. 본체 reset 이
     되돌리기 기록까지 비우기 때문이다. 마우스로 잘못 눌러도 같은 결과였다.

     그래서 두 겹으로 막는다.
       ① 지울 것이 있으면 «정말 지울까요» 를 먼저 묻는다 (커서는 «취소» 에 둔다)
       ② 지운 뒤에 «되돌리기 한 칸» 을 다시 만들어 준다 — Ctrl+Z 한 번에 살아난다

     ②의 방법: 지우기 직전 문서를 들고 있다가, 지운 뒤에
       조용히 예전 것으로 돌렸다가(기록 없음) → 지금(빈 것)으로 다시 놓으면서 기록을 남긴다.
     그러면 되돌리기 기록에 «지우기 한 걸음» 이 생긴다. (브라우저에서 확인)

     한계 — 되살아나는 것은 «지금 보고 있는 면» 이다. 양면 상품은 현재 디자인센터에서
     빠져 있어(v5.5-3) 문제가 되지 않지만, 되살리면 뒷면도 함께 다뤄야 한다.
     ────────────────────────────────────────────────────────────────── */

  // 지울 것이 있나 — 빈 화면이면 물을 것도 없다
  function hasWork(api) {
    var d = api && api.doc;
    if (!d) return false;
    if (d.layers && d.layers.length) return true;
    return !!(d.background && String(d.background).toLowerCase() !== '#ffffff');
  }
  function snap(api) {
    try { return JSON.parse(JSON.stringify(api.doc)); } catch (e) { return null; }
  }
  function seedUndo(api, before, after) {
    if (!before || !after) return;
    /* «지운 뒤» 가 «지우기 전» 과 아직 똑같다면 화면이 다시 그려지기 «전» 이다 (A24 · DC-127).
       그대로 진행하면 아래 두 줄이 옛 디자인을 되돌리기 기록과 함께 다시 써 넣어
       지우기가 통째로 취소된다 — 실측: 「담고 다른 상품 디자인」 을 누르면 앞서 만든
       글자가 캔버스에 그대로 남았다. 되돌리기를 못 만드는 것보다 «안 지워지는 것» 이
       훨씬 나쁘다. 그래서 이럴 때는 되돌리기를 «만들지 않고» 지워진 상태를 지킨다.
       (「처음부터」 는 확인 창을 한 번 거치는 사이 화면이 그려져서 여기 걸리지 않는다 —
        DC-120 의 되돌리기는 그대로 살아 있다.) */
    try { if (JSON.stringify(before) === JSON.stringify(after)) return; } catch (e) { return; }
    try {
      api.setDoc(JSON.parse(JSON.stringify(before)), false);   // 조용히 되살림
      api.setDoc(JSON.parse(JSON.stringify(after)), true);     // 기록 남기며 다시 비움
    } catch (e) { /* 되돌리기를 못 만들어도 지우기 자체는 이미 끝났다 */ }
  }

  /* ── 되돌리기·다시하기도 감싼다 (V56-R03) ──────────────────────────
     상품은 본체의 되돌리기 기록 «밖» 에 있어서, undo 는 규격만 되돌리고 상품은
     새것에 남겼다 — 리트랙터블(31.5×80)인데 규격은 96×48, 가격은 $91.43 처럼.
     되돌린 «뒤» 에 규격의 이름표를 보고 상품을 맞춘다.

     두 길 모두 여기를 지난다:
       키보드 Ctrl+Z   → sbdc-aug 의 __dcShortcut 이 window.__dcApi.undo() 를 부른다
       툴바 되돌리기 단추 → 캔버스가 부모(윗 컴포넌트)보다 나중에 그려지므로,
                          그때는 이미 감싼 것이 들어가 있다
     ────────────────────────────────────────────────────────────────── */
  var moveCache = {};                             // 원본 → 감싼 것 (렌더마다 새로 안 만들게)

  function afterHistoryMove(before) {
    /* ⚠ 되돌리기를 «부른 즉시» 읽으면 안 된다. 본체는 React 라 아직 옛 규격을 들고 있고,
       그걸 «지금 값» 이라 믿고 아래에서 도로 써 넣으면 되돌리기가 통째로 취소된다.
       (doReset 이 setTimeout 을 쓰는 것과 같은 이유인데, 고정된 시간으로는 모자랐다.)

       본체는 다시 그릴 때마다 window.__dcApi 에 «새 객체» 를 넣는다. 그러니
       객체가 바뀌었는지로 «다시 그려졌나» 를 정확히 알 수 있다. 끝내 안 바뀌면
       (되돌릴 것이 없어 아무 일도 안 일어난 경우) 아무것도 하지 않고 물러난다.

       ⚠ 기다리는 간격은 반드시 0 이어야 한다. 8 로 두었다가 실제로 깨졌다.
          패치 층에는 화면을 다시 그리는 «도중에» 스스로 «0밀리초 뒤» 를 예약해 두고
          규격을 손보는 자리가 여럿 있다 — 수량 스냅(스티커), 재질 되맞춤, 마감 되맞춤,
          크기 칸 정리. 그것들은 예약될 때 «지금 상품» 을 아직 옛 상품으로 알고 있다.
          우리 예약은 되돌리기를 부른 시점에 미리 걸어 두므로, 간격이 같은 0 이면
          우리가 먼저 돈다(먼저 건 것이 먼저 만료). 8 로 벌리면 나중에 걸린 0밀리초가
          먼저 돌아, 아직 상품이 안 맞은 상태에서
            · 인치 규격을 «피트 자» 로 다시 재어 24″×24″ 로 줄이거나
            · 배너인데 스티커 수량표로 끌려가 1장이 25장이 되거나
          하는 일이 생긴다. 우리가 먼저 돌면 그것들은 다시 확인하고 스스로 물러난다. */
    var tries = 0;
    (function wait() {
      if (window.__dcApi === before) { if (++tries < 60) setTimeout(wait, 0); return; }
      try {
        if (typeof window.__dcSyncProductFromSpec !== 'function') return;
        if (!window.__dcSyncProductFromSpec()) return;   // 상품·규격이 그대로면 다시 그릴 것도 없다
        /* 전역만 바꾸면 화면 숫자가 안 따라온다.
           본체는 가격·검사 결과를 «규격 객체가 그대로면 다시 계산하지 않는다» 로 아껴 두는데,
           되돌리기는 옛 규격 «객체» 를 그대로 되살리므로 그 계산이 옛 상품 기준으로 굳는다
           (실측: 되돌린 뒤 상품·규격은 맞는데 합계가 $91.43 으로 남았다).
           그래서 «같은 값» 을 한 번 더 써 넣어 다시 계산하게 만든다.
             · 두 번째 인자 false = 되돌리기 기록을 남기지 않는다 (다시하기도 그대로 살아 있다)
             · 값은 그대로다 — 규격 다듬기(ftPull)는 파는 규격이든 자유 규격이든
               «같은 값을 넣으면 같은 값» 이고, 위 되맞춤에서 __dcInch 를 먼저 맞춰 두었다 */
        var a = window.__dcApi, s = a && a.spec;
        if (a && typeof a.setSpec === 'function' && s) {
          a.setSpec({ widthIn: s.widthIn, heightIn: s.heightIn, finishing: s.finishing,
                      quantity: s.quantity, material: s.material, __dcProd: s.__dcProd }, false);
        }
      } catch (e) {}
    })();
  }

  function wrapMove(fn, slot) {
    if (typeof fn !== 'function' || fn.__dcSyncsProduct) return fn;   // 이미 감싼 것
    if (moveCache[slot + 'Of'] === fn) return moveCache[slot];        // 같은 원본 — 만든 것을 재사용
    var out = function () {
      var before = window.__dcApi;                                    // 다시 그려졌는지 재는 기준
      var r = fn.apply(this, arguments);
      afterHistoryMove(before);
      return r;
    };
    out.__dcSyncsProduct = true;
    moveCache[slot + 'Of'] = fn; moveCache[slot] = out;
    return out;
  }

  function wrap(api) {
    if (!api) return api;
    api.undo = wrapMove(api.undo, 'undo');
    api.redo = wrapMove(api.redo, 'redo');
    if (typeof api.reset !== 'function' || api.reset.__dcKeepsProduct) return api;
    var orig = api.reset;

    /* seedable = «되돌리기를 만들어도 되는 자리인가».
       「처음부터」 는 실수로 누를 수 있으니 만든다(true · DC-120).
       「담고 다른 상품 디자인」 은 손님이 «첫 방문으로 가겠다» 고 고른 길이라 만들지 않는다
       (false · DC-127). 예전에는 이 구분이 «타이밍» 에 맡겨져 있었다 — 아래 seedUndo 의
       안전장치가 어쩌다 걸려 주는 식이라, 브라우저 사정이 바뀌면 「처음부터」 의 되돌리기가
       조용히 사라질 수 있었다. 이제 부르는 «단추» 가 직접 정한다. */
    function doReset(seedable) {
      var live = window.__dcApi || api;
      var k = keepOf(live), before = snap(live);
      orig();
      var live2 = window.__dcApi || live;
      restore(live2, k);
      /* «지운 뒤» 를 여기서 바로 읽으면 안 된다 — 본체는 React 라 아직 예전 문서를
         들고 있고, 그걸 «빈 것» 이라 믿고 되돌리기를 만들면 지우기가 통째로 취소된다
         (실측으로 걸렸다). 화면이 다시 그려진 다음 틱에 읽는다. */
      setTimeout(function () {
        if (!seedable) return;                       // 첫 방문으로 가는 길 — 되돌릴 것을 남기지 않는다
        var a2 = window.__dcApi || live2;
        seedUndo(a2, before, snap(a2));
      }, 0);
    }

    var next = function (opts) {
      var live = window.__dcApi || api;
      // 「새 디자인」(주문 뒤 처음부터 시작)은 손님이 이미 «새로 만들겠다» 고 고른 것이라 안 묻는다
      var silent = !!(opts && opts.silent);
      if (!silent && hasWork(live) && typeof window.__dcAsk === 'function') {
        window.__dcAsk({
          title: 'Start the design over from scratch',
          html: 'Everything on the canvas — <b>text, images and shapes — will be erased.</b><br>'
              + 'Your product, size, finishing and material stay as they are.<br><br>'
              + 'If you clear it by mistake, <b>undo (Ctrl+Z · ⌘Z)</b> brings it all back at once.',
          yes: 'Clear all', no: 'Cancel',
          onYes: function () { doReset(true); }      // 물어보고 지운 것은 되돌릴 수 있어야 한다 (DC-120)
        });
        return;
      }
      doReset(!silent);
    };
    next.__dcKeepsProduct = true;
    api.reset = next;
    return api;
  }

  // 본체는 그릴 때마다 window.__dcApi 에 새 객체를 넣는다.
  // 넣는 길목을 잡아 두면 어느 판이든 감싼 reset 을 쓰게 된다.
  // (본체는 type="module" 이라 이 스크립트보다 늦게 돈다 — 첫 대입부터 잡힌다)
  var live = null;
  Object.defineProperty(window, '__dcApi', {
    configurable: true,
    get: function () { return live; },
    set: function (v) { live = wrap(v); }
  });
})();
    

/* ===== sbdc-qr ===== */

/* =====================================================================
   QR 은 벡터로 만든다 — 만들자마자 «해상도 부족» 이 뜨던 문제

   예전에는 무조건 1200px PNG 를 만들어 최대 12인치로 놓았다.
     1200px ÷ 12in = 100 DPI  →  권장 125 DPI 미만  →  경고
   «대형 출력에서도 선명합니다» 라고 써 놓고 바로 아래에서 경고가 떴다.

   이제 SVG(벡터)로 만든다. 벡터는 원본 픽셀이 없으므로 얼마나 키우든
   출력 해상도 그대로 찍힌다. SVG 를 못 만드는 환경이면 PNG 로 물러서되,
   «놓일 인치 × 필요한 DPI» 를 먼저 계산해서 픽셀 수를 정한다.

   벡터라고 봐주는 기준은 «이름이 QR 이라서» 가 아니라
   **src 가 진짜 SVG 인지** 다. 아래 __dcClipIssues 에서 한 번 더 검사한다.
   ===================================================================== */
(function () {
  'use strict';

  var made = null;   // 마지막으로 만든 QR (안내 문구용)

  function num(n) { return String(Math.round(n * 100) / 100); }
  function svgToDataUrl(svg) {
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }
  function isSvgSrc(src) { return /^data:image\/svg\+xml/i.test(String(src || '')); }

  // 이 상품·이 거리에서 요구하는 DPI (회사 기준 125 아래로는 안 내려간다)
  function requiredDpi() {
    var api = window.__dcApi;
    var ft = (api && api.doc && api.doc.viewingDistanceFt) || 15;
    var std = ft <= 10 ? 125 : (ft <= 25 ? 125 : 125);   // 회사 기준은 거리와 무관하게 125
    return Math.max(125, std);
  }

  /* ---------------------------------------------------------------- 만들기 */
  window.__dcMakeQr = function (text, spec, QR) {
    if (!QR || !spec) return Promise.resolve(null);
    window.__dcQrLib = QR;                       // 확인·시험용
    var sizeIn = Math.min(spec.heightIn * 0.5, 12);
    var color = { dark: '#000000', light: '#FFFFFF' };   // 흰 바탕 + 여백(quiet zone)

    return Promise.resolve()
      .then(function () {
        if (typeof QR.toString !== 'function') return null;
        // 픽셀 수를 주지 않는다 — 벡터에는 «해상도» 라는 게 없다.
        // 나오는 것은 viewBox 뿐이고, 한 칸이 QR 모듈 하나다.
        return QR.toString(text, {
          type: 'svg', margin: 4, errorCorrectionLevel: 'M', color: color
        });
      })
      .catch(function () { return null; })
      .then(function (svg) {
        if (typeof svg === 'string' && /^\s*<svg[\s>]/.test(svg)) {
          /* viewBox 만 있고 width/height 가 없는 SVG 는 브라우저가 «크기를 모르는 그림»
             으로 본다. 크롬은 알아서 처리하지만 그러지 못하는 브라우저가 있어,
             칸 수를 그대로 width/height 로 적어 준다 (37칸이면 width="37").
             해상도가 아니라 «격자 크기» 다 — viewBox 가 있으므로 여전히 벡터로 늘어난다. */
          var vb = /viewBox="0 0 (\d+)/.exec(svg);
          var units = vb ? +vb[1] : 0;
          if (units) svg = svg.replace('<svg ', '<svg width="' + units + '" height="' + units + '" ');
          made = { src: svgToDataUrl(svg), px: units || 0, sizeIn: sizeIn,
                   isVector: true, fileName: 'qr.svg' };
          return made;
        }
        // ── 물러서기: PNG. 놓일 크기에 맞춰 픽셀 수를 정한다 ──
        var px = Math.max(1200, Math.ceil(sizeIn * requiredDpi()));
        return QR.toDataURL(text, {
          width: px, margin: 4, errorCorrectionLevel: 'M', color: color
        }).then(function (url) {
          made = { src: url, px: px, sizeIn: sizeIn, isVector: false, fileName: 'qr.png' };
          return made;
        });
      });
  };

  /* ---------------------------------------------------------------- 안내 문구
     «지금 캔버스에 있는» QR 을 기준으로 말한다 — 크기를 바꾸면 숫자도 바뀐다 */
  function qrLayer() {
    var api = window.__dcApi;
    if (!api || !api.doc || !api.doc.layers) return null;
    var ls = api.doc.layers;
    for (var i = ls.length - 1; i >= 0; i--) {
      var l = ls[i];
      if (l.type === 'image' && (l.fileName === 'qr.svg' || l.fileName === 'qr.png')) return l;
    }
    return null;
  }
  window.__dcQrNote = function () {
    var l = qrLayer() || made;
    if (!l) return 'The QR code is vector, so it stays sharp at any size.';
    var vector = l.isVector && (l.src ? isSvgSrc(l.src) : true);
    if (vector) return 'The QR code is vector, so it stays sharp at any size.';
    var w = l.widthIn || l.sizeIn, h = l.heightIn || l.sizeIn;
    var px = l.naturalWidth || l.px || 0;
    var dpi = w > 0 ? Math.round(px / w) : 0;
    return 'Current QR: ' + num(w) + '″ × ' + num(h) + '″ · ' + px + 'px · ' + dpi + ' DPI';
  };

  /* ---------------------------------------------------------------- 벡터라는 주장 검사
     «벡터» 라고 적혀 있으면 해상도 검사를 건너뛴다. 그러니 그 표시가
     진짜인지 확인한다 — 이름이 QR 이라서 봐주는 일은 없다. */
  var prev = window.__dcClipIssues;
  window.__dcClipIssues = function (layers, issues) {
    if (typeof prev === 'function') { try { prev(layers, issues); } catch (e) {} }
    try {
      if (!Array.isArray(layers) || !Array.isArray(issues)) return;
      layers.forEach(function (l) {
        if (!l || l.type !== 'image' || !l.isVector) return;
        if (isSvgSrc(l.src)) return;
        issues.push({
          id: 'not-vector-' + l.id, severity: 'warn',
          title: '“' + (l.name || 'Image') + '” is not a vector',
          detail: 'It was marked as vector so the resolution check was skipped, but the file is not actually SVG.',
          fix: 'Re-upload the image as SVG, or replace it with a large enough original.',
          layerId: l.id
        });
      });
    } catch (e) {}
  };
})();
    

/* ===== sbdc-a11y ===== */

/* =====================================================================
   모달 접근성 (DC-14)

   증강 스크립트가 만드는 창(.sbdc-modal — 시작 팝업 · 단축키 도움말 ·
   «뒷면이 제거됩니다» 확인)에는 dialog 정보가 없었다. 스크린리더는 뒤쪽
   페이지를 계속 읽고, Tab 은 창 밖으로 새고, 닫기 «×» 는 이름이 없었다.

   창마다 고쳐 넣는 대신 여기서 한 번에 올린다 — 새 창이 뜨면
   role/aria-modal/aria-labelledby 를 붙이고, 첫 조작 요소로 포커스를
   옮기고, Tab 을 창 안에 가둔다. Esc 는 그 창의 닫기 버튼을 누른다.
   창이 닫히면 열기 전에 보던 곳으로 포커스를 돌려준다.
   ===================================================================== */
(function () {
  'use strict';
  var SEL = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var seq = 0, lastFocus = null, current = null;

  function focusables(el) {
    return Array.prototype.filter.call(el.querySelectorAll(SEL), function (n) {
      return n.offsetWidth || n.offsetHeight || n.getClientRects().length;
    });
  }
  function closeBtn(el) { return el.querySelector('.sbdc-x, .sbdc-ghost'); }

  function upgrade(el) {
    if (el.dataset.sbdcA11y) return;
    el.dataset.sbdcA11y = '1';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('tabindex', '-1');

    var h = el.querySelector('h2');
    if (h) {
      if (!h.id) h.id = 'sbdc-dlg-title-' + (++seq);
      el.setAttribute('aria-labelledby', h.id);
    } else if (!el.getAttribute('aria-label')) {
      el.setAttribute('aria-label', 'Dialog');
    }
    var p = el.querySelector('.sbdc-head p');
    if (p) {
      if (!p.id) p.id = 'sbdc-dlg-desc-' + seq;
      el.setAttribute('aria-describedby', p.id);
    }
    var x = el.querySelector('.sbdc-x');
    if (x && !x.getAttribute('aria-label')) x.setAttribute('aria-label', 'Close');

    lastFocus = document.activeElement;
    current = el;
    setTimeout(function () {
      var f = focusables(el);
      (f[0] || el).focus();
    }, 0);
  }

  // Tab 가두기 + Esc 닫기 — 창이 살아 있을 때만 동작한다
  document.addEventListener('keydown', function (e) {
    if (!current || !document.body.contains(current) || !isShown(current)) return;
    if (e.key === 'Escape') {
      var b = closeBtn(current);
      if (b) { e.preventDefault(); e.stopPropagation(); b.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(current);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }, true);

  function isShown(el) {
    if (!el || !el.getClientRects().length) return false;
    var ov = el.closest ? el.closest('.sbdc-ov') : null;
    if (ov && getComputedStyle(ov).display === 'none') return false;
    return getComputedStyle(el).display !== 'none';
  }
  function scan() {
    // 문서상 첫 번째가 아니라 «실제로 보이는» 창을 잡는다 (DC-019)
    var open = null, all = document.querySelectorAll('.sbdc-modal');
    for (var i = 0; i < all.length; i++) if (isShown(all[i])) { open = all[i]; break; }
    if (open) { if (open !== current && current) current = null; upgrade(open); return; }
    if (current) {                                   // 닫혔다 — 포커스를 돌려준다
      current = null;
      try { if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus(); } catch (e) {}
      lastFocus = null;
    }
  }

  if (typeof MutationObserver === 'function') {
    var pend = 0;
    var obs = new MutationObserver(function () {
      if (pend) return;
      pend = setTimeout(function () { pend = 0; scan(); }, 80);
    });
    obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pagehide', function () {           // 수명 정리 (DC-024)
      try { obs.disconnect(); } catch (e) {}
      if (pend) { clearTimeout(pend); pend = 0; }
    });
  }
  scan();
})();


/* ===== sbdc-icc ===== */

/* =====================================================================
   인쇄 PNG 컬러 프로파일 (검사 11번)

   실제 인쇄용 PNG 에 ICC 프로파일을 iCCP 청크로 «파일 안에» 심는다.
   지금 심는 것은 sRGB IEC61966-2.1 (Compact ICC Profiles, CC0 456바이트) —
   이 앱의 색 파이프라인이 화면·가뮤트 스냅(__dcGamut)·내보내기 전부를
   sRGB 값으로 만들고 있으므로, 파일이 스스로 «내 색은 sRGB 다» 라고
   밝히는 것이 지금 파이프라인과 정확히 일치하는 선언이다. 프로파일을
   모르는 RIP 이 제멋대로 해석하던 여지가 사라진다.

   회사 장비 실측 ICC(.icc)가 준비되면 코드 수정 없이 갈아끼운다:
     window.__dcSetIccProfile(base64OfIccFile, '프로파일 이름')
   (acsp 서명 검사 후 브라우저 CompressionStream 으로 deflate 해 사용)

   팔레트의 «인쇄 안 되는 색 → 유사 색» 스냅은 기존 __dcGamut 이 같은
   프로파일 모델(장비 CMYK 겹침색)로 계산한다 — 스냅된 색의 sRGB 값이
   그대로 파일에 실리고, 파일은 그 값이 sRGB 임을 iCCP 로 밝힌다.
   ===================================================================== */
(function () {
  'use strict';
  var DEFAULT_NAME = 'sRGB IEC61966-2.1';
  var DEFLATED_B64 = 'eNpjYGA8kZOcW8wkwMCQm1dSFOTupBARGaXA/oiBmUGEgZOBj0E2Mbm4wDfYLYQBCIoTy4uTS4pyGFDAt2sMjCD6sm5GYl7K3IkMtg4NG2wdSnQa5y1V6mPADzhTUouTgfQHII5PLigqYWBg5AGyecpLCkBsCSBbpAjoKCBbB8ROh7AdQOwkCDsErCYkyBnIzgCyE9KR2ElIbKhdIMBaCvQsskNKUitKQLSzswEDKAwgop9DwH5jFDuJEMtfwMBg8YmBgbkfIZY0jYFheycDg8QthJgKUB1/KwPDtiPJpUVlUGu0gLiG4QfjHKZS5maWk2x+HEJcEjxJfF8Ez4t8k8iS0VNwVlmjmaVXZ/zacrP9NbdwX7OQshjxFNmcttKwut4OnUlmc1Yv79l0e9/MU8evpz4p//jz/38AR4Nk5Q==';
  function b64bytes(b) {
    var s = atob(b), u = new Uint8Array(s.length);
    for (var i = 0; i < s.length; i++) u[i] = s.charCodeAt(i);
    return u;
  }
  var current = { name: DEFAULT_NAME, deflated: b64bytes(DEFLATED_B64), source: 'default-srgb' };
  window.__dcIccp = function () { return current; };
  window.__dcSetIccProfile = function (rawBase64, name) {
    try {
      var raw = b64bytes(String(rawBase64 || ''));
      if (raw.length < 128 || String.fromCharCode(raw[36], raw[37], raw[38], raw[39]) !== 'acsp') {
        return Promise.reject(new Error('Not an ICC profile (no acsp signature)'));
      }
      if (typeof CompressionStream === 'undefined') {
        return Promise.reject(new Error('This browser does not support profile compression (CompressionStream)'));
      }
      var stream = new Blob([raw]).stream().pipeThrough(new CompressionStream('deflate'));
      return new Response(stream).arrayBuffer().then(function (buf) {
        current = { name: String(name || 'Company ICC').slice(0, 79), deflated: new Uint8Array(buf), source: 'custom' };
        return current;
      });
    } catch (e) { return Promise.reject(e); }
  };
})();


/* ===== sbdc-cart ===== */


  /* ================================================================
     인쇄 파일 업로드 → 주문(오더데스크) 첨부      [2차 검사 반영판]

     ── 순서 (DC-011) ────────────────────────────────────────────
     «담을 수 있는지 먼저 확인 → 그 다음 업로드». 규격이 고정 규격을
     벗어났거나, 변형을 못 찾았거나, 품절이면 파일을 만들지도 않는다.

     ── 변형 찾기 (DC-001 · 002 · 003 · 004 · 014 · 016) ───────────
     ① 밖에서 꽂아 준 ID(__dcVariantId)는 __dcVariantHandle 이 지금
        상품과 같을 때만 믿는다 — 상품을 바꾸면 이전 ID 는 무효다.
     ② 고정 규격 상품은 프리셋에 있는 규격·방향 그대로만 통과한다.
        30×69 는 되지만 69×30 은 안 된다.
     ③ 치수로 후보를 모은다. 원형처럼 숫자가 하나뿐인 변형(«3" Round»)은
        가로=세로일 때 그 한 숫자로도 맞춘다.
     ④ 재질(Regular / Removable)은 손님이 고른 값을 스토어 옵션 값과
        정확히 대조해 먼저 좁힌다 (A19).
     ⑤ 그래도 후보가 여럿이면(Banner Only vs +Stand) 상품 이름의 단어로
        점수를 매겨 가른다. 그래도 못 가르면 후보 이름을 보여 주며
        멈춘다 — 아무거나 담지 않는다.
     ⑥ 품절(available=false) 변형은 이름을 밝히며 거절한다.
     골라진 변형 이름은 주문 속성 Material/Option 으로 남겨, 무엇이
     담겼는지 눈에 보이게 한다.

     ── 시점 (DC-006 · 007) ──────────────────────────────────────
     시작할 때 앞·뒷면 문서 전체를 문자열로 떠 놓고, 업로드가 끝난 뒤
     «지금 문서» 와 글자 단위로 대조한다. 규격만이 아니라 레이어 편집도
     걸린다. 면 전환은 성공을 확인한 다음에만 찍는다 — 전환이 안 됐으면
     엉뚱한 면을 그 이름으로 찍는 대신 실패로 처리한다.

     ── 파일 (DC-008 · 009) ──────────────────────────────────────
     업로드한 PNG 의 blob 을 들고 있다가, 디자인이 그대로면 고객
     다운로드도 그 파일을 그대로 준다 — 주문 첨부본과 동일 파일.
     DPI 는 요청값이 아니라 렌더러가 실제로 찍은 값(r.dpi)을 기록한다.

     ── 오류 (DC-012) ────────────────────────────────────────────
     모든 fetch 는 상태·본문·URL 을 보존하고 window.__dcErrors 에
     쌓인다. 놓친 rejection 도 unhandledrejection 에서 잡아 기록한다.
     ================================================================ */
  (function () {
    'use strict';
    var UPLOAD_FN = 'https://uktrkymhgmzlufzxsavf.supabase.co/functions/v1/dc-print-upload';
    var APP_VER = 'design-center-v5.6';
    var TIMEOUT = 30000;

    /* 재질 (A19) — 예전에는 PREFER 라는 내부 표로 «regular» 라는 낱말에 점수를
       더 줘서 늘 일반 비닐을 담았다. 손님이 고를 칸이 없었기 때문이다.
       이제는 손님이 고른 값(spec.material)을 스토어 옵션 값과 «정확히» 대조한다.

         ① 옵션 이름(Material Type / Option) 칸의 값이 정확히 같은 변형
         ② 못 찾으면 변형 이름에 regular / removable 낱말이 있는 것
         ③ 스토어가 재질 구분을 아예 없앴으면 거르지 않고 지나간다 (기록만 남긴다)

       ①②가 다 비었는데 재질 구분은 살아 있다 → 아무거나 담지 않고 멈춘다. */
    function normOpt(x) { return String(x == null ? '' : x).trim().replace(/:+$/, '').toLowerCase(); }
    function matChoice(p, spec) {
      try {
        var M = window.__dcMaterialsFor && window.__dcMaterialsFor(p);
        if (!M || !M.list || !M.list.length) return null;
        var id = spec && spec.material;
        for (var i = 0; i < M.list.length; i++) if (M.list[i].id === id) return M.list[i];
        return M.list[0];                            // 아직 안 골랐으면 기본(= 일반)
      } catch (e) { return null; }
    }
    function matWords(p) {
      var M = (window.__dcMaterialsFor && window.__dcMaterialsFor(p)) || null;
      return M ? M.list.map(function (m) { return m.word; }) : [];
    }

    /* ---------------------------------------------------------------- 공통 */
    function root() {
      try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      catch (e) { return '/'; }                                   // locale-aware (DC-017)
    }
    window.__dcErrors = window.__dcErrors || [];
    function note(err) {
      try {
        window.__dcErrors.push({ at: new Date().toISOString(), message: String(err && err.message || err),
          status: err && err.status, url: err && err.url, body: err && err.body });
        if (window.__dcErrors.length > 20) window.__dcErrors.shift();
        if (window.console) console.error('[design-center]', err);
      } catch (e) {}
      return err;
    }
    try {                                                          // 삼켜지던 rejection 기록 (DC-012)
      window.addEventListener('unhandledrejection', function (ev) {
        note(ev && (ev.reason || ev.message) || 'unhandled rejection');
      });
    } catch (e) {}
    function httpError(url, status, body, msg) {
      var e = new Error(msg || ('HTTP ' + status + ' — ' + url));
      e.url = url; e.status = status; e.body = String(body || '').slice(0, 400);
      return e;
    }
    function req(url, opts, ms) {
      var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var o = Object.assign({}, opts || {});
      if (ctl) o.signal = ctl.signal;
      var timer = setTimeout(function () { try { ctl && ctl.abort(); } catch (e) {} }, ms || TIMEOUT);
      return fetch(url, o).then(function (r) {
        return r.text().then(function (t) {
          clearTimeout(timer);
          if (!r.ok) throw note(httpError(url, r.status, t));
          try { return t ? JSON.parse(t) : null; }
          catch (e) { throw note(httpError(url, r.status, t, 'Could not read the response as JSON — ' + url)); }
        });
      }, function (e) {
        clearTimeout(timer);
        e.url = url;
        if (e.name === 'AbortError') e.message = 'Timed out (' + Math.round((ms || TIMEOUT) / 1000) + 's) — ' + url;
        throw note(e);
      });
    }

    /* ---------------------------------------------------------------- 인쇄 DPI (DC-009)
       고객 다운로드·프루프 표시·업로드가 같은 «요청값» 을 쓴다. 실제로
       몇 dpi 로 찍혔는지는 렌더 결과(r.dpi)에서 읽어 그 값을 기록한다. */
    window.__dcPrintDpi = function (spec) {
      /* 검사 1번 — spec 이 아닌 것(문서 doc 등)이 들어오면 치수가 0 으로 읽혀
         12,000px 캡 없이 150dpi 로 계산됐고, 프루프 표시(예 3,331×16,384px)와
         실제 파일(2,449×12,050px)이 어긋났다. 치수가 없으면 현재 spec 으로 되돌린다. */
      var s = (spec && (+spec.widthIn > 0 || +spec.heightIn > 0)) ? spec
        : (window.__dcApi && window.__dcApi.spec) || {};
      var longest = Math.max(+s.widthIn || 0, +s.heightIn || 0);
      if (!(longest > 0)) return 150;
      return Math.max(36, Math.min(150, Math.floor(12000 / longest)));
    };

    function applied() {
      return (typeof window.__dcAppliedProduct === 'function' && window.__dcAppliedProduct()) || null;
    }
    function onShopify() {
      var loc = window.location || {};
      if (!/^https?:$/.test(loc.protocol || '')) return false;    // file:// 미리보기 (DC-025)
      return /myshopify\.com$/.test(loc.hostname || '') ||
        !!(window.Shopify && window.Shopify.shop) ||
        !!document.querySelector('form[action*="/cart/add"]');
    }
    function nums(v) {
      // "Oracal 4 mil Vinyl" 의 4, "270gsm" 의 270 같은 «단위 숫자» 는 치수가 아니다 —
      // 지우지 않으면 3″ 원형이 [3,4] 로 읽혀 매칭이 깨진다 (스토어 실측으로 확인)
      var t = String(v == null ? '' : v).replace(/\d+(?:\.\d+)?\s*(?:mil|mm|gsm|oz|pt)\b/gi, ' ');
      return (t.match(/\d+(?:\.\d+)?/g) || []).map(Number);
    }
    function near(a, b) { return Math.abs(a - b) < 0.051; }
    // exact=true 면 가로·세로 순서까지 같아야 한다 (고정 규격 상품, DC-004)
    function dimMatch(list, w, h, exact) {
      if (list.length >= 2) {
        if (near(list[0], w) && near(list[1], h)) return true;
        if (!exact && near(list[0], h) && near(list[1], w)) return true;
        return false;
      }
      if (list.length === 1 && near(w, h)) return near(list[0], w);   // «3" Round» (DC-002)
      return false;
    }
    var STOP = { the: 1, a: 1, an: 1, x: 1, in: 1, ft: 1, and: 1, with: 1, sticker: 1, stickers: 1, banner: 1, custom: 1 };
    function words(v) {
      return String(v || '').toLowerCase().split(/[^a-z]+/).filter(function (w) {
        return w.length > 1 && !STOP[w];
      });
    }

    /* ---------------------------------------------------------------- 기다리기 */
    function frame() {
      return new Promise(function (r) {
        requestAnimationFrame(function () { requestAnimationFrame(function () { r(); }); });
      });
    }
    function until(pred, ms) {
      var end = Date.now() + (ms || 5000);
      return new Promise(function (res) {
        (function tick() {
          var ok = false;
          try { ok = !!pred(); } catch (e) {}
          if (ok) return res(true);
          if (Date.now() > end) return res(false);
          requestAnimationFrame(tick);
        })();
      });
    }
    function stage() {
      try { return (window.Konva && window.Konva.stages && window.Konva.stages[0]) || null; }
      catch (e) { return null; }
    }
    function imagesReady() {
      var st = stage();
      if (!st) return true;
      var ns = st.find('Image');
      for (var i = 0; i < ns.length; i++) if (!ns[i].image()) return false;
      return true;
    }
    // 성공 여부를 돌려준다 — 시간이 다 됐는데 그 면이 아니면 false (DC-007)
    function goSide(side) {
      var api = window.__dcApi;
      if (!api) return Promise.resolve(false);
      if (api.activeSide !== side) { try { api.setActiveSide(side); } catch (e) {} }
      return until(function () {
        var a = window.__dcApi;
        return a && a.activeSide === side && imagesReady();
      }, 6000).then(function (ok) {
        return frame().then(function () {
          var a = window.__dcApi;
          return !!ok && !!a && a.activeSide === side;
        });
      });
    }

    /* ---------------------------------------------------------------- 한 면 찍기 */
    function renderSide(side, mode, dpi, name) {
      var want = side === 'back' ? 'back' : 'front';
      var api = window.__dcApi, ref = window.__dcExportRef;
      if (!api || !ref) return Promise.resolve(null);
      if (want === 'back' && !api.back) return Promise.resolve(null);
      return goSide(want).then(function (ok) {
        var a = window.__dcApi;
        if (!ok || !a || a.activeSide !== want) {                  // 엉뚱한 면을 찍지 않는다 (DC-007)
          throw note(new Error((want === 'back' ? 'Back' : 'Front') + 'could not be switched to, so the print file cannot be built'));
        }
        try {
          var cur = window.__dcExportRef.current;
          return (cur && cur.render(mode || 'print', dpi || window.__dcPrintDpi(), name || (want + '_print'))) || null;
        } catch (e) { note(e); return null; }
      });
    }
    window.__dcRenderSide = renderSide;

    /* Uint8Array → base64. 한 번에 넘기면 100만 바이트에서 스택이 넘치므로 8KB 씩 끊어 넣는다. */
    function bytesToB64(u8) {
      var s = '', C = 8192;
      for (var i = 0; i < u8.length; i += C) s += String.fromCharCode.apply(null, u8.subarray(i, i + C));
      return btoa(s);
    }

    /* 인쇄 파일이 «스스로 밝힌» 가로×세로 (A9 · DC-121).
       주문서에 적던 pixelWidth/pixelHeight 는 «계획값» 이다 — 번들 계산기가
       Math.round(인치×dpi) 로 만든다. 그런데 실제 캔버스는 브라우저가 소수점을
       «버려서» 만들기 때문에 둘이 1px 어긋난다 (실측: 계획 5808 · 실제 5807).
       그 숫자는 «인쇄소가 받은 파일이 우리가 보낸 그 파일인가» 를 대조하라고 적는
       값이라, 어긋나면 대조가 무조건 실패한다.
       그래서 다시 «계산해서 맞추지» 않는다 — 만들어진 PNG 가 자기 머리(IHDR)에
       적어 둔 값을 그대로 읽는다. 그러면 «주문서 숫자 = 파일 숫자» 가 정의상 참이다.
       PNG 서명 8바이트 + 길이 4 + 'IHDR' 4 → 16번째부터 가로, 20번째부터 세로. */
    function pngSize(bytes) {
      try {
        var SIG = [137, 80, 78, 71, 13, 10, 26, 10];
        if (!bytes || bytes.length < 24) return null;
        for (var i = 0; i < 8; i++) if (bytes[i] !== SIG[i]) return null;
        if (String.fromCharCode(bytes[12], bytes[13], bytes[14], bytes[15]) !== 'IHDR') return null;
        var be = function (o) { return ((bytes[o] << 24) >>> 0) + (bytes[o + 1] << 16) + (bytes[o + 2] << 8) + bytes[o + 3]; };
        var w = be(16), h = be(20);
        return (w > 0 && h > 0) ? { w: w, h: h } : null;
      } catch (e) { return null; }
    }
    window.__dcPngSize = pngSize;                    // 시험 훅

    /* 인쇄 파일 «바이트» 의 지문 (A1). 예전에는 base64 «글자» 를 재서, 인쇄소가 받은 PNG 를
       shasum 으로 재도 주문서의 _print_sha256 과 맞지 않았다. */
    function sha256(bytes) {
      try {
        if (!(window.crypto && window.crypto.subtle)) return Promise.resolve(null);
        return window.crypto.subtle.digest('SHA-256', bytes).then(function (buf) {
          return Array.prototype.map.call(new Uint8Array(buf), function (x) {
            return ('0' + x.toString(16)).slice(-2);
          }).join('');
        }).catch(function () { return null; });
      } catch (e) { return Promise.resolve(null); }
    }

    // 한 면 렌더+업로드 → {side,printUrl,jsonUrl,dpi,requestedDpi,capped,px,sha256,blob}
    function uploadSide(designId, side, dpi, designJson) {
      return renderSide(side, 'print', dpi, side + '_print').then(function (r) {
        if (!r || !r.dataUrl) throw note(new Error((side === 'back' ? 'Back' : 'Front') + ' could not be built'));
        /* 스토어가 아닌 곳(파일을 그냥 열어 본 미리보기)에서는 «만들기» 까지만 하고
           운영 저장소에는 올리지 않는다. 예전에는 장바구니만 건너뛰고 업로드는 그대로
           나가서, 파일을 열어 승인만 눌러도 진짜 인쇄 파일이 서버에 쌓였다 (DC-103). */
        var planned = (r.pixelWidth || '') + 'x' + (r.pixelHeight || '');   // 계획값 — 못 읽을 때만 쓴다 (A9)
        if (!onShopify()) {
          var pv = function (px) {
            try { console.log('[design-center] (preview) upload skipped', side, px); } catch (e) {}
            return { side: side, printUrl: null, jsonUrl: null, dpi: Math.round(r.dpi || dpi),
              requestedDpi: dpi, capped: !!r.capped, px: px,
              sha256: null, blob: r.blob || null, deleteToken: null, preview: true };
          };
          // 미리보기에서도 같은 숫자를 보여 준다 — 사장님이 열어 본 값과 주문 기록이 어긋나지 않게
          if (!r.blob) return pv(planned);
          return r.blob.arrayBuffer().then(function (buf) {
            var s = pngSize(new Uint8Array(buf));
            return pv(s ? (s.w + 'x' + s.h) : planned);
          }).catch(function () { return pv(planned); });
        }
        var actualDpi = Math.round(r.dpi || dpi);                  // 실제 찍힌 값 (DC-009)
        /* «손님이 내려받는 파일» 과 «인쇄소가 받는 파일» 은 같은 파일이어야 한다 (A1).
           r.dataUrl 은 캔버스에서 바로 뽑은 것이라 pHYs(dpi)·sRGB 같은 쪽지가 없다.
           쪽지가 들어 있는 것은 r.blob 뿐이고, 다운로드는 원래 그쪽을 쓴다.
           dpi 를 모르는 RIP 는 72dpi 로 가정해 8′×4′ 를 13.4′×6.7′ 로 연다.
           blob 이 없으면 쪽지 없는 파일로 물러서지 않고 여기서 멈춘다. */
        if (!r.blob) throw note(new Error((side === 'back' ? 'Back' : 'Front') + ' could not be built'));
        return r.blob.arrayBuffer().then(function (buf) {
          var bytes = new Uint8Array(buf);
          /* 검사 9번 — 업로드 가능한 크기를 클라이언트에서 먼저 확인한다.
             base64 로 부풀면(4/3배) 함수 요청 한도를 넘길 수 있어 45MB 로 자른다. */
          if (bytes.length > 45 * 1024 * 1024) {
            throw note(new Error((side === 'back' ? 'Back' : 'Front')
              + ' the print file is too large (' + Math.round(bytes.length / 1048576) + 'MB). '
              + 'Reduce the size or resolution and try again.'));
          }
          if (designJson && designJson.length > 9.5 * 1024 * 1024) {
            var protectedLayout = false;
            try { var editable = JSON.parse(designJson); protectedLayout = editable.doc && editable.doc.layout914 && editable.doc.layout914.version === 'sbdc-layout-914-v1'; } catch (ignored) {}
            if (protectedLayout) throw note(new Error('The editable artwork exceeds the upload limit. Export JSON and reduce embedded image sizes; this design was not uploaded.'));
            designJson = null;
          }   // 서버 10MB 캡 — 명세만 생략, 인쇄 파일은 그대로
          /* A9 — 주문서에 적는 픽셀 수는 «계획값» 이 아니라 «올라가는 그 파일이 밝힌 값».
             못 읽으면(예상 밖의 형식) 값을 없애지 않고 계획값으로 물러선다. */
          var real = pngSize(bytes);
          var px = real ? (real.w + 'x' + real.h) : planned;
          var b64 = bytesToB64(bytes);
          return sha256(bytes).then(function (hash) {
            /* 검사 9번 — timeout(대형 파일용 120s)·네트워크 오류 재시도(2회, 1.5s→3s)·
               idempotency key. 열쇠는 designId/side 로 정해져 있어, 재시도가 몇 번을
               가도 서버에는 같은 자리 하나만 남는다 (서버는 같은 열쇠의 요청을 1회로 접는다). */
            var idem = designId + '/' + side + '/' + (hash || 'nohash');
            var payload = JSON.stringify({ designId: designId, side: side, printBase64: b64,
              designJson: designJson || null, idempotencyKey: idem });
            function postOnce() {
              return req(UPLOAD_FN, {
                method: 'POST',
                headers: { 'content-type': 'application/json', 'x-idempotency-key': idem },
                body: payload
              }, 120000);
            }
            function retriable(e) {
              if (!e) return false;
              var st = e.status;
              if (st === 429) return true;                 // 몰림 — 기다리면 된다
              if (st >= 500) return true;                  // 서버 일시 오류
              if (!st) return true;                        // 네트워크 끊김 · 시간 초과
              return false;
            }
            function postRetry(left, wait) {
              return postOnce().catch(function (e) {
                if (left > 0 && retriable(e)) {
                  return new Promise(function (res) { setTimeout(res, wait); })
                    .then(function () { return postRetry(left - 1, wait * 2); });
                }
                throw e;
              });
            }
            return postRetry(2, 1500).then(function (j) {
              if (!j || !j.ok || !j.printUrl) {
                throw note(httpError(UPLOAD_FN, 200, JSON.stringify(j || null), 'The upload response was not valid'));
              }
              return { side: side, printUrl: j.printUrl, jsonUrl: j.jsonUrl, dpi: actualDpi,
                requestedDpi: dpi, capped: !!r.capped, px: px, sha256: hash, blob: r.blob,
                deleteToken: j.deleteToken || null };
            });
          });
        });
      });
    }

    /* ---------------------------------------------------------------- 다운로드 = 주문본 (DC-008)
       디자인이 업로드 시점 그대로면, 새로 찍지 않고 업로드했던 그 blob 을
       내려준다. 번들의 다운로드 버튼이 이 훅을 먼저 부른다. */
    var lastPrints = null;   // { frontJson, backJson, front:{blob,...}, back:{...} }
    window.__dcCachedPrint = function (spec, side) {
      try {
        var api = window.__dcApi;
        if (!lastPrints || !api) return null;
        var want = side === 'back' ? 'back' : 'front';
        var rec = lastPrints[want];
        if (!rec || !rec.blob) return null;
        var nowJson = want === 'back' ? JSON.stringify(window.__sbPack ? window.__sbPack.pack(api.back || null) : (api.back || null)) : JSON.stringify(window.__sbPack ? window.__sbPack.pack(api.front || null) : (api.front || null));
        var refJson = want === 'back' ? lastPrints.backJson : lastPrints.frontJson;
        if (nowJson !== refJson) return null;
        return { blob: rec.blob, dpi: rec.dpi, cached: true };
      } catch (e) { return null; }
    };

    /* ---------------------------------------------------------------- 알림 */
    function clearError() {
      var e = document.querySelector('.sbdc-cart-err');
      if (e && e.parentNode) e.parentNode.removeChild(e);
    }
    function showError(head, detail) {
      clearError();
      var el = document.createElement('div');
      el.className = 'sbdc-cart-err';
      el.setAttribute('role', 'alert');
      el.appendChild(Object.assign(document.createElement('b'), { textContent: head }));
      el.appendChild(Object.assign(document.createElement('em'), {
        textContent: detail || 'Nothing was added to the cart. Please press 「Approve and add to cart」 again shortly.'
      }));
      var body = document.querySelector('.modal-body');
      if (body) body.insertBefore(el, body.firstChild);
      try { if (window.__dcToast) window.__dcToast(head); } catch (e) {}
      return false;
    }
    window.__dcCartUnavailable = function () {
      return showError('The cart is not ready yet',
        'Refresh the page and try again. If it keeps happening, let our team know.');
    };
    window.__dcClearCartErr = clearError;
    /* 검사 3번 — 파일 생성이 실패하면 «아무 반응 없음» 대신 안내를 띄운다.
       다운로드 버튼은 잠그지 않으므로 상태 복구가 따로 필요 없다 — 바로 다시 누르면 된다. */
    window.__dcPrintFail = function () {
      return showError('Could not build the print file',
        'Please press 「Download print file」 again shortly. If it keeps happening, let our team know.');
    };
    /* 검사 1·4번 — 이미 업로드한(주문 첨부) 파일이 있으면, 프루프의 픽셀 수를
       그 파일이 스스로 밝힌 값(PNG IHDR)으로 바꿔 «화면 값 = 파일 값» 을 만든다. */
    window.__dcProofPx = function (spec, side, setState) {
      try {
        var cp = window.__dcCachedPrint && window.__dcCachedPrint(spec, side);
        if (!cp || !cp.blob || typeof setState !== 'function') return;
        cp.blob.arrayBuffer().then(function (buf) {
          var s = pngSize(new Uint8Array(buf));
          if (!s) return;
          setState(function (g) {
            if (!g || !g.printPlan) return g;
            var pl = Object.assign({}, g.printPlan, { pixelWidth: s.w, pixelHeight: s.h });
            if (cp.dpi > 0) pl.dpi = cp.dpi;
            return { proof: g.proof, printPlan: pl };
          });
        }).catch(function () {});
      } catch (e) {}
    };
    /* 검사 7번 — 실제 인쇄 파일의 DPI 가 회사 기준(125) 미만이면 «검수 없이 생산 큐로
       직행» 으로 표시하지 않는다. 하단 바·승인 토스트·주문 명세가 전부 이 값을 쓴다. */
    window.__dcAutoOk = function () {
      try {
        var api = window.__dcApi;
        if (!api || !api.spec) return true;
        var dpi = window.__dcPrintDpi(api.spec);
        var ref = window.__dcExportRef && window.__dcExportRef.current;
        if (ref && ref.plan) { var pl = ref.plan('print', dpi); if (pl && pl.dpi > 0) dpi = pl.dpi; }
        var std = (typeof window.__dcCompanyMinDpi === 'number' && window.__dcCompanyMinDpi) || 125;
        return dpi >= std - 1e-9;
      } catch (e) { return true; }
    };

    /* ---------------------------------------------------------------- 주상품 변형 찾기 */
    // 검사 8번 — 주입된 Variant ID 의 «소속 검증» 에 쓰는 전체 변형 조회 (250개 페이지네이션)
    var SHOP = { 'fabric-step-repeat-banners': 'custom-fabric-step-repeat-banner' };   // 2026-10-01: the first one was deleted in Shopify
    function shopHandle(h) { return SHOP[h] || h; }
    function fetchAllVariants(handle) {
      function go(page, acc) {
        var u = root() + 'products/' + shopHandle(handle) + '.js' + (page > 1 ? '?page=' + page : '');
        return req(u, {}, 15000).then(function (prod) {
          var v = (prod && prod.variants) || [];
          acc = acc.concat(v);
          if (v.length >= 250 && page < 10) return go(page + 1, acc);
          return acc;
        });
      }
      return go(1, []);
    }
    var variantCache = {};
    function fixedKey(p, spec) {
      var W = p.unit === 'in' ? spec.widthIn : spec.widthIn / 12;
      var H = p.unit === 'in' ? spec.heightIn : spec.heightIn / 12;
      var f = function (n) { return String(Math.round(n * 100) / 100).replace(/\.0+$/, ''); };
      return { W: W, H: H, key: f(W) + 'x' + f(H) };
    }
    function resolveVariant(spec) {
      var p = applied();

      /* 밖에서 꽂은 ID (DC-014 · 검사 8번) — 상품이 같을 때 «그리고» 실제로 그 상품의
         변형임이 스토어에서 확인됐을 때만 쓴다. 확인이 안 되면 담지 않고 멈춘다 —
         상품을 바꾼 뒤 남은 이전 ID 로 엉뚱한 상품이 담기는 길을 막는다. */
      var direct = window.__dcVariantId ||
        (window.__dcSelectedProduct && window.__dcSelectedProduct.variantId);
      if (direct) {
        var dh = window.__dcVariantHandle ||
          (window.__dcSelectedProduct && window.__dcSelectedProduct.handle) || null;
        if (p && dh && dh !== p.handle) {
          direct = null;                                  // 상품이 바뀜 — 이전 ID 는 버리고 규격 매칭으로
        } else if (!onShopify()) {
          return Promise.resolve({ id: direct, source: 'injected' });   // 미리보기 — 조회 불가
        } else {
          var vHandle = (p && p.handle) || dh;
          if (!vHandle) {
            return Promise.resolve({ error: 'variant',
              detail: 'We could not confirm which product the selected variant belongs to, so it was not added. Please choose the product again.' });
          }
          return fetchAllVariants(vHandle).then(function (vs) {
            var hit = null;
            for (var i = 0; i < vs.length; i++) {
              if (String(vs[i].id) === String(direct)) { hit = vs[i]; break; }
            }
            if (!hit) {
              return { error: 'variant',
                detail: 'The selected variant does not belong to this product (' + vHandle + '), so it was not added. Please choose the size again.' };
            }
            if (hit.available === false) {
              return { error: 'soldout', detail: '「' + hit.title + '」 is currently sold out.' };
            }
            return { id: hit.id, title: hit.title,
              price: hit.price != null ? hit.price / 100 : null, source: 'injected-verified' };
          }).catch(function (e) {
            var st = e && e.status;
            if (st === 404 || st === 403) {
              return { error: 'missing', status: st,
                detail: (st === 404 ? 'Product not found' : 'This product is not on sale right now')
                  + ' (' + ((e && e.message) || 'HTTP ' + st) + ')' };
            }
            return { error: 'network', detail: (e && e.message) || 'Could not reach the store.' };
          });
        }
      }
      if (!p || !p.handle) return Promise.resolve(null);

      var d = fixedKey(p, spec), W = d.W, H = d.H;

      // 고정 규격 상품은 프리셋 규격·방향 그대로만 (DC-004)
      var presets = p.presetsIn || p.presets || null;
      if (p.fixedOnly && presets && presets.indexOf(d.key) < 0) {
        return Promise.resolve({ error: 'fixed',
          detail: 'This product is a fixed size (' + presets.join(', ') + (p.unit === 'in' ? ' in' : ' ft') + '). '
            + 'Current size ' + d.key + ' cannot be ordered.' });
      }

      // 같은 handle·규격에 Banner Only / + Stand 항목이 따로 있으므로 캐시 키에 구성도 넣는다.
      // 재질(A19)도 같은 규격에 변형이 둘이므로 캐시 키에 함께 넣는다.
      var matPick = matChoice(p, spec);
      var key = p.handle + '|' + (p.key || (p.pick && p.pick.join(',')) || '') + '|' + d.key
        + '|' + (matPick ? matPick.id : '');
      if (variantCache[key] !== undefined) return Promise.resolve(variantCache[key]);

      /* 스토어의 products/….js 는 변형을 «250개까지만» 돌려준다. 커스텀 비닐 배너는
         실제 637개라 앞 250개(폭 2~7ft)만 보였고, 폭 8ft 이상은 «규격을 찾지 못했습니다» 로
         떨어졌다. ?page= 로 넘기면 나머지가 온다 (?limit= 은 듣지 않는다). — DC-111 */
      var optOrder = null;                     // 스토어가 알려 주는 옵션 이름 순서
      function fetchVariants(page, acc) {
        var u = root() + 'products/' + shopHandle(p.handle) + '.js' + (page > 1 ? '?page=' + page : '');
        return req(u, {}, 15000).then(function (prod) {
          if (!optOrder && prod && prod.options) {
            optOrder = prod.options.map(function (o) {
              return String((o && o.name != null) ? o.name : o);       // 문자열 배열로 올 때도 있다
            });
          }
          var v = (prod && prod.variants) || [];
          acc = acc.concat(v);
          if (v.length >= 250 && page < 10) return fetchVariants(page + 1, acc);   // 최대 2,500개
          return acc;
        });
      }
      return fetchVariants(1, []).then(function (allVariants) {
        if (!allVariants.length) return null;
        var vs = allVariants, hit = null;

        /* 재질 (A19) — 손님이 고른 재질만 남긴다 */
        if (matPick) {
          var iM = -1;
          if (optOrder) for (var oi = 0; oi < optOrder.length; oi++) {
            if (normOpt(optOrder[oi]) === normOpt(p.materials.opt)) { iM = oi; break; }
          }
          var narrow = iM >= 0
            ? vs.filter(function (v) { return normOpt((v.options || [])[iM]) === normOpt(matPick.val); })
            : [];
          if (!narrow.length) {                                   // ② 이름 낱말로 예비 매칭
            narrow = vs.filter(function (v) {
              return String(v.title || '').toLowerCase().indexOf(matPick.word) >= 0;
            });
          }
          if (narrow.length) vs = narrow;
          else {
            /* 이름을 words 로 쓰면 안 된다 — 아래 점수 계산이 쓰는 words() 함수를
               var 끌어올림으로 가려 버린다 (실제로 한 번 밟았다). */
            var mw = matWords(p);
            var stillSplit = vs.some(function (v) {
              var t = String(v.title || '').toLowerCase();
              return mw.some(function (w) { return t.indexOf(w) >= 0; });
            });
            if (stillSplit) {                                     // 재질 구분은 있는데 고른 것이 없다
              var rM = { error: 'material',
                detail: 'The material you picked 「' + matPick.ko + '」 was not found at this size. '
                  + 'Try another material, or let our team know.' };
              variantCache[key] = rM;
              return rM;
            }
            // ③ 스토어가 재질 구분을 없앤 경우 — 거르지 않고 지나간다
            note(new Error('No material options found, so nothing was filtered — ' + p.handle + ' / ' + matPick.val));
          }
        }

        /* 스토어 옵션 이름으로 «정확히» 집는다.
           숫자를 긁어 맞추면 «4 / 8» 과 «8 / 4» 를 못 가리고 재질의 숫자에도 걸린다.
           카탈로그의 optNames 와 스토어가 알려 준 옵션 순서를 맞춰, 가로 칸과 세로 칸을
           지정해 값을 비교한다. 이름이 안 맞으면 아래 기존 방식으로 내려간다. */
        var byName = null;
        if (p.optNames && optOrder && optOrder.length) {
          var iW = optOrder.indexOf(p.optNames.w), iH = optOrder.indexOf(p.optNames.h);
          if (iW >= 0 && iH >= 0) {
            byName = vs.filter(function (v) {
              var o = v.options || [];
              return near(parseFloat(o[iW]), W) && near(parseFloat(o[iH]), H);
            });
            if (!byName.length) byName = null;             // 못 찾으면 기존 방식으로
          }
        }
        if (byName) vs = byName;

        if (vs.length === 1) {
          hit = vs[0];
        } else {
          var cands = vs.filter(function (v) {                       // ① 치수 후보
            var flat = [];
            (v.options || []).forEach(function (o) { flat = flat.concat(nums(o)); });
            if (dimMatch(flat, W, H, !!p.fixedOnly)) return true;
            return dimMatch(nums(v.title), W, H, !!p.fixedOnly);
          });
          /* 스토어에는 «4 / 8» 과 «8 / 4» 가 둘 다 있다. 순서를 무시하고 둘 다 후보로 두면
             이름 점수가 동률이 나서 «여러 개라 못 고르겠다» 로 담기가 막혔다.
             가로·세로가 그대로 맞는 것이 있으면 그것만 남긴다. 없을 때만 뒤집힌 쪽을 쓴다. — DC-110 */
          if (cands.length > 1) {
            var sameOrder = cands.filter(function (v) {
              var flat = [];
              (v.options || []).forEach(function (o) { flat = flat.concat(nums(o)); });
              return dimMatch(flat, W, H, true) || dimMatch(nums(v.title), W, H, true);
            });
            if (sameOrder.length) cands = sameOrder;
          }
          // 카탈로그 항목의 pick 구절(예: 'banner only', 'banner + stand')이 있으면 그걸로 먼저 거른다 —
          // Banner Only / + Stand / Stand Only 처럼 3구성이면 단어 점수만으론 동률이 난다
          if (cands.length > 1 && p.pick && p.pick.length) {
            var picked = cands.filter(function (v) {
              var t = String(v.title || '').toLowerCase();
              return p.pick.every(function (ph) { return t.indexOf(ph) >= 0; });
            });
            if (picked.length) cands = picked;
          }
          if (cands.length === 1) hit = cands[0];
          else if (cands.length > 1) {                                // ② 이름 점수로 가른다 (DC-001·016)
            var want = words(p.name).concat(words(p.materialEn));
            var scored = cands.map(function (v) {
              var w = words(v.title), sc = 0;
              want.forEach(function (t) { if (w.indexOf(t) >= 0) sc++; });
              return { v: v, sc: sc };
            }).sort(function (a, b) { return b.sc - a.sc; });
            if (scored[0].sc > (scored[1] ? scored[1].sc : -1)) hit = scored[0].v;
            else {
              var r2 = { error: 'ambiguous',
                detail: 'Several packages share this size, so we cannot pick one automatically: '
                  + cands.map(function (v) { return v.title; }).join(' / ') };
              variantCache[key] = r2;
              return r2;
            }
          }
        }
        if (!hit) return null;                                        // 미발견은 캐시 안 함 — 일시 오류일 수 있다
        if (hit.available === false) {                                // ③ 품절 (DC-003) — 캐시 안 함, 재입고되면 바로 담기게
          return { error: 'soldout', detail: '「' + hit.title + '」 is currently sold out.' };
        }
        var out = { id: hit.id, title: hit.title, price: hit.price != null ? hit.price / 100 : null, source: 'matched' };
        variantCache[key] = out;
        return out;
      }).catch(function (e) {
        /* 실패를 «없음» 으로 바꾸면 부른 쪽이 «그런 규격이 없다» 와 «스토어에 못 닿았다» 를
           구분하지 못한다. 예전에는 500·연결 끊김·JSON 아님이 전부 «규격을 바꿔 보세요» 로
           안내돼 손님이 크기만 바꾸다 포기했다 (DC-104). 캐시에는 넣지 않는다.

           A7 — «잠시 후 다시» 라고 말해도 되는 고장과, 기다려도 소용없는 고장을 가른다.
           404·403 은 상품이 없거나 숨겨진 것이라 손님이 몇 번을 눌러도 영영 안 된다.
           그런데도 «잠시 후 다시 시도해 주세요» 라고 안내하면 손님은 계속 다시 누른다.
           상태는 httpError(4553) 가 e.status 에 담아 준다. 캐시는 여전히 안 한다 —
           사장님이 상품을 되살리면 새로고침 없이 바로 담기게 하려는 것이다. */
        var st = e && e.status;
        if (st === 404 || st === 403) {
          return { error: 'missing', status: st,
            detail: (st === 404 ? 'Product not found' : 'This product is not on sale right now')
              + ' (' + ((e && e.message) || 'HTTP ' + st) + ')' };
        }
        if (st === 429) {
          return { error: 'busy', status: st,
            detail: (e && e.message) || 'Too many requests at once.' };
        }
        return { error: 'network', detail: (e && e.message) || 'Could not reach the store.' };
      });
    }

    /* 앱 표시가와 스토어 실제가가 다르면 기록해 둔다 — 담기는 막지 않는다 (DC-015 감지기)

       A22 (DC-122) — 예전에는 «대조했더니 문제없음» 과 «대조를 못 했음» 을 둘 다 null 로
       돌려줬다. 나중에 주문 기록만 보면 그 둘이 구분되지 않아, 가격이 맞았다고 믿을 근거가
       없는데도 «문제없음» 으로 읽혔다. 이제 «했는가(checked)» 와 «왜 못 했나(why)» 를
       따로 돌려준다. **어긋남을 담는 칸(gap)의 모양은 예전 그대로** — 서버·팀원이 읽는
       priceMismatch 는 바뀌지 않는다. */
    function priceCheck(p, spec, variant) {
      var 못함 = function (why) { return { checked: false, why: why, gap: null }; };
      try {
        if (!p) return 못함('No product info');
        if (!variant) return 못함('Variant not found');
        if (variant.price == null) return 못함('Could not get the store price');
        var d = fixedKey(p, spec), expect = null;
        /* 앱이 «실제로 화면에 띄우는» 값을 그대로 쓴다. 예전에는 여기서 요율×넓이만
           계산해 특가(specials)를 못 봤고, 앱과 스토어가 같은 $98 인데도 «가격 불일치»
           라고 기록했다 (DC-105). p.min 은 최소 «가격» 이 아니라 최소 «피트» 라 빼야 한다. */
        if (typeof window.__dcUnitPriceFor === 'function') {
          try { expect = window.__dcUnitPriceFor(p, spec.widthIn / 12, spec.heightIn / 12); } catch (e) { expect = null; }
          if (!(expect > 0)) expect = null;
        }
        if (expect != null) { /* 훅에서 구했다 */ }
        else if (p.priceBySizeIn && p.priceBySizeIn[d.key] != null) expect = p.priceBySizeIn[d.key];
        else if (p.rateBySize && p.rateBySize[d.key] != null) expect = p.rateBySize[d.key] * d.W * d.H;
        else if (p.rate) expect = Math.max(p.rate * (spec.widthIn / 12) * (spec.heightIn / 12), p.min || 0);
        if (expect == null) return 못함('Could not read the app price (' + p.handle + ' ' + d.key + ')');
        var diff = Math.abs(expect - variant.price);
        if (diff > Math.max(0.5, expect * 0.01)) {
          note(new Error('Price mismatch — app ' + expect.toFixed(2) + ' vs store variant ' + variant.price.toFixed(2)
            + ' (' + p.handle + ' ' + d.key + ')'));
          return { checked: true, why: null, gap: { app: +expect.toFixed(2), store: variant.price } };
        }
        return { checked: true, why: null, gap: null };
      } catch (e) { return 못함('Comparison error — ' + ((e && e.message) || e)); }
    }

    /* ---------------------------------------------------------------- 장바구니 */
    function addToShopifyCart(props, qty, variant, addons) {
      if (!onShopify()) {
        try { console.log('[design-center] (preview) cart', props, variant, addons); } catch (e) {}
        return Promise.resolve(true);
      }
      var items = [{ id: variant.id, quantity: qty || 1, properties: props }];
      addons.forEach(function (a) {
        items.push({ id: a.variantId, quantity: a.quantity || 1, properties: a.properties || {} });
      });
      return req(root() + 'cart/add.js', {
        method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function () { return true; }).catch(function () { return false; });
    }

    // 주문에 못 붙은 업로드 정리 (DC-011): dc-print-upload v2 가 업로드 응답에 준
    // deleteToken(HMAC) 으로 «올린 사람만» 자기 파일을 지울 수 있다. 지우기에
    // 실패한 것만 localStorage 에 남겨 서버측 정리 목록으로 쓴다.
    function markOrphan(designId, why) {
      try {
        var k = 'sbdc_orphan_prints';
        var arr = JSON.parse(localStorage.getItem(k) || '[]');
        arr.push({ designId: designId, why: why, at: new Date().toISOString() });
        localStorage.setItem(k, JSON.stringify(arr.slice(-50)));
      } catch (e) {}
    }
    function cleanup(designId, token, why) {
      if (!token) { markOrphan(designId, why); return Promise.resolve(false); }
      return req(UPLOAD_FN, {
        method: 'POST', headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ action: 'delete', designId: designId, deleteToken: token })
      }, 10000).then(function () { return true; })
        .catch(function () { markOrphan(designId, why + '(delete-failed)'); return false; });
    }

    window.__dcNewDesign = function () {
      try { window.__dcVariantId = null; window.__dcVariantHandle = null; window.__dcSelectedProduct = null; } catch (e) {}
      lastPrints = null;
      try { if (window.__dcResetAddons) window.__dcResetAddons(); } catch (e) {}
      // 「새 디자인」 은 손님이 이미 «새로 만들겠다» 고 고른 것이라 확인을 다시 묻지 않는다 (DC-120)
      try { var api = window.__dcApi; if (api && api.reset) api.reset({ silent: true }); } catch (e) {}
      setTimeout(function () {
        try { if (window.__dcResetStart) window.__dcResetStart(); } catch (e) {}   // 팝업도 첫 방문으로 (DC-127)
        try { if (window.__dcOpenStart) window.__dcOpenStart(); } catch (e) {}
      }, 60);
    };

    /* ---------------------------------------------------------------- 담기 */
    var busy = null;
    window.__dcCartBusy = function () { return !!busy; };          // 두 승인 버튼 공용 잠금 (DC-018)

    /* ── 승인 중 잠금 (A25) ─────────────────────────────────────────────
       busy 는 여태 «승인 단추 두 개» 만 막았다. 그런데 인쇄 파일을 만드는 몇 초
       동안에도 창은 그대로 열려 있고, «계속 편집 · × · 바깥 클릭 · Esc» 로 닫을
       수 있었다. 닫아도 업로드와 담기는 뒤에서 계속 돌아서, 손님은 취소한 줄
       알았는데 잠시 뒤 «장바구니에 담았습니다» 가 떴다.
       또 추가상품(스탠드·레드카펫) 체크는 창 «안» 에 있어서, 그 사이에 바꾸면
       화면에 보이는 것과 실제로 담기는 것이 달라졌다.

       그래서 busy 를 켜고 끄는 자리를 이 함수 하나로 모으고, 여기서
         · body 에 표시를 걸어 닫기 단추들을 흐리게 (CSS)
         · 추가상품 칸을 통째로 잠그고 (inert — 마우스와 키보드 둘 다)
         · «만드는 중» 을 단추 줄에 띄운다
       를 함께 한다. 닫기 자체를 막는 것은 번들 Ru 의 onClose 래퍼가 맡는다. */
    function setBusy(p) {
      busy = p;
      var on = !!p;
      try { document.body.classList.toggle('sbdc-busy', on); } catch (e) {}
      try { if (window.__dcLockAddons) window.__dcLockAddons(on); } catch (e) {}
      showBusy(on);
    }
    function showBusy(on) {
      var old = document.querySelector('.sbdc-cart-busy');
      if (!on) { if (old && old.parentNode) old.parentNode.removeChild(old); return; }
      if (old) return;
      var foot = document.querySelector('.modal-foot');
      if (!foot) return;                                  // 미리보기 등 창이 없을 때
      var bar = document.createElement('div');
      bar.className = 'sbdc-cart-busy';
      bar.setAttribute('role', 'status');
      bar.innerHTML = '<i aria-hidden="true"></i>';
      bar.appendChild(document.createTextNode('Building the print file — please do not close this window'));
      foot.insertBefore(bar, foot.firstChild);
    }

    window.__dcAddToCart = function () {
      if (busy) return busy;
      var api = window.__dcApi, ref = window.__dcExportRef;
      if (!api || !ref) return Promise.resolve(window.__dcCartUnavailable());

      var spec = Object.assign({}, api.spec || {});
      var frontJson = JSON.stringify(window.__sbPack ? window.__sbPack.pack(api.front || null) : (api.front || null));
      var backJson = api.back ? JSON.stringify(window.__sbPack ? window.__sbPack.pack(api.back) : api.back) : null;
      // Preserve editable 09/14 originals: do not reach the legacy JSON-omission branch.
      var layoutLimit = 9 * 1024 * 1024;
      if ((api.front && api.front.layout914 && new Blob([frontJson]).size > layoutLimit) ||
          (api.back && api.back.layout914 && new Blob([backJson]).size > layoutLimit)) {
        return Promise.resolve(showError('Editable artwork is too large',
          'This design exceeds the editable upload limit. Export JSON to preserve your work, then reduce embedded image sizes before approving. No print file has been uploaded.'));
      }
      var hasBack = !!api.back;
      var activeSide = api.activeSide || 'front';
      var designId = 'dsn_' + Date.now().toString(36);
      var qty = (spec.quantity && +spec.quantity) || 1;
      var dpi = window.__dcPrintDpi(spec);
      var prod = applied();

      var finNames = { 'hem-grommets': 'Hem & Grommets', 'hem-only': 'Hem Only', 'grommets-only': 'Grommets Only',
        'none': 'No Hem & No Grommets', 'pockets-both': 'Pole Pockets (Top and Bottom)', 'pockets-top': 'Pole Pockets (Top Only)' };
      var finLabel = finNames[spec.finishing] || '';
      var hasFinishing = window.__dcHasFinishing ? window.__dcHasFinishing() : true;
      var cartMat = matChoice(prod, spec);                    // 손님이 고른 재질 (A19)

      clearError();
      var runToken = null;                              // 첫 업로드가 돌려준 삭제 토큰
      var done = function (v) { setBusy(null); return v; };

      setBusy(Promise.resolve().then(function () {
        // ① 담을 수 있는지 먼저
        // 검사 6번 — 스티커는 공식 가격표의 수량 열로만 승인·담기
        try {
          if (typeof window.__dcQtyOptions === 'function' && window.__dcQtyOptions()
              && window.__dcStkQty && window.__dcStkQty.indexOf(+spec.quantity) < 0) {
            return showError('This quantity cannot be added',
              'Stickers are sold at the official table quantities (' + window.__dcStkQty.join(' · ') + ' pcs). Please pick another quantity.');
          }
        } catch (e) {}
        var addons = [];
        try { addons = (window.__dcAddons ? window.__dcAddons() : []) || []; } catch (e) { note(e); }
        var live = onShopify();
        var badAddon = live ? addons.filter(function (a) { return !a.variantId; }) : [];
        if (badAddon.length) {
          return showError('Could not add the extra products',
            badAddon.map(function (a) { return a._label; }).join(', ')
            + ' — no product info found. Deselect it, or let our team know.');
        }
        return resolveVariant(spec).then(function (variant) {
          if (variant && variant.error === 'missing') {                     // A7 — 기다려도 안 된다
            return showError('This product cannot be added right now',
              (prod ? (prod.nameKo || prod.name) + ' of ' : '') + 'The store has no info for this product. '
              + 'Retrying is not fixing it, so please let our team know. (' + variant.detail + ')');
          }
          if (variant && variant.error === 'busy') {                        // A7 — 기다리면 된다
            return showError('Orders are coming in all at once',
              'Please press 「Approve and add to cart」 again in about 30 seconds. '
              + 'Your design is still here. (' + variant.detail + ')');
          }
          if (variant && variant.error === 'network') {                     // DC-104
            return showError('Could not reach the store',
              'This is a temporary connection problem, not a size problem. Please try again shortly. '
              + 'If it keeps happening, let our team know. (' + variant.detail + ')');
          }
          if (variant && variant.error) return showError('This size cannot be added', variant.detail);
          if (live && !variant) {
            return showError('Product size not found',
              (prod ? (prod.nameKo || prod.name) + ' ' : '') + 'No product info was found for this size, so it cannot be added. '
              + 'Try another size, or let our team know.');
          }
          var pc = priceCheck(prod, spec, variant);
          var priceGap = pc.gap;                                   // 예전과 같은 모양 (A22)
          try { if (window.__dcToast) window.__dcToast('Building the print file…'); } catch (e) {}

          // ② 주문 명세 — 업로드하는 JSON 안에 함께 넣는다 (DC-010)
          var manifest = {
            app: APP_VER, designId: designId, at: new Date().toISOString(),
            product: prod ? { handle: prod.handle, name: prod.name, nameKo: prod.nameKo,
              material: prod.materialEn || prod.material, unit: prod.unit || 'ft' } : null,
            materialPick: cartMat ? { id: cartMat.id, ko: cartMat.ko, en: cartMat.en } : null,   // A19
            variantId: variant ? variant.id : null, variantTitle: variant ? variant.title : null,
            size: { widthIn: spec.widthIn, heightIn: spec.heightIn,
              widthFt: +(spec.widthIn / 12).toFixed(3), heightFt: +(spec.heightIn / 12).toFixed(3) },
            quantity: qty, sides: hasBack ? 'double' : 'single',
            finishing: hasFinishing ? { id: spec.finishing, label: finLabel } : null,
            grommetRule: window.__dcGrommetRule || null,
            requestedDpi: dpi,
            autoRelease: !!(window.__dcApi && window.__dcApi.combined && window.__dcApi.combined.autoRelease),   // 검사 7번 — DPI 게이트 반영값
            colorProfile: (typeof window.__dcIccp === 'function' && window.__dcIccp() && window.__dcIccp().name) || null,   // 검사 11번
            priceMismatch: priceGap,
            priceCheck: { checked: pc.checked, why: pc.why || null },   // A22 — «못 했음» 과 «문제없음» 을 가른다
            addons: addons.map(function (a) {
              return { handle: a.handle, variantId: a.variantId, size: a.properties && a.properties.Size, price: a._price };
            })
          };
          var wrap = function (docJson) {
            return '{"manifest":' + JSON.stringify(manifest) + ',"doc":' + (docJson || 'null') + '}';
          };

          // ③ 인쇄 파일 — 한 번에 한 면씩
          return uploadSide(designId, 'front', dpi, wrap(frontJson))
            .then(function (front) {
              runToken = front.deleteToken || runToken;
              if (!hasBack) return [front, null];
              return uploadSide(designId, 'back', dpi, wrap(backJson)).then(function (back) { return [front, back]; });
            })
            .then(function (res) { return goSide(activeSide).then(function () { return res; }); })
            .then(function (res) {
              // ④ 문서 전체를 글자 단위로 대조 — 레이어 편집까지 걸린다 (DC-006)
              var a2 = window.__dcApi;
              var f2 = JSON.stringify(window.__sbPack ? window.__sbPack.pack(a2 && a2.front || null) : (a2 && a2.front || null));
              var b2 = a2 && a2.back ? JSON.stringify(window.__sbPack ? window.__sbPack.pack(a2.back) : a2.back) : null;
              var s2 = (a2 && a2.spec) || {};
              if (f2 !== frontJson || b2 !== backJson ||
                  s2.widthIn !== spec.widthIn || s2.heightIn !== spec.heightIn ||
                  s2.quantity !== spec.quantity || s2.finishing !== spec.finishing ||
                  s2.material !== spec.material) {                       // 재질도 대조 (DC-118)
                cleanup(designId, runToken, 'design-changed');
                return showError('The design has changed',
                  'The design changed while the print file was being built. Please approve again.');
              }
              var front = res[0], back = res[1];
              lastPrints = { frontJson: frontJson, backJson: backJson, front: front, back: back };  // DC-008

              manifest.print = { dpi: front.dpi, requestedDpi: dpi, capped: front.capped,
                front: { url: front.printUrl, px: front.px, sha256: front.sha256 },
                back: back ? { url: back.printUrl, px: back.px, sha256: back.sha256 } : null };
              window.__dcManifest = manifest;

              var props = { '_design_id': designId, '_designed_in': 'DesignCenter', '_app': APP_VER };
              props['Print File'] = front.printUrl;
              if (front.jsonUrl) props['_design_json'] = front.jsonUrl;
              if (hasBack && back) {
                props['Print File (Back)'] = back.printUrl;
                if (back.jsonUrl) props['_design_json_back'] = back.jsonUrl;
              }
              props['Sides'] = hasBack ? 'Double Sided' : 'Single Sided';
              if (cartMat) props['Material'] = cartMat.ko + ' (' + cartMat.en + ')';   // 손님이 고른 재질 (A19)
              if (variant && variant.title && (variant.source === 'matched' || variant.source === 'injected-verified') && prod) {
                props['Option'] = variant.title;                     // 무엇이 담겼는지 보이게 (DC-016)
              }
              props['_print_dpi'] = String(front.dpi);               // 실제 값 (DC-009)
              if (front.dpi !== dpi) props['_print_dpi_requested'] = String(dpi);
              if (front.px) props['_print_px'] = front.px;
              /* A22 — 지문을 «못 만든» 것과 «애초에 안 만드는 옛 판» 이 주문서에서 똑같이
                 «칸이 없음» 으로 보였다. 못 만들었으면 못 만들었다고 적는다. */
              props['_print_sha256'] = front.sha256 || 'unavailable';
              if (back) props['_print_sha256_back'] = back.sha256 || 'unavailable';
              if (prod) props['_product_handle'] = prod.handle;
              props['_size_in'] = spec.widthIn + 'x' + spec.heightIn;
              if (hasFinishing && finLabel) props['Finishing'] = finLabel;

              window.__dcLastCart = { props: props, quantity: qty, variant: variant, manifest: manifest };

              return addToShopifyCart(props, qty, variant || { id: null }, addons).then(function (ok) {
                if (!ok) {
                  cleanup(designId, runToken, 'cart-add-failed');
                  var last = window.__dcErrors[window.__dcErrors.length - 1];
                  return showError('Could not add to the cart',
                    (last && last.message ? last.message + ' — ' : '') + 'Please try again shortly.');
                }
                return true;
              });
            });
        });
      }).then(done, function (e) {
        note(e);
        cleanup(designId, runToken, 'exception');
        showError('Could not upload the print file',
          (e && e.message ? e.message + ' — ' : '') + 'Nothing was added to the cart. Please try again.');
        return done(false);
      }));

      return busy;
    };
  })();

    


/* ===== sbdc-proof ===== */

/* =====================================================================
   프루프를 «그 상품» 것으로 만든다

   프루프 창은 배너 하나만 팔던 시절 그대로였다. 스티커에도 피트 환산과
   시청 거리가 뜨고, 파일 이름은 무엇을 담든 banner_0x0ft 였다.

   여기서 채우는 것 (번들에 뚫어 둔 구멍들)
     __dcFileBase       내려받는 파일 이름
     __dcProofSize      규격을 상품 단위(인치/피트)로
     __dcProofProduct   프루프 맨 앞의 «상품» 줄
     __dcProofShowView  «시청 거리» 줄을 보일지 (스티커엔 뜻 없음)
   그리고 검사 결과에 두 가지를 더한다 — 양면인데 뒷면이 없음 · 키스컷 재단 경로.
   ===================================================================== */
(function () {
  'use strict';

  var STICKERS = ['bumper-stickers', 'kiss-cut-stickers', 'round-stickers', 'oval-stickers'];

  function AP() {
    return (typeof window.__dcAppliedProduct === 'function' && window.__dcAppliedProduct()) || null;
  }
  function isSticker(p) { return !!p && STICKERS.indexOf(p.handle) >= 0; }
  function inchProduct(p) { return !!p && p.unit === 'in'; }

  // 31.5 는 31.5 로, 8 은 8 로 — 억지로 소수점을 붙이거나 반올림하지 않는다
  function num(n) { return String(Math.round(n * 100) / 100); }

  /* ---------------------------------------------------------------- 파일 이름
     예)  round-stickers_3x3in_front_print.png
          pop-up-retractable-banner-with-stand_31.5x80in_back_print.png
          custom-vinyl-banners_8x4ft_front_print.png                        */
  function fileKey(p) {
    if (!p) return 'design';
    if (!p.key) return p.handle;
    return /stand$/.test(p.key) ? p.handle + '-with-stand' : p.handle + '-' + p.key;
  }
  window.__dcFileBase = function (side) {
    var api = window.__dcApi, p = AP();
    if (!api || !api.spec || !p) return null;
    var inch = inchProduct(p);
    var w = inch ? api.spec.widthIn : api.spec.widthIn / 12;
    var h = inch ? api.spec.heightIn : api.spec.heightIn / 12;
    return fileKey(p) + '_' + num(w) + 'x' + num(h) + (inch ? 'in' : 'ft')
      + '_' + (side === 'back' ? 'back' : 'front') + '_print';
  };

  /* ---------------------------------------------------------------- 프루프 표기 */
  window.__dcProofSize = function (spec) {
    var p = AP();
    if (!spec) return null;
    if (inchProduct(p)) return num(spec.widthIn) + '″ × ' + num(spec.heightIn) + '″';
    return num(spec.widthIn / 12) + '′ × ' + num(spec.heightIn / 12) + '′ ('
      + num(spec.widthIn) + '″ × ' + num(spec.heightIn) + '″)';
  };
  window.__dcProofProduct = function () {
    var P = window.__dcProduct;
    var nm = (P && (P.nameKo || P.name)) || '';
    // 재질을 고르는 상품이면 무엇으로 담기는지 승인 창에서 보이게 한다 (A19)
    var mt = null;
    try { mt = window.__dcMaterialLabel ? window.__dcMaterialLabel() : null; } catch (e) {}
    return mt ? nm + ' · ' + mt : nm;
  };
  // 시청 거리는 «멀리서 읽는» 물건에만 뜻이 있다 — 손에 드는 스티커엔 없다
  window.__dcProofShowView = function () { return !isSticker(AP()); };

  /* ---------------------------------------------------------------- 검사 항목 두 가지 */
  var prevIssues = window.__dcClipIssues;
  window.__dcClipIssues = function (layers, issues) {
    if (typeof prevIssues === 'function') { try { prevIssues(layers, issues); } catch (e) {} }
    try {
      var api = window.__dcApi, P = window.__dcProduct, p = AP();
      if (!api || !Array.isArray(issues)) return;

      /* ① 양면 상품인데 뒷면이 없다 — 뒷면이 백지로 인쇄되어 나간다.
         api.back 을 보면 안 된다. window.__dcApi 는 «한 판 전» 이라,
         뒷면을 막 만든 판에서는 아직 null 이고, 검사 결과는 기억(memo)되어
         다시 계산되지 않으므로 경고가 영영 안 사라진다.
         그래서 검사 직전에 본체가 넣어 주는 __dcHasBackNow 를 본다. */
      var backNow = window.__dcHasBackNow === undefined ? !!api.back : !!window.__dcHasBackNow;
      if (P && P.doubleSidedOffered && !backNow) {
        issues.push({
          id: 'needs-back', severity: 'block',
          title: 'This is a double-sided product but the back is empty',
          detail: (P.nameKo || P.name) + ' prints on both the front and the back. '
            + 'Approving now prints the back blank.',
          fix: 'Click 「Add back」 on the right to create the back.'
        });
      }

      // ② 키스컷은 «고객이 준 재단 경로» 로 잘라야 한다 — 지금 선은 예시일 뿐
      if (p && p.handle === 'kiss-cut-stickers') {
        issues.push({
          id: 'kiss-cut-path', severity: 'warn',
          title: 'The cut line is an example — we need the real cut path',
          detail: 'Custom shape stickers are cut to shape. The rounded rectangle on screen '
            + 'It shows the position only and is not the real cut line.',
          fix: 'Send us the cut path you want, or talk to us to settle the shape.'
        });
      }
    } catch (e) { /* 검사가 앱을 멈추게 하지는 않는다 */ }
  };
})();
    

/* ===== sbdc-addons ===== */


  /* ================================================================
     프루프 화면 애드온 — 배너 스탠드 · 레드카펫
     상품마다 «권할 수 있는 것» 이 다르다 (아래 ADDON_MAP).
     스티커·접착 배너에는 아무것도 안 뜨고, 스탠드가 이미 들어 있는 상품에는
     스탠드를 또 권하지 않는다. 스탠드는 지금 배너 크기에 맞는 것만 보여 준다.
     가격/변형은 Shopify 상품가 그대로(라이브에선 /products/<handle>.js
     로 실시간 확인, 미리보기에선 아래 내장 표로 표시).
     선택 결과는 window.__dcAddons() 로 카트 모듈이 읽어 별도
     라인아이템으로 담는다.
     ================================================================ */
  (function () {
    'use strict';

    // Shopify 실측(2026-08-23). variantId 는 라이브에서 handle.js 로 갱신됨.
    var ADDONS = [
      {
        key: 'banner-stand', handle: 'banner-stand', label: 'Banner stand',
        desc: 'A stand that holds the banner upright',
        sizes: [
          { label: "8'×8' telescopic", price: 125 },
          { label: "10'×8' telescopic", price: 149 },
          { label: "12'×8' aluminum", price: 249 },
          { label: "16'×8' aluminum", price: 299 },
          { label: "20'×8' aluminum", price: 349 }
        ]
      },
      {
        key: 'red-carpet', handle: 'red-carpet', label: 'Red carpet',
        desc: 'Event red carpet runner',
        sizes: [
          { label: "3'×8'", price: 72 },
          { label: "3'×10'", price: 90 },
          { label: "4'×12'", price: 150 },
          { label: "4'×16'", price: 180 },
          { label: "4'×20'", price: 210 }
        ]
      }
    ];

    /* 상품(handle) 마다 권할 추가 상품. 목록에 없는 상품은 «아무것도 안 권함» 이다.
       - 스티커 4종 · 접착 배너/윈도우 데칼 : 세울 물건이 아니다
       - 리트랙터블 · X-배너 : 스탠드가 상품 안에 있거나 규격이 안 맞는다 (31.5″×80″ 에 8′ 스탠드) */
    var ADDON_MAP = {
      'custom-vinyl-banners':          ['banner-stand', 'red-carpet'],
      'mesh-banners':                  ['banner-stand', 'red-carpet'],
      'fabric-banners':                ['banner-stand', 'red-carpet'],
      'custom-step-and-repeat-banner': ['banner-stand', 'red-carpet'],
      'fabric-step-repeat-banners':    ['banner-stand', 'red-carpet'],
      'vinyl-step-and-repeat-banner':  ['banner-stand', 'red-carpet'],
      'fabric-step-and-repeat-banner': ['banner-stand', 'red-carpet'],
      '10x8-fabric-pop-up-display-backdrop-banner-only': ['banner-stand', 'red-carpet'],
      'pop-up-retractable-banner':     ['red-carpet'],
      'x-banner':                      ['red-carpet'],
      'double-sided-x-banner':         ['red-carpet'],
      'window-decals':                 [],
      'bumper-stickers':               [],
      'kiss-cut-stickers':             [],
      'round-stickers':                [],
      'oval-stickers':                 []
    };

    function applied() {
      return (typeof window.__dcAppliedProduct === 'function' && window.__dcAppliedProduct()) || null;
    }
    function allowedKeys() {
      var p = applied();
      if (!p) return [];
      return Object.prototype.hasOwnProperty.call(ADDON_MAP, p.handle) ? ADDON_MAP[p.handle] : [];
    }
    // 스탠드는 «이 배너를 걸 수 있는» 크기여야 한다 — 8'×8' 스탠드에 20' 배너는 안 걸린다
    function sizeFits(a, sz) {
      if (a.key !== 'banner-stand') return true;
      var api = window.__dcApi, p = applied();
      if (!api || !api.spec || !p) return true;
      var m = /^(\d+)'×(\d+)'/.exec(sz.label);
      if (!m) return true;
      var wFt = p.unit === 'in' ? api.spec.widthIn / 12 : api.spec.widthIn / 12;
      var hFt = p.unit === 'in' ? api.spec.heightIn / 12 : api.spec.heightIn / 12;
      return wFt <= (+m[1]) + 0.01 && hFt <= (+m[2]) + 0.01;
    }
    // 지금 상품에 보여 줄 것 — [{ a: 추가상품, sizes: [{i, sz}] }]
    function visible() {
      var ok = allowedKeys(), out = [];
      ADDONS.forEach(function (a) {
        if (ok.indexOf(a.key) < 0) return;
        var sizes = [];
        a.sizes.forEach(function (sz, i) { if (sizeFits(a, sz)) sizes.push({ i: i, sz: sz }); });
        if (sizes.length) out.push({ a: a, sizes: sizes });
      });
      return out;
    }
    // 안 보이는 것은 골라 둔 것도 푼다 — 상품을 바꿨을 때 스티커 주문에 스탠드가 따라붙지 않게
    function prune() {
      var live = {};
      visible().forEach(function (v) {
        live[v.a.key] = v.sizes.map(function (x) { return x.i; });
      });
      ADDONS.forEach(function (a) {
        var st = state[a.key];
        if (!st) return;
        if (!live[a.key]) { st.on = false; return; }
        if (live[a.key].indexOf(st.sizeIdx) < 0) st.sizeIdx = live[a.key][0];
      });
    }

    // 선택 상태: { 'banner-stand': {on, sizeIdx}, 'red-carpet': {...} }
    var state = {};
    ADDONS.forEach(function (a) { state[a.key] = { on: false, sizeIdx: 0 }; });

    var money = function (n) {
      try { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
      catch (e) { return '$' + n; }
    };

    /* 라이브면 각 상품의 변형 가격/ID 를 실시간으로 덮어쓴다.

       예전 매칭은 «라벨에서 ×·' 만 지우고 앞 4글자» 였다 — "8'×8' 텔레스코픽" 은
       "8x8텔" 이 되어 스토어의 "8'x8' Telescopic Adjustable Stand" 와 절대 안 맞았다.
       화면에는 체크되는데 variantId 가 없어 장바구니에서 조용히 빠졌다 (DC-07).
       지금은 «치수 숫자쌍» 으로 맞추고, 안 되면 가격, 그것도 안 되면 순서로 맞춘다.
       스토어의 변형 이름이 어떻게 바뀌어도 규격만 같으면 붙는다. */
    function dims(v) { return (String(v == null ? '' : v).match(/\d+(?:\.\d+)?/g) || []).map(Number); }
    function samePair(x, y) {
      if (x.length < 2 || y.length < 2) return false;
      return (Math.abs(x[0] - y[0]) < .051 && Math.abs(x[1] - y[1]) < .051) ||
             (Math.abs(x[0] - y[1]) < .051 && Math.abs(x[1] - y[0]) < .051);
    }
    function shopRoot() {
      try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
      catch (e) { return '/'; }
    }
    function onStore() {
      var loc = window.location || {};
      if (!/^https?:$/.test(loc.protocol || '')) return false;    // file:// 미리보기에선 요청하지 않는다
      return /myshopify\.com$/.test(loc.hostname || '') ||
        !!(window.Shopify && window.Shopify.shop) ||
        !!document.querySelector('form[action*="/cart/add"]');
    }
    ADDONS.forEach(function (a) {
      if (!onStore()) return;                                     // 미리보기에선 내장 표를 그대로 쓴다
      try {
        var ctl = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var t = setTimeout(function () { try { ctl && ctl.abort(); } catch (e) {} }, 15000);
        fetch(shopRoot() + 'products/' + a.handle + '.js', ctl ? { signal: ctl.signal } : {})
          .then(function (r) {
            clearTimeout(t);
            if (!r.ok) throw new Error('HTTP ' + r.status + ' /products/' + a.handle + '.js');
            return r.json();
          })
          .then(function (p) {
            if (!p || !p.variants) return;
            var used = {};
            a.sizes.forEach(function (sz, idx) {
              var want = dims(sz.label), v = null;
              p.variants.forEach(function (x) {                       // ① 치수쌍
                if (!v && !used[x.id] && samePair(dims(x.title), want)) v = x;
              });
              if (!v) p.variants.forEach(function (x) {               // ② 가격
                if (!v && !used[x.id] && Math.abs(x.price / 100 - sz.price) < .005) v = x;
              });
              if (!v && p.variants.length === a.sizes.length) v = p.variants[idx];   // ③ 순서
              if (v && v.available !== false) {
                used[v.id] = 1; sz.price = v.price / 100; sz.variantId = v.id; sz.variantTitle = v.title;
              } else {
                sz.variantId = null; sz.unavailable = true;
                if (v) sz.soldout = true;                          // 품절 (DC-003)
              }
            });
            rerender();
          })
          .catch(function (e) {
            clearTimeout(t);
            /* A13 — 조회가 통째로 실패했을 때가 제일 나빴다. 여기서 아무것도 안 해 두면
               화면에는 내장 가격표가 «완전히 정상인 것처럼» 그대로 남는다. 손님은
               「배너 스탠드 $125.00」 을 체크하고, 승인을 누른 뒤에야 막힌다.
               (실측: 조회 실패 → 딱지 0개 · 체크됨 · variantId 없음)
               품절·규격 불일치는 아래 성공 경로가 이미 딱지를 붙이므로, 여기서는
               «상품 정보를 못 받았다» 는 것만 표시하고 고르지 못하게 한다. */
            a.sizes.forEach(function (sz) { sz.variantId = null; sz.unavailable = true; sz.lookupFailed = true; });
            try { rerender(); } catch (x) {}
            try {
              (window.__dcErrors = window.__dcErrors || []).push({
                at: new Date().toISOString(), message: String(e && e.message || e), url: '/products/' + a.handle + '.js' });
              if (window.console) console.error('[design-center] addon lookup', e);
            } catch (x) {}
          });
      } catch (e) {}
    });

    // window.__dcAddons() → 선택된 애드온을 카트 라인아이템 배열로
    window.__dcAddons = function () {
      var out = [];
      prune();                                   // 지금 상품에 안 맞는 선택은 먼저 푼다
      var ok = allowedKeys();
      ADDONS.forEach(function (a) {
        var st = state[a.key];
        if (!st.on || ok.indexOf(a.key) < 0) return;
        var sz = a.sizes[st.sizeIdx];
        out.push({
          handle: a.handle, variantId: sz.variantId || null,
          quantity: 1,
          properties: { '_addon_for': 'DesignCenter', 'Size': sz.label.replace(/×/g, ' x ') },
          _label: a.label + ' · ' + sz.label, _price: sz.price
        });
      });
      return out;
    };
    window.__dcAddonsTotal = function () {
      return window.__dcAddons().reduce(function (s, x) { return s + (x._price || 0); }, 0);
    };
    /* 승인 중에는 고르지 못하게 (A25).
       inert 하나면 마우스와 키보드(Tab·Space)가 함께 막힌다 — 칸마다 disabled 를
       걸고 되돌리는 것보다 짧고, 되돌릴 때 «원래부터 잠겨 있던 칸» 을 실수로
       풀어 줄 일도 없다. 흐리게 보이는 것은 CSS 가 맡는다. */
    window.__dcLockAddons = function (on) {
      var el = document.querySelector('.sbdc-addons');
      if (el) el.inert = !!on;
    };

    // 새 디자인 시작 시 애드온 선택 초기화
    window.__dcResetAddons = function () {
      ADDONS.forEach(function (a) { state[a.key] = { on: false, sizeIdx: 0 }; });
      var old = document.querySelector('.sbdc-addons');
      if (old && old.parentNode) old.parentNode.removeChild(old);
    };

    /* ---------- UI: 프루프 모달 열릴 때 주입 ---------- */
    var $ = function (t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; };

    function buildSection() {
      prune();
      var wrap = $('section', 'sbdc-addons');
      wrap.appendChild($('h3', '', 'Add together'));
      var hint = $('p', 'sbdc-addons-hint', 'You can add a stand or red carpet too. Pick the size yourself.');
      wrap.appendChild(hint);
      /* A13 — «담기지 못할 것은 고르지도 못하게».
         스토어 안에서만 판단한다. 미리보기(file:// · 로컬)에서는 조회를 아예 하지
         않으므로 variantId 가 언제나 비어 있다 — 여기서 그것까지 막으면 사장님·팀원이
         내장 가격표조차 못 고르게 된다. 담기 직전 검사(sbdc-cart)도 같은 기준을 쓴다. */
      var live = onStore();
      var 못담음 = function (sz) { return live && !sz.variantId; };
      var 딱지 = function (sz) {
        if (sz.lookupFailed) return ' (could not get product info)';
        if (sz.soldout) return ' (sold out)';
        if (sz.unavailable) return ' (no stock info)';
        return '';
      };
      visible().forEach(function (v) {
        var a = v.a;
        var 고를수있는것 = v.sizes.filter(function (x) { return !못담음(x.sz); });
        var 전부막힘 = live && !고를수있는것.length;
        var row = $('div', 'sbdc-addon');
        row.dataset.key = a.key;
        if (전부막힘) row.classList.add('is-blocked');
        var head = $('label', 'sbdc-addon-head');
        var cb = document.createElement('input'); cb.type = 'checkbox';
        // 전부 못 담는 상품은 체크 자체가 안 되게 하고, 이미 켜져 있었다면 끈다
        if (전부막힘) { state[a.key].on = false; cb.disabled = true; }
        cb.checked = state[a.key].on;
        cb.onchange = function () { state[a.key].on = cb.checked; row.classList.toggle('is-on', cb.checked); updateTotal(); };
        head.appendChild(cb);
        var txt = $('div', 'sbdc-addon-txt');
        txt.appendChild($('b', '', a.label));
        txt.appendChild($('em', '', 전부막힘
          ? 'Cannot be added right now — please let our team know'
          : a.desc));
        head.appendChild(txt);
        row.appendChild(head);

        var pick = $('div', 'sbdc-addon-pick');
        var sel = document.createElement('select');
        if (전부막힘) sel.disabled = true;
        v.sizes.forEach(function (x) {              // 이 배너에 맞는 규격만
          var o = document.createElement('option'); o.value = x.i;
          o.textContent = x.sz.label + ' — ' + money(x.sz.price) + 딱지(x.sz);
          if (못담음(x.sz)) o.disabled = true;       // 품절·조회실패는 고를 수 없다
          sel.appendChild(o);
        });
        /* 골라 둔 규격이 그새 품절됐을 수 있다 — 고를 수 있는 첫 규격으로 옮긴다.
           안 옮기면 select 가 «막힌 항목» 을 그대로 보여 준 채 담기만 조용히 실패한다. */
        if (고를수있는것.length && 못담음(a.sizes[state[a.key].sizeIdx] || {})) {
          state[a.key].sizeIdx = 고를수있는것[0].i;
        }
        sel.value = state[a.key].sizeIdx;
        sel.onchange = function () { state[a.key].sizeIdx = +sel.value; updateTotal(); };
        pick.appendChild(sel);
        row.appendChild(pick);
        row.classList.toggle('is-on', state[a.key].on);
        wrap.appendChild(row);
      });
      var tot = $('div', 'sbdc-addons-total');
      /* 검사 10번 — 본 상품과 추가상품을 «합한» 최종 결제 예정 금액을 승인 전에 보여 준다.
         추가상품을 켜고 끄거나 사이즈를 바꾸면 updateTotal 이 즉시 다시 계산한다. */
      tot.innerHTML =
        '<div class="sbdc-tl"><span>Product subtotal</span><b class="sbdc-t-main"></b></div>' +
        '<div class="sbdc-tl"><span>Add-ons</span><b class="sbdc-t-add"></b></div>' +
        '<div class="sbdc-tl sbdc-t-grand"><span>Order total</span><b class="sbdc-t-sum"></b></div>';
      wrap.appendChild(tot);
      // 합계는 언제나 state 에서 다시 센다.
      // 여기에 0 을 박아 두면, 프루프를 닫았다 다시 열 때 섹션이 새로 만들어지면서
      // 고른 애드온은 그대로인데 합계만 $0.00 으로 보인다.
      updateTotal(wrap);
      // 승인 중에 섹션이 새로 그려져도 잠금은 유지된다
      if (window.__dcCartBusy && window.__dcCartBusy()) wrap.inert = true;
      return wrap;
    }

    // root 를 주면 그 안에서만 찾는다. 다시 그릴 때(rerender)는 옛 섹션이
    // 아직 문서에 남아 있어서, 범위를 안 주면 버려질 쪽 숫자를 고치게 된다.
    function updateTotal(root) {
      var r = root || document;
      var mt = 0;
      try { var a = window.__dcApi; mt = (a && a.price && +a.price.total) || 0; } catch (e) {}
      var at = window.__dcAddonsTotal();
      var em = r.querySelector('.sbdc-t-main'), ea = r.querySelector('.sbdc-t-add'), es = r.querySelector('.sbdc-t-sum');
      if (em) em.textContent = money(mt);
      if (ea) ea.textContent = (at > 0 ? '+ ' : '') + money(at);
      if (es) es.textContent = money(mt + at);
    }
    function rerender() {
      var old = document.querySelector('.sbdc-addons');
      if (old && old.parentNode) { var n = buildSection(); old.parentNode.replaceChild(n, old); }
    }

    // 프루프 모달(.modal-body)이 뜨면 검사결과 섹션 뒤에 주입, 없으면 끝에
    function tryInject() {
      var body = document.querySelector('.modal-body');
      if (!body) return;
      if (body.querySelector('.sbdc-addons')) return;
      // 프루프 모달인지 대충 확인 (proof-stage/proof-sides 존재)
      if (!body.querySelector('.proof-stage') && !body.querySelector('.proof-sides')) return;
      if (!visible().length) return;              // 이 상품엔 권할 게 없다 — 칸도 안 만든다
      var sec = buildSection();
      var issues = body.querySelector('.proof-issues');
      if (issues && issues.nextSibling) body.insertBefore(sec, issues.nextSibling);
      else if (issues) body.appendChild(sec);
      else body.appendChild(sec);
    }
     /* 예전에는 500ms 마다 영원히 돌았다 (DC-13). 지금은 DOM 변화를 보고,
       변화가 없으면 아무 일도 하지 않는다. MutationObserver 가 없는 환경만
       느린 타이머로 물러선다.

       v0.8 — 여기에 «120ms 늦추기» 가 있었다. 그래서 승인 창이 화면에 뜬
       «뒤에» 이 칸이 끼어들어 창 안 내용이 346px 아래로 밀렸다 (덜컹).
       MutationObserver 는 변경 하나하나가 아니라 한 묶음마다 한 번만 불리므로,
       늦추지 않아도 드는 값은 querySelector 한 번이다 (실측 30회 0.2ms).
       바로 넣으면 브라우저가 창을 «그리기 전» 에 자리가 잡혀 밀림이 사라진다.
       visible() 은 이미 받아 둔 표만 보므로 기다릴 이유도 없다. */
    if (typeof MutationObserver === 'function') {
      var obs = new MutationObserver(function () { try { tryInject(); } catch (e) {} });
      obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
      window.addEventListener('pagehide', function () {          // 수명 정리 (DC-024)
        try { obs.disconnect(); } catch (e) {}
      });

      tryInject();
    } else {
      var iv = setInterval(tryInject, 1000);
      window.addEventListener('pagehide', function () { clearInterval(iv); });
    }
  })();